import { createTerraIcon } from '../../create-terra-icon';

const FaceIdIconData = [
  ['path', { d: "M17.5 17L17.2978 16.1511C17.1307 15.4497 16.5989 14.8925 15.9061 14.6929L13.5 13.9994L13.4997 12.5318C14.3964 11.9266 14.9997 10.7955 14.9997 9.5C14.9997 7.567 13.6565 6 11.9997 6C10.3428 6 8.99966 7.567 8.99966 9.5C8.99966 10.7955 9.60296 11.9266 10.4997 12.5318L10.5 13.9994L8.10885 14.6994C7.43747 14.896 6.91757 15.429 6.73787 16.1051L6.5 17", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M15 2.5H19.5C20.6046 2.5 21.5 3.39543 21.5 4.5V9M9 2.5H4.5C3.39543 2.5 2.5 3.39543 2.5 4.5V9M9 21.5H4.5C3.39543 21.5 2.5 20.6046 2.5 19.5V15M15 21.5H19.5C20.6046 21.5 21.5 20.6046 21.5 19.5V15", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const FaceIdIcon = /* @__PURE__ */ createTerraIcon({
  icon: FaceIdIconData,
  displayName: 'FaceIdIcon',
});

const Facebook01IconData = [
  ['path', { d: "M19.5 2.5C20.6046 2.5 21.5 3.39543 21.5 4.5V19.5C21.5 20.6046 20.6046 21.5 19.5 21.5H4.5C3.39543 21.5 2.5 20.6046 2.5 19.5V4.5C2.5 3.39543 3.39543 2.5 4.5 2.5H19.5Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M17.0001 7.5H14.0006C12.8931 7.5 11.9965 8.39996 12.0006 9.50742L12.0154 13.4995M12.0154 13.4995V21.5M12.0154 13.4995H10.0001M12.0154 13.4995H15", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const Facebook01Icon = /* @__PURE__ */ createTerraIcon({
  icon: Facebook01IconData,
  displayName: 'Facebook01Icon',
});

const Facebook02IconData = [
  ['path', { d: "M13 13.5H17L18 9.5H13V7.5C13 6.47 13 5.5 15 5.5H18V2C18 2 14.943 2 13.643 2C10.928 2 9 3.657 9 6.7V9.5H5V13.5H9V22H13V13.5Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "0" }],
] as const;

export const Facebook02Icon = /* @__PURE__ */ createTerraIcon({
  icon: Facebook02IconData,
  displayName: 'Facebook02Icon',
});

const Factory01IconData = [
  ['path', { d: "M2 21H21", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M3 21C4.5 18 5.5 14 5.5 8H12.5C12.5 14 13.5 18 15 21", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M20 21C18 19 16.5 16 16.5 12H13", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M12 4.26495C13.1704 2.62795 14.6678 2.62795 15.8382 4.26495C16.5439 5.26947 17.4561 5.23227 18.179 4.22775C19.3322 2.59075 20.8296 2.59075 22 4.22775", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "3" }],
] as const;

export const Factory01Icon = /* @__PURE__ */ createTerraIcon({
  icon: Factory01IconData,
  displayName: 'Factory01Icon',
});

const Factory02IconData = [
  ['path', { d: "M9 10.989L15.5 7V11L22 7V19.9641C22 20.5153 21.554 20.9626 21.0028 20.9641L8 21", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M4.06137 6.05038H8.06137", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M11.9919 15.0172H13.9936", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M16.9958 15.0172H18.9975", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "3" }],
  ['path', { d: "M3.83355 3.88963L2.00641 19.8894C1.93876 20.4819 2.41526 21 3.02776 21H10L8.12877 3.88739C8.06986 3.3819 7.63042 3 7.10768 3H4.8549C4.33128 3 3.89139 3.38316 3.83355 3.88963Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "4" }],
] as const;

export const Factory02Icon = /* @__PURE__ */ createTerraIcon({
  icon: Factory02IconData,
  displayName: 'Factory02Icon',
});

const FactoryIconData = [
  ['path', { d: "M3 10H9.00293", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M13.0034 2H8C6.89543 2 6 2.89543 6 4", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M16 2H17", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M11.0039 5H17.0068", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "3" }],
  ['path', { d: "M8.97685 13.5222L15.0555 11.0594V13.5463L20.9885 11.0594L20.999 20.9987C20.9995 21.5515 20.5515 21.9999 19.9987 21.9998L8.97685 21.9972M8.97685 13.5222V21.9972M8.97685 13.5222V8.00192C8.97685 7.44889 8.52796 7.00086 7.97493 7.00192L3.99808 7.00956C3.44655 7.01062 3 7.45802 3 8.00956V20.9995C3 21.552 3.448 21.9998 4.00047 21.9995L8.97685 21.9972", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "4" }],
] as const;

export const FactoryIcon = /* @__PURE__ */ createTerraIcon({
  icon: FactoryIconData,
  displayName: 'FactoryIcon',
});

const FahrenheitIconData = [
  ['circle', { cx: 5, cy: 6, r: 2, stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M21 4H12V20", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M12 12H19", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const FahrenheitIcon = /* @__PURE__ */ createTerraIcon({
  icon: FahrenheitIconData,
  displayName: 'FahrenheitIcon',
});

const FallingStarIconData = [
  ['path', { d: "M22 2L14 10M16 2L11 7M20 10L17 13", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", key: "0" }],
  ['path', { d: "M4 22L8 20.5L12 22L11.5 18L14 15L10.5 14L8 10.5L5.5 14L2 15L4.5 18L4 22Z", stroke: "currentColor", strokeWidth: 1.55, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const FallingStarIcon = /* @__PURE__ */ createTerraIcon({
  icon: FallingStarIconData,
  displayName: 'FallingStarIcon',
});

const Fan01IconData = [
  ['path', { d: "M14.4042 12.4996C14.4042 13.8803 13.2849 14.9996 11.9042 14.9996C10.5235 14.9996 9.40417 13.8803 9.40417 12.4996C9.40417 11.1189 10.5235 9.99963 11.9042 9.99963C13.2849 9.99963 14.4042 11.1189 14.4042 12.4996Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M9.41387 12.2807C7.60979 12.0641 5.12121 12.1016 2.97618 13.34C2.97618 13.34 1.74413 15.2061 3.24413 17.8041C5.24413 21.2682 8.8422 21.5003 8.8422 21.5003C8.2742 19.9841 8.35704 16.6196 10.1773 14.3071C9.70105 13.8519 9.40442 13.2104 9.40442 12.4996C9.40442 12.4259 9.40761 12.3529 9.41387 12.2807Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M14.2811 13.2772C14.0271 14.0542 13.4026 14.6636 12.6165 14.8968C13.3292 16.5704 14.6076 18.7192 16.7613 19.9626C16.7613 19.9626 18.9934 20.0966 20.4934 17.4985C22.4934 14.0344 20.8953 10.8024 20.8953 10.8024C19.8996 12.0119 17.1004 13.559 14.2811 13.2772Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M11.3832 10.054C11.5513 10.0184 11.7257 9.99963 11.9044 9.99963C12.547 9.99963 13.133 10.2421 13.5759 10.6405C14.6724 9.18644 15.9044 6.99704 15.9044 4.49963C15.9044 4.49963 14.9044 2.49963 11.9044 2.49963C7.90442 2.49963 5.90442 5.49963 5.90442 5.49963C7.46247 5.75931 10.2343 7.43504 11.3832 10.054Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "3" }],
] as const;

export const Fan01Icon = /* @__PURE__ */ createTerraIcon({
  icon: Fan01IconData,
  displayName: 'Fan01Icon',
});

const Fan02IconData = [
  ['path', { d: "M9.5786 12.6244C8.04086 13.4772 7 15.117 7 17C7 19.7614 9.23858 22 12 22V14.5C10.8349 14.5 9.85592 13.703 9.5786 12.6244Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M12.6244 14.4214C13.703 14.1441 14.5 13.1651 14.5 12H22C22 14.7614 19.7614 17 17 17C15.117 17 13.4772 15.9591 12.6244 14.4214Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M2 12C2 9.23858 4.23858 7 7 7C8.88297 7 10.5228 8.04086 11.3756 9.5786C10.297 9.85592 9.5 10.8349 9.5 12H2Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M12 9.5V2C14.7614 2 17 4.23858 17 7C17 8.88297 15.9591 10.5228 14.4214 11.3756C14.1441 10.297 13.1651 9.5 12 9.5Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "3" }],
  ['path', { d: "M14.5 12C14.5 13.3807 13.3807 14.5 12 14.5C10.6193 14.5 9.5 13.3807 9.5 12C9.5 10.6193 10.6193 9.5 12 9.5C13.3807 9.5 14.5 10.6193 14.5 12Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "4" }],
] as const;

export const Fan02Icon = /* @__PURE__ */ createTerraIcon({
  icon: Fan02IconData,
  displayName: 'Fan02Icon',
});

const FastWindIconData = [
  ['path', { d: "M2 5.94145C5.5 9.37313 10.5755 7.90241 11.7324 5.94145C11.9026 5.65301 12 5.31814 12 4.96096C12 3.87795 11.1046 3 10 3C8.89543 3 8 3.87795 8 4.96096", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M17 8.92814C17 7.31097 18.1193 6 19.5 6C20.8807 6 22 7.31097 22 8.92814C22 9.6452 21.7799 10.3021 21.4146 10.8111C19.3463 14.1915 9.2764 12.9164 4 11.8563", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M13.0854 19.8873C13.2913 20.5356 13.8469 21 14.5 21C15.3284 21 16 20.2528 16 19.331C16 19.0176 15.9224 18.7244 15.7873 18.4738C14.4999 15.9925 7.99996 14.3239 2 18.7746", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M19 15.5H21", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "3" }],
] as const;

export const FastWindIcon = /* @__PURE__ */ createTerraIcon({
  icon: FastWindIconData,
  displayName: 'FastWindIcon',
});

const FavouriteCircleIconData = [
  ['path', { d: "M22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M12 17C12 17 7 13.8235 7 10.75C7 9.23122 8.05263 8 9.5 8C10.25 8 11 8.26471 12 9.32353C13 8.26471 13.75 8 14.5 8C15.9474 8 17 9.23122 17 10.75C17 13.8235 12 17 12 17Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "1" }],
] as const;

export const FavouriteCircleIcon = /* @__PURE__ */ createTerraIcon({
  icon: FavouriteCircleIconData,
  displayName: 'FavouriteCircleIcon',
});

const FavouriteSquareIconData = [
  ['path', { d: "M12 16.5C12 16.5 7 13.3235 7 10.25C7 8.73122 8.05263 7.5 9.5 7.5C10.25 7.5 11 7.76471 12 8.82353C13 7.76471 13.75 7.5 14.5 7.5C15.9474 7.5 17 8.73122 17 10.25C17 13.3235 12 16.5 12 16.5Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M20.9995 5V19C20.9995 20.1046 20.1041 21 18.9995 21H4.99951C3.89494 21 2.99951 20.1046 2.99951 19V5C2.99951 3.89543 3.89494 3 4.99951 3H18.9995C20.1041 3 20.9995 3.89543 20.9995 5Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "1" }],
] as const;

export const FavouriteSquareIcon = /* @__PURE__ */ createTerraIcon({
  icon: FavouriteSquareIconData,
  displayName: 'FavouriteSquareIcon',
});

const FavouriteIconData = [
  ['path', { d: "M12 20.5C12 20.5 2 14.5 2 8.69444C2 5.82563 4.10526 3.5 7 3.5C8.5 3.5 10 4 12 6C14 4 15.5 3.5 17 3.5C19.8947 3.5 22 5.82563 22 8.69444C22 14.5 12 20.5 12 20.5Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "0" }],
] as const;

export const FavouriteIcon = /* @__PURE__ */ createTerraIcon({
  icon: FavouriteIconData,
  displayName: 'FavouriteIcon',
});

const FeatherIconData = [
  ['path', { d: "M7.89462 10.1187C7.32227 10.6825 7 11.4524 7 12.2558V17H11.7442C12.5476 17 13.3175 16.6777 13.8813 16.1054L19.7785 10.1192C21.4072 8.4906 21.4072 5.85006 19.7785 4.22144C18.1499 2.59285 15.5094 2.59285 13.8808 4.22145L7.89462 10.1187Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M3 21L15 9", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M12 12H14.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const FeatherIcon = /* @__PURE__ */ createTerraIcon({
  icon: FeatherIconData,
  displayName: 'FeatherIcon',
});

const Female02IconData = [
  ['path', { d: "M14.5001 16.5L18.9853 17.6213C19.8756 17.8439 20.5002 18.6438 20.5002 19.5616V21.5H3.50024L3.55348 19.5125C3.57745 18.6177 4.19295 17.8479 5.06045 17.6276L9.5001 16.5V14.345C8.21532 14.1822 7.03049 13.897 6.0001 13.5161C6.5001 12.5322 7.0001 11.0563 7.0001 7.61264C7.0001 1.70919 12.5001 1.70912 14.0001 3.67672C17.0001 3.18499 17.0001 5.64483 17.0001 8.59655C17.0001 10.9579 17.6668 12.8602 18.0001 13.5161C16.9697 13.897 15.7849 14.1822 14.5001 14.345V16.5Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "0" }],
] as const;

export const Female02Icon = /* @__PURE__ */ createTerraIcon({
  icon: Female02IconData,
  displayName: 'Female02Icon',
});

const FemaleSymbolIconData = [
  ['path', { d: "M18 8C18 11.3137 15.3137 14 12 14C8.68629 14 6 11.3137 6 8C6 4.68629 8.68629 2 12 2C15.3137 2 18 4.68629 18 8Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M12 14V22M9 18H15", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const FemaleSymbolIcon = /* @__PURE__ */ createTerraIcon({
  icon: FemaleSymbolIconData,
  displayName: 'FemaleSymbolIcon',
});

const FenceIconData = [
  ['path', { d: "M10 20V5.33333C10 5.11696 10.0702 4.90643 10.2 4.73333L11.2 3.4C11.3889 3.14819 11.6852 3 12 3C12.3148 3 12.6111 3.14819 12.8 3.4L13.8 4.73333C13.9298 4.90643 14 5.11696 14 5.33333V20C14 20.5523 13.5523 21 13 21H11C10.4477 21 10 20.5523 10 20Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M18 20V5.33333C18 5.11696 18.0702 4.90643 18.2 4.73333L19.2 3.4C19.3889 3.14819 19.6852 3 20 3C20.3148 3 20.6111 3.14819 20.8 3.4L21.8 4.73333C21.9298 4.90643 22 5.11696 22 5.33333V20C22 20.5523 21.5523 21 21 21H19C18.4477 21 18 20.5523 18 20Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M10 8H6V18H10V8Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M18 8H14V18H18V8Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "3" }],
  ['path', { d: "M2 20V5.33333C2 5.11696 2.07018 4.90643 2.2 4.73333L3.2 3.4C3.38885 3.14819 3.68524 3 4 3C4.31476 3 4.61115 3.14819 4.8 3.4L5.8 4.73333C5.92982 4.90643 6 5.11696 6 5.33333V20C6 20.5523 5.55228 21 5 21H3C2.44772 21 2 20.5523 2 20Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "4" }],
] as const;

export const FenceIcon = /* @__PURE__ */ createTerraIcon({
  icon: FenceIconData,
  displayName: 'FenceIcon',
});

const FencingMaskIconData = [
  ['path', { d: "M11.9996 20.0001C15.5002 20.0001 20 14.2945 20 9.84114C20 4.64409 16.5709 1.98295 11.9996 2.00008C7.42842 2.01721 4 4.64407 4 9.84112C4 14.2945 8.49907 20.0001 11.9996 20.0001Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M12 2V20", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M4.5 8C8 10 16 10 19.5 8", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M4.5 13C8 15 16 15 19.5 13", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "3" }],
  ['path', { d: "M6 16C6 18.4 5 20.8 3 22", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "4" }],
  ['path', { d: "M18 16C18 18.4 19 20.8 21 22", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "5" }],
] as const;

export const FencingMaskIcon = /* @__PURE__ */ createTerraIcon({
  icon: FencingMaskIconData,
  displayName: 'FencingMaskIcon',
});

const FencingIconData = [
  ['path', { d: "M9.0257 13.9743C7.83992 12.7885 6.03756 12.6684 5 13.7059L9.29408 18C10.3316 16.9624 10.2115 15.1601 9.0257 13.9743ZM9.0257 13.9743L20 3M7.36628 16.0722L4.19835 20.6047C3.19395 21.844 1.12433 19.8672 2.40699 18.8189L6.8792 15.5851", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M14.9743 13.9743C16.1601 12.7885 17.9624 12.6684 19 13.7059L14.7059 18C13.6684 16.9624 13.7885 15.1601 14.9743 13.9743ZM14.9743 13.9743L4 3M16.6337 16.0722L19.8017 20.6047C20.806 21.844 22.8757 19.8672 21.593 18.8189L17.1208 15.5851", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const FencingIcon = /* @__PURE__ */ createTerraIcon({
  icon: FencingIconData,
  displayName: 'FencingIcon',
});

const FerrisWheelIconData = [
  ['circle', { cx: 12, cy: 12, r: 6, stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M8 22L12 12L16 22", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M14 4C14 5.10457 13.1046 6 12 6C10.8954 6 10 5.10457 10 4C10 2.89543 10.8954 2 12 2C13.1046 2 14 2.89543 14 4Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M19 10C17.8954 10 17 9.10457 17 8C17 6.89543 17.8954 6 19 6C20.1046 6 21 6.89543 21 8C21 9.10457 20.1046 10 19 10Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "3" }],
  ['path', { d: "M7 16C7 17.1046 6.10457 18 5 18C3.89543 18 3 17.1046 3 16C3 14.8954 3.89543 14 5 14C6.10457 14 7 14.8954 7 16Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "4" }],
  ['path', { d: "M7 8C7 9.10457 6.10457 10 5 10C3.89543 10 3 9.10457 3 8C3 6.89543 3.89543 6 5 6C6.10457 6 7 6.89543 7 8Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "5" }],
  ['path', { d: "M21 16C21 17.1046 20.1046 18 19 18C17.8954 18 17 17.1046 17 16C17 14.8954 17.8954 14 19 14C20.1046 14 21 14.8954 21 16Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "6" }],
] as const;

export const FerrisWheelIcon = /* @__PURE__ */ createTerraIcon({
  icon: FerrisWheelIconData,
  displayName: 'FerrisWheelIcon',
});

const FerryBoatIconData = [
  ['path', { d: "M5 14.5H8M16 14.5H19", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M17.9975 17L19.7813 12.5501C20.1822 11.5501 19.7188 10.4121 18.7333 9.97663L12.4018 7.17867C12.1443 7.06487 11.8507 7.0649 11.5932 7.17876L5.26491 9.97695C4.28013 10.4124 3.81684 11.5493 4.2168 12.549L5.99751 17", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M18 9.5L17.6654 5.81893C17.5717 4.78877 16.708 4 15.6736 4H8.32643C7.29202 4 6.42829 4.78877 6.33464 5.81893L6 9.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M12 4V2", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "3" }],
  ['path', { d: "M2 21.1932C2.68524 22.2443 3.57104 22.2443 4.27299 21.1932C6.52985 17.7408 8.67954 23.6764 10.273 21.2321C12.703 17.5694 14.4508 23.9218 16.273 21.1932C18.6492 17.5582 20.1295 23.5776 22 21.5842", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "4" }],
] as const;

export const FerryBoatIcon = /* @__PURE__ */ createTerraIcon({
  icon: FerryBoatIconData,
  displayName: 'FerryBoatIcon',
});

const FigmaIconData = [
  ['circle', { cx: 15, cy: 12, r: 3, stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M9 21C10.6569 21 12 19.6569 12 18V15H9C7.34315 15 6 16.3431 6 18C6 19.6569 7.34315 21 9 21Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M12 9V15H9C7.34315 15 6 13.6569 6 12C6 10.3431 7.34315 9 9 9H12Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M12 3V9H9C7.34315 9 6 7.65685 6 6C6 4.34315 7.34315 3 9 3H12Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "3" }],
  ['path', { d: "M12 3V9H15C16.6569 9 18 7.65685 18 6C18 4.34315 16.6569 3 15 3H12Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "4" }],
] as const;

export const FigmaIcon = /* @__PURE__ */ createTerraIcon({
  icon: FigmaIconData,
  displayName: 'FigmaIcon',
});

const File01IconData = [
  ['path', { d: "M7.99976 7H15.9998", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M7.99976 11H11.9998", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M12.9955 22.0015H6C4.89421 22.0015 3.99828 21.1042 4 19.9984L4.02496 3.99688C4.02668 2.89353 4.92161 2 6.02496 2H17.9969C19.1014 2 19.9969 2.89543 19.9969 4V15.0145L12.9955 22.0015Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M20 15H15C13.8954 15 13 15.8954 13 17V22", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "3" }],
] as const;

export const File01Icon = /* @__PURE__ */ createTerraIcon({
  icon: File01IconData,
  displayName: 'File01Icon',
});

const File02IconData = [
  ['path', { d: "M8 17H16", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M8 13H12", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M20 20V9L13 2H6C4.89543 2 4 2.89543 4 4V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M13 2V7C13 8.10457 13.8954 9 15 9H20", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "3" }],
] as const;

export const File02Icon = /* @__PURE__ */ createTerraIcon({
  icon: File02IconData,
  displayName: 'File02Icon',
});

const FileAddIconData = [
  ['path', { d: "M12.9992 2H18.0006C19.1052 2 20.0006 2.89543 20.0006 4V15.0145L12.9992 22.0015H6.00391C4.89805 22.0015 4.00209 21.1041 4.00391 19.9982V12", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M20 15H15C13.8954 15 13 15.8954 13 17V22", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M12 6H4M8 2V10", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const FileAddIcon = /* @__PURE__ */ createTerraIcon({
  icon: FileAddIconData,
  displayName: 'FileAddIcon',
});

const FileArchiveIconData = [
  ['path', { d: "M4 20V4C4 2.89543 4.89543 2 6 2H13L20 9V20C20 21.1046 19.1046 22 18 22H14", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M13 2V7C13 8.10457 13.8954 9 15 9H20", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M10.5 20.5C10.5 21.3284 9.82843 22 9 22C8.17157 22 7.5 21.3284 7.5 20.5C7.5 19.6716 8.17157 19 9 19C9.82843 19 10.5 19.6716 10.5 20.5Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M9 19V17M9 13V11M9 7V5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "3" }],
] as const;

export const FileArchiveIcon = /* @__PURE__ */ createTerraIcon({
  icon: FileArchiveIconData,
  displayName: 'FileArchiveIcon',
});

const FileAttachmentIconData = [
  ['path', { d: "M14 2H18C19.1046 2 20 2.89543 20 4V15.0145L12.9986 22.0015H6C4.89543 22.0015 4 21.1061 4 20.0015V13", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M20 15H15C13.8954 15 13 15.8954 13 17V22", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M4 8.23077V5.46154C4 3.54978 5.567 2 7.5 2C9.433 2 11 3.54978 11 5.46154V9.26923C11 10.2251 10.2165 11 9.25 11C8.2835 11 7.5 10.2251 7.5 9.26923V5.46154", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const FileAttachmentIcon = /* @__PURE__ */ createTerraIcon({
  icon: FileAttachmentIconData,
  displayName: 'FileAttachmentIcon',
});

const FileAudioIconData = [
  ['path', { d: "M20 11V9L13 2H6C4.89543 2 4 2.89543 4 4V20C4 21.1046 4.89543 22 6 22H12", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M13 2V7C13 8.10457 13.8954 9 15 9H20", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M16 16.5H13.5C13.2239 16.5 13 16.7239 13 17V19C13 19.2761 13.2239 19.5 13.5 19.5H16L20 22V14L16 16.5Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "2" }],
] as const;

export const FileAudioIcon = /* @__PURE__ */ createTerraIcon({
  icon: FileAudioIconData,
  displayName: 'FileAudioIcon',
});

const FileAxis3dIconData = [
  ['path', { d: "M20 20V9L13 2H6C4.89543 2 4 2.89543 4 4V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M13 2V7C13 8.10457 13.8954 9 15 9H20", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M8 10V18H16", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M8 18L13 13", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "3" }],
] as const;

export const FileAxis3dIcon = /* @__PURE__ */ createTerraIcon({
  icon: FileAxis3dIconData,
  displayName: 'FileAxis3dIcon',
});

const FileBadgeIconData = [
  ['path', { d: "M4 8V4C4 2.89543 4.89543 2 6 2H13L20 9V20C20 21.1046 19.1046 22 18 22H13", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M13 2V7C13 8.10457 13.8954 9 15 9H20", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M10 14C10 15.6569 8.65685 17 7 17C5.34315 17 4 15.6569 4 14C4 12.3431 5.34315 11 7 11C8.65685 11 10 12.3431 10 14Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M5 16.5L4 22L7 20.5L10 22L9 16.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "3" }],
] as const;

export const FileBadgeIcon = /* @__PURE__ */ createTerraIcon({
  icon: FileBadgeIconData,
  displayName: 'FileBadgeIcon',
});

const FileBitcoinIconData = [
  ['path', { d: "M11.5 22.0015H5C3.89543 22.0015 3 21.1061 3 20.0015V9.81667C3 9.28553 3.21128 8.7762 3.58724 8.40101L9.41585 2.58434C9.7908 2.21015 10.2989 2 10.8286 2H18C19.1046 2 20 2.89543 20 4V9.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M3 9.00146H8C9.10457 9.00146 10 8.10603 10 7.00146V2.00146", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M15 14H16M19.25 17.5H16M19.25 17.5C20.2165 17.5 21 16.7165 21 15.75C21 14.7835 20.2165 14 19.25 14H18M19.25 17.5C20.2165 17.5 21 18.2835 21 19.25C21 20.2165 20.2165 21 19.25 21H18M16 17.5V14M16 17.5V21M15 21H16M16 14H18M16 21H18M18 14V13M18 21V22", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const FileBitcoinIcon = /* @__PURE__ */ createTerraIcon({
  icon: FileBitcoinIconData,
  displayName: 'FileBitcoinIcon',
});

const FileBlockIconData = [
  ['path', { d: "M14 2H18C19.1046 2 20 2.89543 20 4V15.0145L12.9986 22.0015H6C4.89543 22.0015 4 21.1061 4 20.0015V12", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M20 15H15C13.8954 15 13 15.8954 13 17V22", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M9.97487 7.97487C10.6082 7.3415 11 6.4665 11 5.5C11 3.567 9.433 2 7.5 2C6.5335 2 5.6585 2.39175 5.02513 3.02513M9.97487 7.97487C9.3415 8.60825 8.4665 9 7.5 9C5.567 9 4 7.433 4 5.5C4 4.5335 4.39175 3.6585 5.02513 3.02513M9.97487 7.97487L5.02513 3.02513", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const FileBlockIcon = /* @__PURE__ */ createTerraIcon({
  icon: FileBlockIconData,
  displayName: 'FileBlockIcon',
});

const FileBookmarkIconData = [
  ['path', { d: "M13 2H18C19.1046 2 20 2.89543 20 4V15.0145L12.9986 22.0015H6C4.89543 22.0015 4 21.1061 4 20.0015V13", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M20 15H15C13.8954 15 13 15.8954 13 17V22", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M4 10V2H10V10L7 8L4 10Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const FileBookmarkIcon = /* @__PURE__ */ createTerraIcon({
  icon: FileBookmarkIconData,
  displayName: 'FileBookmarkIcon',
});

const FileBoxIconData = [
  ['path', { d: "M4.5 9.99976V3.99976C4.5 2.89519 5.39543 1.99976 6.5 1.99976H13.5L20.5 8.99976V19.9998C20.5 21.1043 19.6046 21.9998 18.5 21.9998H14.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M13.5 1.99976V6.99976C13.5 8.10433 14.3954 8.99976 15.5 8.99976H20.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M12.5 14.4998L8 11.9998L3.5 14.4998L8 16.9998L12.5 14.4998Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M12.5 14.4998V19.5001L8 22.0002L3.5 19.5001V14.4998M8 16.9998V21.5024", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "3" }],
] as const;

export const FileBoxIcon = /* @__PURE__ */ createTerraIcon({
  icon: FileBoxIconData,
  displayName: 'FileBoxIcon',
});

const FileBracesIconData = [
  ['path', { d: "M20 20V9L13 2H6C4.89543 2 4 2.89543 4 4V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M13 2V7C13 8.10457 13.8954 9 15 9H20", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M14 12C14.5523 12 15 12.4477 15 13V14C15 14.5523 15.4477 15 16 15C15.4477 15 15 15.4477 15 16V17C15 17.5523 14.5523 18 14 18M10 12C9.44772 12 9 12.4477 9 13V14C9 14.5523 8.55228 15 8 15C8.55228 15 9 15.4477 9 16V17C9 17.5523 9.44772 18 10 18", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const FileBracesIcon = /* @__PURE__ */ createTerraIcon({
  icon: FileBracesIconData,
  displayName: 'FileBracesIcon',
});

const FileChartColumnIncreasingIconData = [
  ['path', { d: "M20 20V9L13 2H6C4.89543 2 4 2.89543 4 4V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M13 2V7C13 8.10457 13.8954 9 15 9H20", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M8 17V18M12 15V18M16 13V18", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const FileChartColumnIncreasingIcon = /* @__PURE__ */ createTerraIcon({
  icon: FileChartColumnIncreasingIconData,
  displayName: 'FileChartColumnIncreasingIcon',
});

const FileChartColumnIconData = [
  ['path', { d: "M20 20V9L13 2H6C4.89543 2 4 2.89543 4 4V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M13 2V7C13 8.10457 13.8954 9 15 9H20", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M8 16V18", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M12 13V18", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "3" }],
  ['path', { d: "M16 15V18", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "4" }],
] as const;

export const FileChartColumnIcon = /* @__PURE__ */ createTerraIcon({
  icon: FileChartColumnIconData,
  displayName: 'FileChartColumnIcon',
});

const FileChartPieIconData = [
  ['path', { d: "M5 9V4C5 2.89543 5.89543 2 7 2H14L21 9V20C21 21.1046 20.1046 22 19 22H15", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M14 2V7C14 8.10457 14.8954 9 16 9H21", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['circle', { cx: 8, cy: 17, r: 5, stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M8 12V16C8 16.5523 8.44772 17 9 17H13", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "3" }],
] as const;

export const FileChartPieIcon = /* @__PURE__ */ createTerraIcon({
  icon: FileChartPieIconData,
  displayName: 'FileChartPieIcon',
});

const FileClockIconData = [
  ['path', { d: "M5 9V4C5 2.89543 5.89543 2 7 2H14L21 9V20C21 21.1046 20.1046 22 19 22H15", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M14 2V7C14 8.10457 14.8954 9 16 9H21", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['circle', { cx: 8, cy: 17, r: 5, stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M8 15V17L9.5 17.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "3" }],
] as const;

export const FileClockIcon = /* @__PURE__ */ createTerraIcon({
  icon: FileClockIconData,
  displayName: 'FileClockIcon',
});

const FileCloudIconData = [
  ['path', { d: "M14 2H18C19.1046 2 20 2.89543 20 4V15.0145L12.9986 22.0015H6C4.89543 22.0015 4 21.1061 4 20.0015V12", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M20 15H15C13.8954 15 13 15.8954 13 17V22", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M4 6.66667C4 7.95533 5.00736 9 6.25 9H10.975C12.0934 9 13 8.0598 13 6.9C13 5.7402 12.0833 4.80003 10.9649 4.80003C11.0897 3.36433 9.97992 2 8.5 2C7.20546 2 6.14305 3.03069 6.03419 4.34393C4.89279 4.45657 4 5.45349 4 6.66667Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const FileCloudIcon = /* @__PURE__ */ createTerraIcon({
  icon: FileCloudIconData,
  displayName: 'FileCloudIcon',
});

const FileCodeCornerIconData = [
  ['path', { d: "M5 12V4C5 2.89543 5.89543 2 7 2H14L21 9V20C21 21.1046 20.1046 22 19 22H15", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M10 16L13 19L10 22", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M6 16L3 19L6 22", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M14 2V7C14 8.10457 14.8954 9 16 9H21", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "3" }],
] as const;

export const FileCodeCornerIcon = /* @__PURE__ */ createTerraIcon({
  icon: FileCodeCornerIconData,
  displayName: 'FileCodeCornerIcon',
});

const FileCodeIconData = [
  ['path', { d: "M20 20V9L13 2H6C4.89543 2 4 2.89543 4 4V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M13 2V7C13 8.10457 13.8954 9 15 9H20", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M14 13L16.5 15.5L14 18", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M10 13L7.5 15.5L10 18", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "3" }],
] as const;

export const FileCodeIcon = /* @__PURE__ */ createTerraIcon({
  icon: FileCodeIconData,
  displayName: 'FileCodeIcon',
});

const FileCorruptIconData = [
  ['path', { d: "M13 2V7C13 8.10457 13.8954 9 15 9H20", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M14 22H18C19.1046 22 20 21.1046 20 20V9L13 2H6C4.89543 2 4 2.89543 4 4V20C4 21.1046 4.89543 22 6 22H9.03162C9.32841 22 9.60985 21.8682 9.79985 21.6402L12 19L9.5 16.5L12 14L10 12", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const FileCorruptIcon = /* @__PURE__ */ createTerraIcon({
  icon: FileCorruptIconData,
  displayName: 'FileCorruptIcon',
});

const FileDatabaseIconData = [
  ['path', { d: "M21 14.5V20.5C21 21.3284 19.2091 22 17 22C14.7909 22 13 21.3284 13 20.5V14.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M19 10V9L12 2H5C3.89543 2 3 2.89543 3 4V20C3 21.1046 3.89543 22 5 22H10", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M12 2V7C12 8.10457 12.8954 9 14 9H19", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M17 16C19.2091 16 21 15.3284 21 14.5C21 13.6716 19.2091 13 17 13C14.7909 13 13 13.6716 13 14.5C13 15.3284 14.7909 16 17 16Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "3" }],
  ['path', { d: "M21 17.5C21 18.3284 19.2091 19 17 19C14.7909 19 13 18.3284 13 17.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "4" }],
] as const;

export const FileDatabaseIcon = /* @__PURE__ */ createTerraIcon({
  icon: FileDatabaseIconData,
  displayName: 'FileDatabaseIcon',
});

const FileDiffIconData = [
  ['path', { d: "M5.9925 12V18M9 14.9925L3 14.9925", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M3 22H9", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M5 8V4C5 2.89543 5.89543 2 7 2H14L21 9V20C21 21.1046 20.1046 22 19 22H13", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M14 2V7C14 8.10457 14.8954 9 16 9H21", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "3" }],
] as const;

export const FileDiffIcon = /* @__PURE__ */ createTerraIcon({
  icon: FileDiffIconData,
  displayName: 'FileDiffIcon',
});

const FileDigitIconData = [
  ['path', { d: "M5 12V4C5 2.89543 5.89543 2 7 2H14L21 9V20C21 21.1046 20.1046 22 19 22", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M7 20V18C7 16.8954 6.10457 16 5 16C3.89543 16 3 16.8954 3 18V20C3 21.1046 3.89543 22 5 22C6.10457 22 7 21.1046 7 20Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M15 22H11", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M13 22V16L11 17", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "3" }],
  ['path', { d: "M14 2V7C14 8.10457 14.8954 9 16 9H21", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "4" }],
] as const;

export const FileDigitIcon = /* @__PURE__ */ createTerraIcon({
  icon: FileDigitIconData,
  displayName: 'FileDigitIcon',
});

const FileDollarIconData = [
  ['path', { d: "M3 9.00146H8C9.10457 9.00146 10 8.10603 10 7.00146V2.00146", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M13 22.0015H5C3.89543 22.0015 3 21.1061 3 20.0015V9.81667C3 9.28553 3.21128 8.7762 3.58724 8.40101L9.41585 2.58434C9.7908 2.21015 10.2989 2 10.8286 2H18C19.1046 2 20 2.89543 20 4V8.98705", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M18.5 13V13.9M18.5 13.9C17.2343 13.9 16.2083 14.7357 16.2083 15.7667C16.2083 16.7976 16.8333 17.3667 18.5 17.3667C20.1667 17.3667 21 17.9001 21 19.2334C21 20.5668 19.8807 21.1 18.5 21.1M18.5 13.9C19.7657 13.9 20.7917 14.7357 20.7917 15.7667M18.5 21.1V22M18.5 21.1C17.1192 21.1 16 20.2644 16 19.2334", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const FileDollarIcon = /* @__PURE__ */ createTerraIcon({
  icon: FileDollarIconData,
  displayName: 'FileDollarIcon',
});

const FileDownIconData = [
  ['path', { d: "M20 20V9L13 2H6C4.89543 2 4 2.89543 4 4V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M13 2V7C13 8.10457 13.8954 9 15 9H20", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M9 15L12 18L15 15M12 17.5V12", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const FileDownIcon = /* @__PURE__ */ createTerraIcon({
  icon: FileDownIconData,
  displayName: 'FileDownIcon',
});

const FileDownloadIconData = [
  ['path', { d: "M11.5156 2H18C19.1046 2 20 2.89543 20 4V15.0145L12.9986 22.0015H6C4.89543 22.0015 4 21.1061 4 20.0015V12", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M4 7L7 10L10 7M7 2V9.39122", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M20 15H15C13.8954 15 13 15.8954 13 17V22", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "2" }],
] as const;

export const FileDownloadIcon = /* @__PURE__ */ createTerraIcon({
  icon: FileDownloadIconData,
  displayName: 'FileDownloadIcon',
});

const FileEditIconData = [
  ['path', { d: "M13 20V22H15L21 16L19 14L13 20Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M19 11V9L12 2H5C3.89543 2 3 2.89543 3 4V20C3 21.1046 3.89543 22 5 22H10", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M12 2V7C12 8.10457 12.8954 9 14 9H19", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "2" }],
] as const;

export const FileEditIcon = /* @__PURE__ */ createTerraIcon({
  icon: FileEditIconData,
  displayName: 'FileEditIcon',
});

const FileEmpty01IconData = [
  ['path', { d: "M12.9955 22.0015H6C4.89421 22.0015 3.99828 21.1042 4 19.9984L4.02496 3.99688C4.02668 2.89353 4.92161 2 6.02496 2H17.9969C19.1014 2 19.9969 2.89543 19.9969 4V15.0145L12.9955 22.0015Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M20 15H15C13.8954 15 13 15.8954 13 17V22", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "1" }],
] as const;

export const FileEmpty01Icon = /* @__PURE__ */ createTerraIcon({
  icon: FileEmpty01IconData,
  displayName: 'FileEmpty01Icon',
});

const FileEmpty02IconData = [
  ['path', { d: "M20 20V9L13 2H6C4.89543 2 4 2.89543 4 4V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M13 2V7C13 8.10457 13.8954 9 15 9H20", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "1" }],
] as const;

export const FileEmpty02Icon = /* @__PURE__ */ createTerraIcon({
  icon: FileEmpty02IconData,
  displayName: 'FileEmpty02Icon',
});

const FileEuroIconData = [
  ['path', { d: "M3 9.00146H8C9.10457 9.00146 10 8.10603 10 7.00146V2.00146", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M12.5 22.0015H5C3.89543 22.0015 3 21.1061 3 20.0015V9.81667C3 9.28553 3.21128 8.7762 3.58724 8.40101L9.41585 2.58434C9.7908 2.21015 10.2989 2 10.8286 2H18C19.1046 2 20 2.89543 20 4V10.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M21 15.5C20.5 14.5 19.6936 14 18.6056 14C17.1665 14 16 15.1665 16 16.6056V19.3944C16 20.8335 17.1665 22 18.6056 22C19.6936 22 20.5 21.5 21 20.5M15 18H19", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const FileEuroIcon = /* @__PURE__ */ createTerraIcon({
  icon: FileEuroIconData,
  displayName: 'FileEuroIcon',
});

const FileExclamationPointIconData = [
  ['path', { d: "M20 20V9L13 2H6C4.89543 2 4 2.89543 4 4V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M13 2V7C13 8.10457 13.8954 9 15 9H20", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M12 12V15", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M12.125 18.5H12M12.25 18.5C12.25 18.6381 12.1381 18.75 12 18.75C11.8619 18.75 11.75 18.6381 11.75 18.5C11.75 18.3619 11.8619 18.25 12 18.25C12.1381 18.25 12.25 18.3619 12.25 18.5Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "3" }],
] as const;

export const FileExclamationPointIcon = /* @__PURE__ */ createTerraIcon({
  icon: FileExclamationPointIconData,
  displayName: 'FileExclamationPointIcon',
});

const FileExportIconData = [
  ['path', { d: "M19 14V9L12 2H5C3.89543 2 3 2.89543 3 4V20C3 21.1046 3.89543 22 5 22H10", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M12 2V7C12 8.10457 12.8954 9 14 9H19", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M16 22L19 19L16 16M11 19H18.3912", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const FileExportIcon = /* @__PURE__ */ createTerraIcon({
  icon: FileExportIconData,
  displayName: 'FileExportIcon',
});

const FileFavouriteIconData = [
  ['path', { d: "M15 2H18C19.1046 2 20 2.89543 20 4V15.0145L12.9986 22.0015H6C4.89543 22.0015 4 21.1061 4 20.0015V11", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M20 15H15C13.8954 15 13 15.8954 13 17V22", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M10.7431 2.28961C9.14648 1.45704 8.00003 2.68433 8.00003 2.68433C8.00003 2.68433 6.85353 1.45704 5.25685 2.2896C3.32296 3.298 3.18408 7.24692 8.00003 9C12.816 7.24692 12.677 3.298 10.7431 2.28961Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const FileFavouriteIcon = /* @__PURE__ */ createTerraIcon({
  icon: FileFavouriteIconData,
  displayName: 'FileFavouriteIcon',
});

const FileHeadphoneIconData = [
  ['path', { d: "M5 8V4C5 2.89543 5.89543 2 7 2H14L21 9V20C21 21.1046 20.1046 22 19 22H17", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M6 19C6 18.4477 5.55228 18 5 18H3V21C3 21.5523 3.44772 22 4 22H5C5.55228 22 6 21.5523 6 21V19Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M13 18H11C10.4477 18 10 18.4477 10 19V21C10 21.5523 10.4477 22 11 22H12C12.5523 22 13 21.5523 13 21V18Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M3 18V17C3 14.2386 5.23858 12 8 12C10.7614 12 13 14.2386 13 17V18", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "3" }],
  ['path', { d: "M14 2V7C14 8.10457 14.8954 9 16 9H21", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "4" }],
] as const;

export const FileHeadphoneIcon = /* @__PURE__ */ createTerraIcon({
  icon: FileHeadphoneIconData,
  displayName: 'FileHeadphoneIcon',
});

const FileHeartIconData = [
  ['path', { d: "M4.5 11V4C4.5 2.89543 5.39543 2 6.5 2H13.5L20.5 9V20C20.5 21.1046 19.6046 22 18.5 22H13.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M7.5 22C7.5 22 3.5 19.5294 3.5 17.1389C3.5 15.9576 4.34211 15 5.5 15C6.1 15 6.7 15.2059 7.5 16.0294C8.3 15.2059 8.9 15 9.5 15C10.6579 15 11.5 15.9576 11.5 17.1389C11.5 19.5294 7.5 22 7.5 22Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M13.5 2V7C13.5 8.10457 14.3954 9 15.5 9H20.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const FileHeartIcon = /* @__PURE__ */ createTerraIcon({
  icon: FileHeartIconData,
  displayName: 'FileHeartIcon',
});

const FileImageIconData = [
  ['path', { d: "M20 20V9L13 2H6C4.89543 2 4 2.89543 4 4V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['circle', { cx: 9.5, cy: 12.5, r: 1.5, stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M20 17L17.3536 14.3536C17.1272 14.1272 16.8201 14 16.5 14C16.1799 14 15.8728 14.1272 15.6464 14.3536L8 22", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M13 2V7C13 8.10457 13.8954 9 15 9H20", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "3" }],
] as const;

export const FileImageIcon = /* @__PURE__ */ createTerraIcon({
  icon: FileImageIconData,
  displayName: 'FileImageIcon',
});

const FileImportIconData = [
  ['path', { d: "M19 15V9L12 2H5C3.89543 2 3 2.89543 3 4V20C3 21.1046 3.89543 22 5 22H9", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M12 2V7C12 8.10457 12.8954 9 14 9H19", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M14 22L11 19L14 16M19 19H11.6088", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const FileImportIcon = /* @__PURE__ */ createTerraIcon({
  icon: FileImportIconData,
  displayName: 'FileImportIcon',
});

const FileInputIconData = [
  ['path', { d: "M4 11V4C4 2.89543 4.89543 2 6 2H13L20 9V20C20 21.1046 19.1046 22 18 22H6C4.89543 22 4 21.1046 4 20V19", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M13 2V7C13 8.10457 13.8954 9 15 9H20", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M11 12L14 15L11 18M13.5 15H4", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const FileInputIcon = /* @__PURE__ */ createTerraIcon({
  icon: FileInputIconData,
  displayName: 'FileInputIcon',
});

const FileKeyIconData = [
  ['path', { d: "M4.5 14V4C4.5 2.89543 5.39543 2 6.5 2H13.5L20.5 9V20C20.5 21.1046 19.6046 22 18.5 22H11.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M13.5 2V7C13.5 8.10457 14.3954 9 15.5 9H20.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M7 18.5L11.5 14M10.5 15.5L11.5 16.5M7.5 20C7.5 21.1046 6.60457 22 5.5 22C4.39543 22 3.5 21.1046 3.5 20C3.5 18.8954 4.39543 18 5.5 18C6.60457 18 7.5 18.8954 7.5 20Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const FileKeyIcon = /* @__PURE__ */ createTerraIcon({
  icon: FileKeyIconData,
  displayName: 'FileKeyIcon',
});

const FileLinkIconData = [
  ['path', { d: "M12 2H18C19.1046 2 20 2.89543 20 4V15.0145L12.9986 22.0015H6C4.89543 22.0015 4 21.1061 4 20.0015V12", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M20 15H15C13.8954 15 13 15.8954 13 17V22", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M9.27212 10.3604C10.1249 11.2132 11.5076 11.2132 12.3604 10.3604C13.2132 9.50754 13.2132 8.12489 12.3604 7.27206L10.4302 5.34185C9.61625 4.52786 8.31952 4.49081 7.46157 5.23071M7.72789 2.63961C6.8751 1.7868 5.49246 1.7868 4.63959 2.63961C3.7868 3.49242 3.7868 4.87511 4.63959 5.72792L6.56984 7.65812C7.38376 8.47213 8.6805 8.50919 9.53844 7.76923", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const FileLinkIcon = /* @__PURE__ */ createTerraIcon({
  icon: FileLinkIconData,
  displayName: 'FileLinkIcon',
});

const FileLockIconData = [
  ['path', { d: "M4.5 11V4C4.5 2.89543 5.39543 2 6.5 2H13.5L20.5 9V20C20.5 21.1046 19.6046 22 18.5 22H14.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M13.5 2V7C13.5 8.10457 14.3954 9 15.5 9H20.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M9 17.5V16C9 14.8954 8.10457 14 7 14C5.89543 14 5 14.8954 5 16V17.5M9 17.5H9.5C10.0523 17.5 10.5 17.9477 10.5 18.5V21C10.5 21.5523 10.0523 22 9.5 22H4.5C3.94772 22 3.5 21.5523 3.5 21V18.5C3.5 17.9477 3.94772 17.5 4.5 17.5H5M9 17.5H5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const FileLockIcon = /* @__PURE__ */ createTerraIcon({
  icon: FileLockIconData,
  displayName: 'FileLockIcon',
});

const FileLockedIconData = [
  ['path', { d: "M20 12V9L13 2H6C4.89543 2 4 2.89543 4 4V20C4 21.1046 4.89543 22 6 22H10", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M13 2V7C13 8.10457 13.8954 9 15 9H20", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M14.75 17V15.75C14.75 14.7835 15.5335 14 16.5 14C17.4665 14 18.25 14.7835 18.25 15.75V17M13 17V22H20V17H13Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "2" }],
] as const;

export const FileLockedIcon = /* @__PURE__ */ createTerraIcon({
  icon: FileLockedIconData,
  displayName: 'FileLockedIcon',
});

const FileManagementIconData = [
  ['path', { d: "M15 2H18C19.1046 2 20 2.89543 20 4V15.0145L12.9986 22.0015H6C4.89543 22.0015 4 21.1061 4 20.0015V13", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M20 15H15C13.8954 15 13 15.8954 13 17V22", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M8 9.77273C9.76731 9.77273 11.2 8.30748 11.2 6.5C11.2 4.69252 9.76731 3.22727 8 3.22727M8 9.77273C6.23269 9.77273 4.8 8.30748 4.8 6.5C4.8 4.69252 6.23269 3.22727 8 3.22727M8 9.77273V11M8 3.22727V2M5.0913 4.71488L4.00045 4.04545M12 8.95455L10.9092 8.28512M10.9087 4.71488L11.9996 4.04545M4 8.95455L5.09085 8.28512", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", key: "2" }],
] as const;

export const FileManagementIcon = /* @__PURE__ */ createTerraIcon({
  icon: FileManagementIconData,
  displayName: 'FileManagementIcon',
});

const FileMinusIconData = [
  ['path', { d: "M12 2H18C19.1046 2 20 2.89543 20 4V15.0145L12.9986 22.0015H6C4.89543 22.0015 4 21.1061 4 20.0015V10", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M20 15H15C13.8954 15 13 15.8954 13 17V22", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M12 6H4", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const FileMinusIcon = /* @__PURE__ */ createTerraIcon({
  icon: FileMinusIconData,
  displayName: 'FileMinusIcon',
});

const FileMusicIconData = [
  ['path', { d: "M19 12V9L12 2H5C3.89543 2 3 2.89543 3 4V20C3 21.1046 3.89543 22 5 22H9", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M12 2V7C12 8.10457 12.8954 9 14 9H19", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M16.3971 19.7446C16.3971 20.9885 15.4127 21.9969 14.1985 21.9969C12.9843 21.9969 12 20.9885 12 19.7446C12 18.5007 12.9843 17.4923 14.1985 17.4923C15.4127 17.4923 16.3971 18.5007 16.3971 19.7446ZM16.3971 19.7446V14C16.6172 14.4963 17.7041 16.6999 19.0009 16.6999", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const FileMusicIcon = /* @__PURE__ */ createTerraIcon({
  icon: FileMusicIconData,
  displayName: 'FileMusicIcon',
});

const FileNotFoundIconData = [
  ['path', { d: "M15 15C13.8954 15 13 15.8954 13 17V22", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M2 2L22 22", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M6.02496 2H17.9969C19.1014 2 19.9969 2.89543 19.9969 4V15.0145L19.5052 15.5052M4.02496 3.99688L4 19.9984C3.99828 21.1042 4.89421 22.0015 6 22.0015H12.9955L17.5031 17.5031", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const FileNotFoundIcon = /* @__PURE__ */ createTerraIcon({
  icon: FileNotFoundIconData,
  displayName: 'FileNotFoundIcon',
});

const FilePasteIconData = [
  ['path', { d: "M12 2H18C19.1046 2 20 2.89543 20 4V15.0145L12.9986 22.0015H6C4.89543 22.0015 4 21.1061 4 20.0015V11", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M20 15H15C13.8954 15 13 15.8954 13 17V22", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M12 10V7.00016C12 5.89559 11.1046 5.00016 10 5.00016H4.50195M7 2L4 4.99625L7 7.99625", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const FilePasteIcon = /* @__PURE__ */ createTerraIcon({
  icon: FilePasteIconData,
  displayName: 'FilePasteIcon',
});

const FilePenIconData = [
  ['path', { d: "M4.5 13V4C4.5 2.89543 5.39543 2 6.5 2H13.5L20.5 9V20C20.5 21.1046 19.6046 22 18.5 22H11.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M13.5 2V7C13.5 8.10457 14.3954 9 15.5 9H20.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M3.5 22V19.7143L9.01225 14.202C9.14161 14.0727 9.31706 14 9.5 14C9.68294 14 9.85839 14.0727 9.98775 14.202L11.298 15.5123C11.4273 15.6416 11.5 15.8171 11.5 16C11.5 16.1829 11.4273 16.3584 11.298 16.4877L5.78571 22H3.5Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const FilePenIcon = /* @__PURE__ */ createTerraIcon({
  icon: FilePenIconData,
  displayName: 'FilePenIcon',
});

const FilePinIconData = [
  ['path', { d: "M20 11V9L13 2H6C4.89543 2 4 2.89543 4 4V20C4 21.1046 4.89543 22 6 22H12", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M13 2V7C13 8.10457 13.8954 9 15 9H20", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M17 19H14L15.5 16.5L15 14H19L18.5 16.5L20 19H17ZM17 19V22", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const FilePinIcon = /* @__PURE__ */ createTerraIcon({
  icon: FilePinIconData,
  displayName: 'FilePinIcon',
});

const FilePlayIconData = [
  ['path', { d: "M20 20V9L13 2H6C4.89543 2 4 2.89543 4 4V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M13 2V7C13 8.10457 13.8954 9 15 9H20", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M14.5629 14.2572L10.6799 12.0999C10.5619 12.0344 10.4292 12 10.2942 12C9.85558 12 9.5 12.3556 9.5 12.7942V17.2058C9.5 17.6444 9.85558 18 10.2942 18C10.4292 18 10.5619 17.9656 10.6799 17.9001L14.5629 15.7428C14.8327 15.593 15 15.3086 15 15C15 14.6914 14.8327 14.407 14.5629 14.2572Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const FilePlayIcon = /* @__PURE__ */ createTerraIcon({
  icon: FilePlayIconData,
  displayName: 'FilePlayIcon',
});

const FilePlusIconData = [
  ['path', { d: "M20 20V9L13 2H6C4.89543 2 4 2.89543 4 4V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M13 2V7C13 8.10457 13.8954 9 15 9H20", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M12 12V18M15.005 14.995L9.005 14.995", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const FilePlusIcon = /* @__PURE__ */ createTerraIcon({
  icon: FilePlusIconData,
  displayName: 'FilePlusIcon',
});

const FilePoundIconData = [
  ['path', { d: "M11.5 22.0015H5C3.89543 22.0015 3 21.1061 3 20.0015V9.81667C3 9.28553 3.21128 8.7762 3.58724 8.40101L9.41585 2.58434C9.7908 2.21015 10.2989 2 10.8286 2H18C19.1046 2 20 2.89543 20 4V11", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M3 9.00146H8C9.10457 9.00146 10 8.10603 10 7.00146V2.00146", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M21 22H15C16.1046 22 17 21.1046 17 20V16C17 14.8954 17.8954 14 19 14C20.1046 14 21 14.8954 21 16M15 19H19", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const FilePoundIcon = /* @__PURE__ */ createTerraIcon({
  icon: FilePoundIconData,
  displayName: 'FilePoundIcon',
});

const FileQuestionMarkIconData = [
  ['path', { d: "M4.5 8V4C4.5 2.89543 5.39543 2 6.5 2H13.5L20.5 9V20C20.5 21.1046 19.6046 22 18.5 22H10.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M13.5 2V7C13.5 8.10457 14.3954 9 15.5 9H20.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M3.5 14.5C3.5 13.1193 4.6193 12 6 12C7.3807 12 8.5 13.1193 8.5 14.5C8.5 15.3569 8.06886 16.1131 7.41166 16.5636C6.72833 17.0319 6 17.6716 6 18.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M6.125 21.75H6M6.25 21.75C6.25 21.8881 6.13807 22 6 22C5.86193 22 5.75 21.8881 5.75 21.75C5.75 21.6119 5.86193 21.5 6 21.5C6.13807 21.5 6.25 21.6119 6.25 21.75Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "3" }],
] as const;

export const FileQuestionMarkIcon = /* @__PURE__ */ createTerraIcon({
  icon: FileQuestionMarkIconData,
  displayName: 'FileQuestionMarkIcon',
});

const FileRemoveIconData = [
  ['path', { d: "M14.9986 2H18C19.1046 2 20 2.89543 20 4V15.0145L12.9986 22.0015H6C4.89543 22.0015 4 21.1061 4 20.0015V13", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M20 15H15C13.8954 15 13 15.8954 13 17V22", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M11 9L4 2M11 2L4 9", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const FileRemoveIcon = /* @__PURE__ */ createTerraIcon({
  icon: FileRemoveIconData,
  displayName: 'FileRemoveIcon',
});

const FileScanIconData = [
  ['path', { d: "M8 22H6C4.89543 22 4 21.1046 4 20V4C4 2.89543 4.89543 2 6 2H13L20 9V10", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M18 14H19C19.5523 14 20 14.4477 20 15V16M14 14H13C12.4477 14 12 14.4477 12 15V16M18 22H19C19.5523 22 20 21.5523 20 21V20M14 22H13C12.4477 22 12 21.5523 12 21V20", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M13 2V7C13 8.10457 13.8954 9 15 9H20", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const FileScanIcon = /* @__PURE__ */ createTerraIcon({
  icon: FileScanIconData,
  displayName: 'FileScanIcon',
});

const FileScriptIconData = [
  ['path', { d: "M20 15V9L13 2H6C4.89543 2 4 2.89543 4 4V20C4 21.1046 4.89543 22 6 22H10", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M13 2V7C13 8.10457 13.8954 9 15 9H20", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M14.5 22L12 19.5L14.5 17M17.5 22L20 19.5L17.5 17", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const FileScriptIcon = /* @__PURE__ */ createTerraIcon({
  icon: FileScriptIconData,
  displayName: 'FileScriptIcon',
});

const FileSearchIconData = [
  ['path', { d: "M20 20V9L13 2H6C4.89543 2 4 2.89543 4 4V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M13 2V7C13 8.10457 13.8954 9 15 9H20", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M13.5 16.5L15 18M14 14.5C14 15.8807 12.8807 17 11.5 17C10.1193 17 9 15.8807 9 14.5C9 13.1193 10.1193 12 11.5 12C12.8807 12 14 13.1193 14 14.5Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const FileSearchIcon = /* @__PURE__ */ createTerraIcon({
  icon: FileSearchIconData,
  displayName: 'FileSearchIcon',
});

const FileSecurityIconData = [
  ['path', { d: "M20 12V9L13 2H6C4.89543 2 4 2.89543 4 4V20C4 21.1046 4.89543 22 6 22H12", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M13 2V7C13 8.10457 13.8954 9 15 9H20", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M20 17.6219V15.6508C20 15.3408 19.7723 15.0835 19.477 15.0307C18.2869 14.8179 17.299 14.3446 16.817 14.0821C16.6197 13.9746 16.3803 13.9746 16.183 14.0821C15.701 14.3446 14.7131 14.8179 13.523 15.0307C13.2277 15.0835 13 15.3408 13 15.6508V17.6219C13 20.1933 15.5424 21.5958 16.2935 21.9541C16.426 22.0173 16.574 22.0173 16.7065 21.9541C17.4576 21.5958 20 20.1933 20 17.6219Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", key: "2" }],
] as const;

export const FileSecurityIcon = /* @__PURE__ */ createTerraIcon({
  icon: FileSecurityIconData,
  displayName: 'FileSecurityIcon',
});

const FileShredderIconData = [
  ['path', { d: "M22 12.9976H2", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M4 12.9978L4.01355 3.99699C4.01522 2.89273 4.91151 1.99877 6.01577 2L12.9924 2.00776L20 8.99481V12.9978M12.9966 2.49778V6.99778C12.9966 8.10235 13.892 8.99778 14.9966 8.99778H19.4998", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M6 15.9976V16.9976M10 15.9976V21.9976M14 15.9976V17.9976M18 15.9976V19.9976", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const FileShredderIcon = /* @__PURE__ */ createTerraIcon({
  icon: FileShredderIconData,
  displayName: 'FileShredderIcon',
});

const FileSignalIconData = [
  ['path', { d: "M4.5 11V4C4.5 2.89543 5.39543 2 6.5 2H13.5L20.5 9V20C20.5 21.1046 19.6046 22 18.5 22H14.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M13.5 2V7C13.5 8.10457 14.3954 9 15.5 9H20.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M14.5 15.9164C13.0924 14.4234 11.1479 13.5 9 13.5C6.85212 13.5 4.90757 14.4234 3.5 15.9164M6.25 18.8333C6.95379 18.0868 7.92606 17.6251 9 17.6251C10.0739 17.6251 11.0462 18.0868 11.75 18.8333M9.12579 21.75H9.00079M9.25079 21.75C9.25079 21.8881 9.13886 22 9.00079 22C8.86272 22 8.75079 21.8881 8.75079 21.75C8.75079 21.6119 8.86272 21.5 9.00079 21.5C9.13886 21.5 9.25079 21.6119 9.25079 21.75Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const FileSignalIcon = /* @__PURE__ */ createTerraIcon({
  icon: FileSignalIconData,
  displayName: 'FileSignalIcon',
});

const FileSlidersIconData = [
  ['path', { d: "M20 20V9L13 2H6C4.89543 2 4 2.89543 4 4V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M13 2V7C13 8.10457 13.8954 9 15 9H20", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M8 16H11M16 16H14", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M14 14V18", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "3" }],
] as const;

export const FileSlidersIcon = /* @__PURE__ */ createTerraIcon({
  icon: FileSlidersIconData,
  displayName: 'FileSlidersIcon',
});

const FileSpreadsheetIconData = [
  ['path', { d: "M20 20V9L13 2H6C4.89543 2 4 2.89543 4 4V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M13 2V7C13 8.10457 13.8954 9 15 9H20", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M8 14H10M14 14H16M8 18H10M14 18H16", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const FileSpreadsheetIcon = /* @__PURE__ */ createTerraIcon({
  icon: FileSpreadsheetIconData,
  displayName: 'FileSpreadsheetIcon',
});

const FileStackIconData = [
  ['path', { d: "M14 10.5V3.5C14 2.67157 14.6716 2 15.5 2H18.3787C18.7765 2 19.158 2.15804 19.4393 2.43934L21.5607 4.56066C21.842 4.84196 22 5.2235 22 5.62132V10.5C22 11.3284 21.3284 12 20.5 12H15.5C14.6716 12 14 11.3284 14 10.5Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M16 15.5C16 16.3284 15.3284 17 14.5 17H9.5C8.67157 17 8 16.3284 8 15.5V8.5C8 7.67157 8.67157 7 9.5 7H10.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M10 20.5C10 21.3284 9.32843 22 8.5 22H3.5C2.67157 22 2 21.3284 2 20.5V13.5C2 12.6716 2.67157 12 3.5 12H4.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const FileStackIcon = /* @__PURE__ */ createTerraIcon({
  icon: FileStackIconData,
  displayName: 'FileStackIcon',
});

const FileStarIconData = [
  ['path', { d: "M20 13V9L13 2H6C4.89543 2 4 2.89543 4 4V20C4 21.1046 4.89543 22 6 22H10", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M13 2V7C13 8.10457 13.8954 9 15 9H20", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M15.5088 14.8215C15.6913 14.3928 16.3087 14.3928 16.4912 14.8215L17.3329 16.7988L19.509 16.9692C19.9822 17.0063 20.1733 17.5879 19.8118 17.8905L18.1566 19.2758L18.6635 21.3521C18.7741 21.8049 18.2743 22.1639 17.8696 21.9224L16 20.8067L14.1304 21.9224C13.7257 22.1639 13.2259 21.8049 13.3365 21.3521L13.8434 19.2758L12.1882 17.8905C11.8267 17.5879 12.0178 17.0063 12.491 16.9692L14.6671 16.7988L15.5088 14.8215Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const FileStarIcon = /* @__PURE__ */ createTerraIcon({
  icon: FileStarIconData,
  displayName: 'FileStarIcon',
});

const FileSyncIconData = [
  ['path', { d: "M20 13V9L13 2H6C4.89543 2 4 2.89543 4 4V20C4 21.1046 4.89543 22 6 22H10", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M13 2V7C13 8.10457 13.8954 9 15 9H20", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M11 16L12 18C12.2426 16.3039 13.7368 15 15.5 15C16.6894 15 17.7402 15.5933 18.3726 16.5M20 21L19 19C18.7574 20.6961 17.2632 22 15.5 22C14.3106 22 13.2598 21.4067 12.6273 20.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const FileSyncIcon = /* @__PURE__ */ createTerraIcon({
  icon: FileSyncIconData,
  displayName: 'FileSyncIcon',
});

const FileTerminalIconData = [
  ['path', { d: "M20 20V9L13 2H6C4.89543 2 4 2.89543 4 4V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M8 13L10 15L8 17", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M12 18H16", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M13 2V7C13 8.10457 13.8954 9 15 9H20", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "3" }],
] as const;

export const FileTerminalIcon = /* @__PURE__ */ createTerraIcon({
  icon: FileTerminalIconData,
  displayName: 'FileTerminalIcon',
});

const FileTypeIconData = [
  ['path', { d: "M20 20V9L13 2H6C4.89543 2 4 2.89543 4 4V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M13 2V7C13 8.10457 13.8954 9 15 9H20", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M9 13.5C9 12.9477 9.44772 12.5 10 12.5H14C14.5523 12.5 15 12.9477 15 13.5M12 12.5V18M11 18H13", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const FileTypeIcon = /* @__PURE__ */ createTerraIcon({
  icon: FileTypeIconData,
  displayName: 'FileTypeIcon',
});

const FileUnknownIconData = [
  ['path', { d: "M7 11V11.5M5 4C5 2.89543 5.89543 2 7 2C8.07458 2 9 2.80976 9 3.91898C9 4.29783 8.88786 4.66821 8.67771 4.98344L7.5547 6.66795C7.19301 7.21049 7 7.84795 7 8.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M12 2H18C19.1046 2 20 2.89543 20 4V15.0145L12.9986 22.0015H6C4.89543 22.0015 4 21.1061 4 20.0015V12.5001", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M20 15H15C13.8954 15 13 15.8954 13 17V22", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "2" }],
] as const;

export const FileUnknownIcon = /* @__PURE__ */ createTerraIcon({
  icon: FileUnknownIconData,
  displayName: 'FileUnknownIcon',
});

const FileUnlockedIconData = [
  ['path', { d: "M14.75 17V15.75C14.75 14.7835 15.5335 14 16.5 14C16.9768 14 17.4091 14.1907 17.7247 14.5M13 17V22H20V17H13Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M20 13V9L13 2H6C4.89543 2 4 2.89543 4 4V20C4 21.1046 4.89543 22 6 22H10", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M13 2V7C13 8.10457 13.8954 9 15 9H20", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "2" }],
] as const;

export const FileUnlockedIcon = /* @__PURE__ */ createTerraIcon({
  icon: FileUnlockedIconData,
  displayName: 'FileUnlockedIcon',
});

const FileUpIconData = [
  ['path', { d: "M20 20V9L13 2H6C4.89543 2 4 2.89543 4 4V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M13 2V7C13 8.10457 13.8954 9 15 9H20", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M9 15L12 12L15 15M12 12.5V18", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const FileUpIcon = /* @__PURE__ */ createTerraIcon({
  icon: FileUpIconData,
  displayName: 'FileUpIcon',
});

const FileUploadIconData = [
  ['path', { d: "M13 2H18C19.1046 2 20 2.89543 20 4V15.0145L12.9986 22.0015H6C4.89543 22.0015 4 21.1061 4 20.0015V12", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M20 15H15C13.8954 15 13 15.8954 13 17V22", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M10 5L7 2L4 5M7 10V2.60878", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const FileUploadIcon = /* @__PURE__ */ createTerraIcon({
  icon: FileUploadIconData,
  displayName: 'FileUploadIcon',
});

const FileUserIconData = [
  ['path', { d: "M14.5001 14.5C14.5001 13.1192 13.3808 12 12.0001 12C10.6193 12 9.50006 13.1192 9.50006 14.5C9.50006 15.8807 10.6193 17 12.0001 17C13.3808 17 14.5001 15.8807 14.5001 14.5Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M17 22C17 19.2386 14.7614 17 12 17C9.23857 17 7 19.2386 7 22", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M20 20V9L13 2H6C4.89543 2 4 2.89543 4 4V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M13 2V7C13 8.10457 13.8954 9 15 9H20", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "3" }],
] as const;

export const FileUserIcon = /* @__PURE__ */ createTerraIcon({
  icon: FileUserIconData,
  displayName: 'FileUserIcon',
});

const FileValidationIconData = [
  ['path', { d: "M15.0303 6.46891C14.7374 6.17601 14.2626 6.17601 13.9697 6.46891C13.6768 6.7618 13.6768 7.23667 13.9697 7.52957L15.0303 6.46891ZM16 8.49924L15.4697 9.02957C15.6187 9.17857 15.8235 9.25802 16.034 9.24847C16.2445 9.23892 16.4413 9.14126 16.5762 8.97938L16 8.49924ZM19.0762 5.97938C19.3413 5.66117 19.2983 5.18824 18.9801 4.92307C18.6619 4.6579 18.189 4.70089 17.9238 5.0191L19.0762 5.97938ZM22.25 6.99924C22.25 3.8236 19.6756 1.24924 16.5 1.24924V2.74924C18.8472 2.74924 20.75 4.65203 20.75 6.99924H22.25ZM16.5 1.24924C13.3244 1.24924 10.75 3.8236 10.75 6.99924H12.25C12.25 4.65203 14.1528 2.74924 16.5 2.74924V1.24924ZM10.75 6.99924C10.75 10.1749 13.3244 12.7492 16.5 12.7492V11.2492C14.1528 11.2492 12.25 9.34645 12.25 6.99924H10.75ZM16.5 12.7492C19.6756 12.7492 22.25 10.1749 22.25 6.99924H20.75C20.75 9.34645 18.8472 11.2492 16.5 11.2492V12.7492ZM13.9697 7.52957L15.4697 9.02957L16.5303 7.96891L15.0303 6.46891L13.9697 7.52957ZM16.5762 8.97938L19.0762 5.97938L17.9238 5.0191L15.4238 8.0191L16.5762 8.97938Z", fill: "currentColor", key: "0" }],
  ['path', { d: "M10 1.99924H4.5C3.39543 1.99924 2.5 2.89467 2.5 3.99924V14.1841C2.5 14.7152 2.71128 15.2246 3.08724 15.5997L8.91585 21.4164C9.2908 21.7906 9.79889 22.0008 10.3286 22.0008H17.5C18.6046 22.0008 19.5 21.1053 19.5 20.0008V14.4992", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M2.5 14.9992H7.5C8.60457 14.9992 9.5 15.8947 9.5 16.9992V21.9992", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "2" }],
] as const;

export const FileValidationIcon = /* @__PURE__ */ createTerraIcon({
  icon: FileValidationIconData,
  displayName: 'FileValidationIcon',
});

const FileVerifiedIconData = [
  ['path', { d: "M20 16L15 22L13 20", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M20 13V9L13 2H6C4.89543 2 4 2.89543 4 4V20C4 21.1046 4.89543 22 6 22H10", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M13 2V7C13 8.10457 13.8954 9 15 9H20", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "2" }],
] as const;

export const FileVerifiedIcon = /* @__PURE__ */ createTerraIcon({
  icon: FileVerifiedIconData,
  displayName: 'FileVerifiedIcon',
});

const FileVideoCameraIconData = [
  ['path', { d: "M4.5 12V4C4.5 2.89543 5.39543 2 6.5 2H13.5L20.5 9V20C20.5 21.1046 19.6046 22 18.5 22H16.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M13.5 2V7C13.5 8.10457 14.3954 9 15.5 9H20.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M10 18V17C10 16.4477 9.55228 16 9 16H4.5C3.94772 16 3.5 16.4477 3.5 17V21C3.5 21.5523 3.94772 22 4.5 22H9C9.55228 22 10 21.5523 10 21V20M10 18V20M10 18L12.9146 16.5427C12.9708 16.5146 13.0327 16.5 13.0955 16.5C13.3189 16.5 13.5 16.6811 13.5 16.9045V21.0955C13.5 21.3189 13.3189 21.5 13.0955 21.5C13.0327 21.5 12.9708 21.4854 12.9146 21.4573L10 20", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const FileVideoCameraIcon = /* @__PURE__ */ createTerraIcon({
  icon: FileVideoCameraIconData,
  displayName: 'FileVideoCameraIcon',
});

const FileVideoIconData = [
  ['path', { d: "M19 13V9L12 2H5C3.89543 2 3 2.89543 3 4V20C3 21.1046 3.89543 22 5 22H9", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M12 2V7C12 8.10457 12.8954 9 14 9H19", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M18 19.5L21 21V17L18 18.5M18 19.5V18.5M18 19.5V21C18 21.5523 17.5523 22 17 22H13C12.4477 22 12 21.5523 12 21V17C12 16.4477 12.4477 16 13 16H17C17.5523 16 18 16.4477 18 17V18.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "2" }],
] as const;

export const FileVideoIcon = /* @__PURE__ */ createTerraIcon({
  icon: FileVideoIconData,
  displayName: 'FileVideoIcon',
});

const FileViewIconData = [
  ['path', { d: "M19 13V9L12 2H5C3.89543 2 3 2.89543 3 4V20C3 21.1046 3.89543 22 5 22H9", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M12 2V7C12 8.10457 12.8954 9 14 9H19", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M16 22C18.7614 22 21 19 21 19C21 19 18.7614 16 16 16C13.2386 16 11 19 11 19C11 19 13.2386 22 16 22Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M15.9922 19H16.0012", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round", key: "3" }],
] as const;

export const FileViewIcon = /* @__PURE__ */ createTerraIcon({
  icon: FileViewIconData,
  displayName: 'FileViewIcon',
});

const FileVolumeIconData = [
  ['path', { d: "M12.5 15.5C13.1491 16.2212 13.5 17.0985 13.5 18C13.5 18.9015 13.1491 19.7788 12.5 20.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M8.5 21.6298V14.3702C8.5 14.1657 8.33428 14 8.12984 14C8.04579 14 7.96424 14.0286 7.89861 14.0811L5.5 16H4.5C3.94772 16 3.5 16.4477 3.5 17V19C3.5 19.5523 3.94772 20 4.5 20H5.5L7.89861 21.9189C7.96424 21.9714 8.04579 22 8.12984 22C8.33428 22 8.5 21.8343 8.5 21.6298Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M4.5 12V4C4.5 2.89543 5.39543 2 6.5 2H13.5L20.5 9V20C20.5 21.1046 19.6046 22 18.5 22H16.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M13.5 2V7C13.5 8.10457 14.3954 9 15.5 9H20.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "3" }],
] as const;

export const FileVolumeIcon = /* @__PURE__ */ createTerraIcon({
  icon: FileVolumeIconData,
  displayName: 'FileVolumeIcon',
});

const FileXCornerIconData = [
  ['path', { d: "M11.5 22H5.5C4.39543 22 3.5 21.1046 3.5 20V4C3.5 2.89543 4.39543 2 5.5 2H12.5L19.5 9V13", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M12.5 2V7C12.5 8.10457 13.3954 9 14.5 9H19.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M20.4917 17L18 19.4958M18 19.4958L15.5 22M18 19.4958L20.5 22M18 19.4958L15.5083 17", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const FileXCornerIcon = /* @__PURE__ */ createTerraIcon({
  icon: FileXCornerIconData,
  displayName: 'FileXCornerIcon',
});

const FileXIconData = [
  ['path', { d: "M20 20V9L13 2H6C4.89543 2 4 2.89543 4 4V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M13 2V7C13 8.10457 13.8954 9 15 9H20", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M14.4834 13L11.9917 15.4958M11.9917 15.4958L9.49168 18M11.9917 15.4958L14.4917 18M11.9917 15.4958L9.5 13", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const FileXIcon = /* @__PURE__ */ createTerraIcon({
  icon: FileXIconData,
  displayName: 'FileXIcon',
});

const FileYenIconData = [
  ['path', { d: "M12 22.0015H5C3.89543 22.0015 3 21.1061 3 20.0015V9.81666C3 9.28552 3.21128 8.77619 3.58724 8.401L9.41585 2.58433C9.7908 2.21014 10.2989 1.99999 10.8286 1.99999H18C19.1046 1.99999 20 2.89542 20 3.99999V8.98703", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M3 9.00145H8C9.10457 9.00145 10 8.10602 10 7.00145V2.00145", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M15 13C15.2 13.9167 16.08 15.5 18 16.5M18 16.5C19.92 15.5 20.8 13.9167 21 13M18 16.5V22.0002M20.5 18.6827H15.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const FileYenIcon = /* @__PURE__ */ createTerraIcon({
  icon: FileYenIconData,
  displayName: 'FileYenIcon',
});

const FileZipIconData = [
  ['path', { d: "M4 22V4C4 2.89543 4.89543 2 6 2H13L20 9V20C20 21.1046 19.1046 22 18 22H14", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M13 2V7C13 8.10457 13.8954 9 15 9H20", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M7.5 5.5H7M10 7.5H9.5M7.5 9.5H7M10 11.5226H9.5M7.5 13.5H7", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M11 22V18.9999C11 17.8954 10.1046 16.9999 9 16.9999C7.89543 16.9999 7 17.8954 7 18.9999V22H11Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "3" }],
] as const;

export const FileZipIcon = /* @__PURE__ */ createTerraIcon({
  icon: FileZipIconData,
  displayName: 'FileZipIcon',
});

const Files01IconData = [
  ['path', { d: "M18.5 19H8.5C7.39543 19 6.5 18.1046 6.5 17V4C6.5 2.89543 7.39543 2 8.5 2H15.5L20.5 7V17C20.5 18.1046 19.6046 19 18.5 19Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M15.5 2.5V6C15.5 6.55228 15.9477 7 16.5 7H20", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M6.49964 5H5.49963C4.39507 5 3.49963 5.89543 3.49963 7L3.49963 20C3.49963 21.1046 4.39507 22 5.49963 22H15.5C16.6046 22 17.5 21.1046 17.5 20V19", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M10 11H14M10 15H17", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "3" }],
] as const;

export const Files01Icon = /* @__PURE__ */ createTerraIcon({
  icon: Files01IconData,
  displayName: 'Files01Icon',
});

const Files02IconData = [
  ['path', { d: "M18.5 5L8.5 5C7.39543 5 6.5 5.89543 6.5 7L6.5 20C6.5 21.1046 7.39543 22 8.5 22H14.6716C15.202 22 15.7107 21.7893 16.0858 21.4142L19.9142 17.5858C20.2893 17.2107 20.5 16.702 20.5 16.1716L20.5 7C20.5 5.89543 19.6046 5 18.5 5Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M15.5 21.5L15.5 18C15.5 17.4477 15.9477 17 16.5 17L20 17", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M6.5 19H5.5C4.39543 19 3.5 18.1046 3.5 17L3.5 4C3.5 2.89543 4.39543 2 5.5 2L15.5004 2C16.6049 2 17.5004 2.89543 17.5004 4V5.00003", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M10.5002 14L13.5002 14", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "3" }],
  ['path', { d: "M10.5002 10L16.5002 10", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "4" }],
] as const;

export const Files02Icon = /* @__PURE__ */ createTerraIcon({
  icon: Files02IconData,
  displayName: 'Files02Icon',
});

const Film01IconData = [
  ['path', { d: "M2.5 7H21.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M2.5 17H21.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M12 17L12 7", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M21.5 19.5V4.5C21.5 3.39543 20.6046 2.5 19.5 2.5H4.5C3.39543 2.5 2.5 3.39543 2.5 4.5V19.5C2.5 20.6046 3.39543 21.5 4.5 21.5H19.5C20.6046 21.5 21.5 20.6046 21.5 19.5Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "3" }],
  ['path', { d: "M8 7L8 3M16 7L16 3", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "4" }],
  ['path', { d: "M8 21L8 17M16 21L16 17", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "5" }],
] as const;

export const Film01Icon = /* @__PURE__ */ createTerraIcon({
  icon: Film01IconData,
  displayName: 'Film01Icon',
});

const Film02IconData = [
  ['path', { d: "M21.5 19.5V4.5C21.5 3.39543 20.6046 2.5 19.5 2.5H4.5C3.39543 2.5 2.5 3.39543 2.5 4.5V19.5C2.5 20.6046 3.39543 21.5 4.5 21.5H19.5C20.6046 21.5 21.5 20.6046 21.5 19.5Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M7 21.5L7 2.5M17 21.5L17 2.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M17 12L7 12", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M7 16L3 16M7 8L3 8", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "3" }],
  ['path', { d: "M21 16L17 16M21 8L17 8", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "4" }],
] as const;

export const Film02Icon = /* @__PURE__ */ createTerraIcon({
  icon: Film02IconData,
  displayName: 'Film02Icon',
});

const FilmRoll01IconData = [
  ['path', { d: "M4.50048 4.5H13.5005V22H4.50048V4.5Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M7.00048 4.5V3C7.00048 2.44772 7.44819 2 8.00048 2H10.0005C10.5528 2 11.0005 2.44772 11.0005 3V4.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M3.00048 4.5H15.0005", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M3.00048 22H15.0005", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "3" }],
  ['path', { d: "M13.5005 7.5L19.9995 7.50002C20.5518 7.50002 20.9995 7.94774 20.9995 8.50002V12.465C20.9995 12.7992 20.8326 13.1114 20.5545 13.2969L18.0005 15.0009L17.9998 17.0003C17.9997 17.5525 17.552 18 16.9998 18L13.5005 18", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "4" }],
] as const;

export const FilmRoll01Icon = /* @__PURE__ */ createTerraIcon({
  icon: FilmRoll01IconData,
  displayName: 'FilmRoll01Icon',
});

const FilmRoll02IconData = [
  ['circle', { cx: 10.5, cy: 10.5, r: 8.5, stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M10.4998 10.5H10.5075M14 7L13 8M8 13L7 14M14 14L13 13M8 8L7 7", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M10.5 19H20.5C21.3284 19 22 19.6716 22 20.5C22 21.3284 21.3284 22 20.5 22H15.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const FilmRoll02Icon = /* @__PURE__ */ createTerraIcon({
  icon: FilmRoll02IconData,
  displayName: 'FilmRoll02Icon',
});

const FilterAddIconData = [
  ['path', { d: "M20.4 7.5L20.6402 7.29985C20.8682 7.10985 21 6.8284 21 6.53162V4C21 3.44772 20.5523 3 20 3H4C3.44772 3 3 3.44772 3 4V6.53163C3 6.8284 3.13182 7.10985 3.35982 7.29985L8.69075 11.7423C8.88918 11.9077 9.01593 12.1434 9.04445 12.4001L9.84155 19.574C9.91841 20.2657 10.6607 20.6693 11.283 20.3578L13.5216 19.2373C13.8144 19.0907 14.0169 18.8101 14.0637 18.4859L14.3504 16.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M17.5 8V15M21 11.5H14", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const FilterAddIcon = /* @__PURE__ */ createTerraIcon({
  icon: FilterAddIconData,
  displayName: 'FilterAddIcon',
});

const FilterEditIconData = [
  ['path', { d: "M20 4.5V4C20 3.44772 19.5523 3 19 3H3C2.44772 3 2 3.44772 2 4V6.53163C2 6.8284 2.13182 7.10985 2.35982 7.29985L7.69075 11.7423C7.88918 11.9077 8.01593 12.1434 8.04445 12.4001L8.84155 19.574C8.91841 20.2657 9.66071 20.6693 10.283 20.3578L12.5216 19.2373C12.8144 19.0907 13.0169 18.8101 13.0637 18.4859L13.161 17.8121", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M14 12.5V15H16.5L22 9.5L19.5 7L14 12.5Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "1" }],
] as const;

export const FilterEditIcon = /* @__PURE__ */ createTerraIcon({
  icon: FilterEditIconData,
  displayName: 'FilterEditIcon',
});

const FilterHorizontalIconData = [
  ['path', { d: "M3.5 7H6", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M3.5 17H8.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M18 17L20.5 17", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M15.5 7L20.5 7", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "3" }],
  ['path', { d: "M11 4H7C6.44772 4 6 4.44772 6 5V9C6 9.55228 6.44772 10 7 10H11C11.5523 10 12 9.55228 12 9V5C12 4.44772 11.5523 4 11 4Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "4" }],
  ['path', { d: "M17 14H13C12.4477 14 12 14.4477 12 15V19C12 19.5523 12.4477 20 13 20H17C17.5523 20 18 19.5523 18 19V15C18 14.4477 17.5523 14 17 14Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "5" }],
] as const;

export const FilterHorizontalIcon = /* @__PURE__ */ createTerraIcon({
  icon: FilterHorizontalIconData,
  displayName: 'FilterHorizontalIcon',
});

const FilterMailCircleIconData = [
  ['path', { d: "M22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M8.5 12.5L15.5 12.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M10.5 16H13.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M7.5 9H16.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "3" }],
] as const;

export const FilterMailCircleIcon = /* @__PURE__ */ createTerraIcon({
  icon: FilterMailCircleIconData,
  displayName: 'FilterMailCircleIcon',
});

const FilterMailEditIconData = [
  ['path', { d: "M3 6H21", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M6 12H14", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M9 18H11", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M16.0071 17.5986L14 18L14.4014 15.9929C14.4367 15.8165 14.5234 15.6545 14.6506 15.5273L18.9111 11.2668C19.2668 10.9111 19.8437 10.9111 20.1995 11.2668L20.7332 11.8005C21.0889 12.1563 21.0889 12.7332 20.7332 13.0889L16.4727 17.3494C16.3455 17.4766 16.1835 17.5633 16.0071 17.5986Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "3" }],
] as const;

export const FilterMailEditIcon = /* @__PURE__ */ createTerraIcon({
  icon: FilterMailEditIconData,
  displayName: 'FilterMailEditIcon',
});

const FilterMailRemoveIconData = [
  ['path', { d: "M3 6H21", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M6 12H12", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M15 12L21 18M21 12L15 18", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M9 18H12", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "3" }],
] as const;

export const FilterMailRemoveIcon = /* @__PURE__ */ createTerraIcon({
  icon: FilterMailRemoveIconData,
  displayName: 'FilterMailRemoveIcon',
});

const FilterMailSquareIconData = [
  ['path', { d: "M8.50006 12H15.5001M10.5001 15.5H13.5001M7.50006 8.5H16.5001", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M19 3H5C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "1" }],
] as const;

export const FilterMailSquareIcon = /* @__PURE__ */ createTerraIcon({
  icon: FilterMailSquareIconData,
  displayName: 'FilterMailSquareIcon',
});

const FilterMailIconData = [
  ['path', { d: "M3 6H21", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M6 12H18", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M9 18H15", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const FilterMailIcon = /* @__PURE__ */ createTerraIcon({
  icon: FilterMailIconData,
  displayName: 'FilterMailIcon',
});

const FilterRemoveIconData = [
  ['path', { d: "M21 4.5V4C21 3.44772 20.5523 3 20 3H4C3.44772 3 3 3.44772 3 4V6.53163C3 6.8284 3.13182 7.10985 3.35982 7.29985L8.69075 11.7423C8.88918 11.9077 9.01593 12.1434 9.04445 12.4001L9.84155 19.574C9.91841 20.2657 10.6607 20.6693 11.283 20.3578L13.5216 19.2373C13.8144 19.0907 14.0169 18.8101 14.0637 18.4859L14.3504 16.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M21 7L15 13M21 13L15 7", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const FilterRemoveIcon = /* @__PURE__ */ createTerraIcon({
  icon: FilterRemoveIconData,
  displayName: 'FilterRemoveIcon',
});

const FilterResetIconData = [
  ['path', { d: "M21 4.5V4C21 3.44772 20.5523 3 20 3H4C3.44772 3 3 3.44772 3 4V6.53163C3 6.8284 3.13182 7.10985 3.35982 7.29985L8.69075 11.7423C8.88918 11.9077 9.01593 12.1434 9.04445 12.4001L9.84155 19.574C9.91841 20.2657 10.6607 20.6693 11.283 20.3578L13.5216 19.2373C13.8144 19.0907 14.0169 18.8101 14.0637 18.4859L14.3504 16.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M14 11.1316C14.2909 12.6698 15.7829 14 17.4086 14C19.3824 14 21 12.4294 21 10.4321C21 8.43487 19.3886 6.83617 17.4147 6.83617C16.0021 6.83617 15.001 7.50211 14 8.5L14.002 6.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const FilterResetIcon = /* @__PURE__ */ createTerraIcon({
  icon: FilterResetIconData,
  displayName: 'FilterResetIcon',
});

const FilterVerticalIconData = [
  ['path', { d: "M7 20.5L7 18", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M17 20.5L17 15.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M17 6L17 3.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M7 8.5L7 3.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "3" }],
  ['path', { d: "M19 6H15C14.4477 6 14 6.44772 14 7V11C14 11.5523 14.4477 12 15 12H19C19.5523 12 20 11.5523 20 11V7C20 6.44772 19.5523 6 19 6Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "4" }],
  ['path', { d: "M9 12H5C4.44772 12 4 12.4477 4 13V17C4 17.5523 4.44772 18 5 18H9C9.55228 18 10 17.5523 10 17V13C10 12.4477 9.55228 12 9 12Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "5" }],
] as const;

export const FilterVerticalIcon = /* @__PURE__ */ createTerraIcon({
  icon: FilterVerticalIconData,
  displayName: 'FilterVerticalIcon',
});

const FilterIconData = [
  ['path', { d: "M3 4V6.53163C3 6.8284 3.13182 7.10985 3.35982 7.29985L8.69075 11.7423C8.88918 11.9077 9.01593 12.1434 9.04445 12.4001L9.84155 19.574C9.91841 20.2657 10.6607 20.6693 11.283 20.3578L13.5216 19.2373C13.8144 19.0907 14.0169 18.8101 14.0637 18.4859L14.9452 12.3797C14.9805 12.1353 15.105 11.9125 15.2947 11.7544L20.6402 7.29985C20.8682 7.10985 21 6.8284 21 6.53163V4C21 3.44772 20.5523 3 20 3H4C3.44772 3 3 3.44772 3 4Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "0" }],
] as const;

export const FilterIcon = /* @__PURE__ */ createTerraIcon({
  icon: FilterIconData,
  displayName: 'FilterIcon',
});

const FingerAccessIconData = [
  ['path', { d: "M18 12C18 8.68628 15.3137 6 12 6C8.68628 6 6 8.68628 6 12C6 15.3136 7 17.5 8.99985 20", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M15 21C9.5 17.5 9 13.6568 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12C15 13.6569 16.3431 15 18 15C19.6569 15 21 13.6569 21 12C21 7.02942 16.9706 3 12 3C7.02942 3 3 7.02942 3 12C3 12.6874 3.07707 13.3568 3.22303 14", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M12 12C12.5 17 17.5 19 17.5 19", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const FingerAccessIcon = /* @__PURE__ */ createTerraIcon({
  icon: FingerAccessIconData,
  displayName: 'FingerAccessIcon',
});

const FingerPrintAddIconData = [
  ['path', { d: "M17.5 16.5V18M17.5 18V19.5M17.5 18H19M17.5 18H16M21.5 18C21.5 20.2091 19.7091 22 17.5 22C15.2909 22 13.5 20.2091 13.5 18C13.5 15.7909 15.2909 14 17.5 14C19.7091 14 21.5 15.7909 21.5 18Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M5.92857 20.6058C3.85602 19.1977 2.5 16.8583 2.5 14.2103V9.75757C2.5 8.57285 2.77144 7.44988 3.25704 6.44444M9.35714 21.9236C10.2589 22.0493 11.1494 22.0167 12 21.8493M17.7301 6.41803C15.636 2.12432 9.89955 0.664089 5.92857 3.36201M18.5 9.5V11M10.5 6C12.7091 6 14.5 7.8804 14.5 10.2M6.88493 8.4C6.63811 8.94555 6.5 9.55584 6.5 10.2V13.8C6.5 16.1196 8.29086 18 10.5 18C10.6693 18 10.8362 17.989 11 17.9675M10.5 10.5V13.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const FingerPrintAddIcon = /* @__PURE__ */ createTerraIcon({
  icon: FingerPrintAddIconData,
  displayName: 'FingerPrintAddIcon',
});

const FingerPrintCheckIconData = [
  ['path', { d: "M16.5303 17.4697C16.2374 17.1768 15.7626 17.1768 15.4697 17.4697C15.1768 17.7626 15.1768 18.2374 15.4697 18.5303L16.5303 17.4697ZM17 19L16.4697 19.5303C16.7626 19.8232 17.2374 19.8232 17.5303 19.5303L17 19ZM19.5303 17.5303C19.8232 17.2374 19.8232 16.7626 19.5303 16.4697C19.2374 16.1768 18.7626 16.1768 18.4697 16.4697L19.5303 17.5303ZM22.25 18C22.25 15.3766 20.1234 13.25 17.5 13.25V14.75C19.2949 14.75 20.75 16.2051 20.75 18H22.25ZM17.5 13.25C14.8766 13.25 12.75 15.3766 12.75 18H14.25C14.25 16.2051 15.7051 14.75 17.5 14.75V13.25ZM12.75 18C12.75 20.6234 14.8766 22.75 17.5 22.75V21.25C15.7051 21.25 14.25 19.7949 14.25 18H12.75ZM17.5 22.75C20.1234 22.75 22.25 20.6234 22.25 18H20.75C20.75 19.7949 19.2949 21.25 17.5 21.25V22.75ZM15.4697 18.5303L16.4697 19.5303L17.5303 18.4697L16.5303 17.4697L15.4697 18.5303ZM17.5303 19.5303L19.5303 17.5303L18.4697 16.4697L16.4697 18.4697L17.5303 19.5303Z", fill: "currentColor", key: "0" }],
  ['path', { d: "M5.92857 20.6058C3.85602 19.1977 2.5 16.8583 2.5 14.2103V9.75757C2.5 8.57285 2.77144 7.44988 3.25704 6.44444M9.35714 21.9236C10.2589 22.0493 11.1494 22.0167 12 21.8493M17.7301 6.41803C15.636 2.12432 9.89955 0.664089 5.92857 3.36201M18.5 9.5V11M10.5 6C12.7091 6 14.5 7.8804 14.5 10.2M6.88493 8.4C6.63811 8.94555 6.5 9.55584 6.5 10.2V13.8C6.5 16.1196 8.29086 18 10.5 18C10.6693 18 10.8362 17.989 11 17.9675M10.5 10.5V13.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const FingerPrintCheckIcon = /* @__PURE__ */ createTerraIcon({
  icon: FingerPrintCheckIconData,
  displayName: 'FingerPrintCheckIcon',
});

const FingerPrintMinusIconData = [
  ['path', { d: "M5.92857 20.6058C3.85602 19.1977 2.5 16.8583 2.5 14.2103V9.75757C2.5 8.57285 2.77144 7.44988 3.25704 6.44444M9.35714 21.9236C10.2589 22.0493 11.1494 22.0167 12 21.8493M17.7301 6.41803C15.636 2.12432 9.89955 0.664089 5.92857 3.36201M18.5 9.5V11M10.5 6C12.7091 6 14.5 7.8804 14.5 10.2M6.88493 8.4C6.63811 8.94555 6.5 9.55584 6.5 10.2V13.8C6.5 16.1196 8.29086 18 10.5 18C10.6693 18 10.8362 17.989 11 17.9675M10.5 10.5V13.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M18.5 18H16.5M21.5 18C21.5 20.2091 19.7091 22 17.5 22C15.2909 22 13.5 20.2091 13.5 18C13.5 15.7909 15.2909 14 17.5 14C19.7091 14 21.5 15.7909 21.5 18Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const FingerPrintMinusIcon = /* @__PURE__ */ createTerraIcon({
  icon: FingerPrintMinusIconData,
  displayName: 'FingerPrintMinusIcon',
});

const FingerPrintRemoveIconData = [
  ['path', { d: "M16.5 17L17.4983 18M17.4983 18L18.5 19M17.4983 18L18.5 17M17.4983 18L16.5 19M21.5 18C21.5 20.2091 19.7091 22 17.5 22C15.2909 22 13.5 20.2091 13.5 18C13.5 15.7909 15.2909 14 17.5 14C19.7091 14 21.5 15.7909 21.5 18Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M5.92857 20.6058C3.85602 19.1977 2.5 16.8583 2.5 14.2103V9.75757C2.5 8.57285 2.77144 7.44988 3.25704 6.44444M9.35714 21.9236C10.2589 22.0493 11.1494 22.0167 12 21.8493M17.7301 6.41803C15.636 2.12432 9.89955 0.664089 5.92857 3.36201M18.5 9.5V11M10.5 6C12.7091 6 14.5 7.8804 14.5 10.2M6.88493 8.4C6.63811 8.94555 6.5 9.55584 6.5 10.2V13.8C6.5 16.1196 8.29086 18 10.5 18C10.6693 18 10.8362 17.989 11 17.9675M10.5 10.5V13.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const FingerPrintRemoveIcon = /* @__PURE__ */ createTerraIcon({
  icon: FingerPrintRemoveIconData,
  displayName: 'FingerPrintRemoveIcon',
});

const FingerPrintScanIconData = [
  ['path', { d: "M8 2.5H4.5C3.39543 2.5 2.5 3.39543 2.5 4.5V8M16 2.5H19.5C20.6046 2.5 21.5 3.39543 21.5 4.5V8M16 21.5H19.5C20.6046 21.5 21.5 20.6046 21.5 19.5V16M8 21.5H4.5C3.39543 21.5 2.5 20.6046 2.5 19.5V16", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M16.5146 8.9424C16.8317 9.51789 17 10.1516 17 10.7991V13.6806C17 14.8151 16.4641 15.9327 15.5355 16.7349C14.6069 17.5371 13.3132 18 12 18M7 11.2783V13.6809C6.9995 14.9393 7.65372 16.1769 8.801 17.002M14.5 6.57868C13.3516 6.00592 11.9869 5.8507 10.706 6.14718C9.42517 6.44365 8.33309 7.16753 7.67003 8.15958M13.6665 11.4782V10.5912C13.6765 9.95465 13.1333 9.38163 12.3951 9.23077M10.3335 11.8567V13.3805C10.3281 13.6611 10.4265 13.9363 10.6156 14.1694C11.2056 14.897 12.5258 14.9802 13.24 14.3226", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const FingerPrintScanIcon = /* @__PURE__ */ createTerraIcon({
  icon: FingerPrintScanIconData,
  displayName: 'FingerPrintScanIcon',
});

const FingerPrintIconData = [
  ['path', { d: "M7.42857 3.36201C11.3996 0.664089 17.136 2.12432 19.2301 6.41803M10.8571 21.9236C15.5839 22.5822 20 18.8952 20 14.2103V10.3333M7.42857 20.6058C5.35602 19.1977 4 16.8583 4 14.2103V9.75757C4 8.57285 4.27144 7.44988 4.75704 6.44444", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M16 13.8C16 16.1196 14.2091 18 12 18C9.79086 18 8 16.1196 8 13.8V10.2C8 9.55584 8.13811 8.94555 8.38493 8.4M12 6C14.2091 6 16 7.8804 16 10.2", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M12 10.5L12 13.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const FingerPrintIcon = /* @__PURE__ */ createTerraIcon({
  icon: FingerPrintIconData,
  displayName: 'FingerPrintIcon',
});

const FingerprintScanIconData = [
  ['path', { d: "M16.5 15.5V11C16.5 8.51472 14.4853 6.5 12 6.5C9.51472 6.5 7.5 8.51472 7.5 11V15.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M13.5 12.5V11C13.5 10.1716 12.8284 9.5 12 9.5C11.1716 9.5 10.5 10.1716 10.5 11V16.5M13.5 15.5V17.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M15 2.5H19.5C20.6046 2.5 21.5 3.39543 21.5 4.5V9M9 2.5H4.5C3.39543 2.5 2.5 3.39543 2.5 4.5V9M9 21.5H4.5C3.39543 21.5 2.5 20.6046 2.5 19.5V15M15 21.5H19.5C20.6046 21.5 21.5 20.6046 21.5 19.5V15", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const FingerprintScanIcon = /* @__PURE__ */ createTerraIcon({
  icon: FingerprintScanIconData,
  displayName: 'FingerprintScanIcon',
});

const FinsIconData = [
  ['path', { d: "M8.4711 19.9634C10.8851 15.8356 11.4912 7.3524 10.6271 3.69484L9.7126 4.14737C9.29543 4.35381 8.79099 4.24334 8.4433 3.9339C7.96581 3.50892 7.23951 3 6.49953 3C5.75975 3 5.03396 3.50865 4.55673 3.93356C4.209 4.24315 3.70444 4.35376 3.28714 4.14729L2.3727 3.69484C1.5086 7.35252 2.11482 15.8358 4.52945 19.9634C5.33792 21.3455 7.66279 21.3456 8.4711 19.9634Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M15.5287 4.03657C13.1147 8.1644 12.5086 16.6476 13.3727 20.3052L14.2872 19.8527C14.7044 19.6462 15.2089 19.7567 15.5565 20.0661C16.0341 20.4911 16.7604 21 17.5003 21C18.2401 21 18.9659 20.4914 19.4431 20.0665C19.7908 19.7569 20.2954 19.6463 20.7127 19.8527L21.6271 20.3052C22.4912 16.6475 21.885 8.16425 19.4704 4.03657C18.6619 2.65454 16.337 2.6544 15.5287 4.03657Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M6.5 17V16", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M17.5 8V7", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "3" }],
] as const;

export const FinsIcon = /* @__PURE__ */ createTerraIcon({
  icon: FinsIconData,
  displayName: 'FinsIcon',
});

const Fire02IconData = [
  ['path', { d: "M12 22C16.1421 22 19.5 18.6421 19.5 14.5C19.5 13.5 19.5 11.5 17.5 9C17.5 9 17.4004 11.8536 15.4262 11.4408C12.2331 10.7732 16.3551 4.50296 10.5 2C10.5 7 4.5 8.5 4.5 14.5C4.5 18.6421 7.85786 22 12 22Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M12 19.0011C13.933 19.0011 15.5 16.9864 15.5 14.5011C12.3 15.7011 11.1667 12.9379 11 11C9.55426 11.5532 8.5 13.8256 8.5 15C8.5 17.4853 10.067 19.0011 12 19.0011Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "1" }],
] as const;

export const Fire02Icon = /* @__PURE__ */ createTerraIcon({
  icon: Fire02IconData,
  displayName: 'Fire02Icon',
});

const Fire03IconData = [
  ['path', { d: "M12 21.5008C16.4183 21.5008 20 17.9191 20 13.5008C20 10.5397 18.3912 6.60684 16 4.33478L14 6.99915L10.5 2.49915C7 4.99915 4 9.59526 4 13.5008C4 17.9191 7.58172 21.5008 12 21.5008Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M12 18.4991C14.2091 18.4991 16 16.4844 16 13.9991C16 13.2081 15.8186 12.4648 15.5 11.8189L13.5 13.4991L10.5 9.49811C9.5 10.4981 8 12.1106 8 13.9991C8 16.4844 9.79086 18.4991 12 18.4991Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "1" }],
] as const;

export const Fire03Icon = /* @__PURE__ */ createTerraIcon({
  icon: Fire03IconData,
  displayName: 'Fire03Icon',
});

const FireExtinguisherIconData = [
  ['path', { d: "M10 20V10C10 7.79086 11.7909 6 14 6C16.2091 6 18 7.79086 18 10V20C18 21.1046 17.1046 22 16 22H12C10.8954 22 10 21.1046 10 20Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M10 13H18", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M12 6V3C12 2.44772 12.4477 2 13 2H15C15.5523 2 16 2.44772 16 3V6", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M12 3H11C8.23855 3 5.99997 5.23858 5.99997 8V14C5.99997 15.1046 5.10454 16 3.99997 16", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "3" }],
  ['path', { d: "M16 3H20", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "4" }],
] as const;

export const FireExtinguisherIcon = /* @__PURE__ */ createTerraIcon({
  icon: FireExtinguisherIconData,
  displayName: 'FireExtinguisherIcon',
});

const FirePitIconData = [
  ['path', { d: "M8.49989 2C16.0002 2.5 14.9999 11 14.9999 11C14.9999 11 17.4349 10.5 17.9999 8.5C18.585 9.36302 18.9763 10.8815 19.0003 12.5C19.0459 15.57 17.5498 19 12.0002 19C7.56119 19 5.00018 15.5 5.00018 13C5.00018 11 5.51966 9.75114 6.67361 8.5C9.90182 4.99991 8.49989 2 8.49989 2Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M9.59855 15C7.6593 12 11.0529 9 11.0529 9C10.7296 10.1667 10.471 12.7 12.0223 13.5C12.9918 14 14.4461 13 14.4461 13C14.4461 13 14.9309 15.5 12.9918 16", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M7 20.5C7 21.3284 6.32843 22 5.5 22C4.67157 22 4 21.3284 4 20.5C4 19.6716 4.67157 19 5.5 19C6.32843 19 7 19.6716 7 20.5Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M5.5 19H18.5C19.3284 19 20 19.6716 20 20.5C20 21.3284 19.3284 22 18.5 22H5.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "3" }],
] as const;

export const FirePitIcon = /* @__PURE__ */ createTerraIcon({
  icon: FirePitIconData,
  displayName: 'FirePitIcon',
});

const FireSecurityIconData = [
  ['path', { d: "M15.5 16.5H14V22H21V16.5H19.5M15.5 16.5V15C15.5 13.8954 16.3954 13 17.5 13C18.6046 13 19.5 13.8954 19.5 15V16.5M15.5 16.5H19.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M10.945 22C6.55711 22 3 18.4183 3 14C3 11.9162 3.95829 9.83244 5.20924 8C5.46596 9.5 6.57526 12.4 8.95878 12C6.33498 6.5 10.945 2 10.945 2C10.945 2 11.4416 5.5 15.9107 9C16.3245 9.32407 16.6857 9.65805 17 10", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const FireSecurityIcon = /* @__PURE__ */ createTerraIcon({
  icon: FireSecurityIconData,
  displayName: 'FireSecurityIcon',
});

const FireIconData = [
  ['path', { d: "M4.96771 10.6515C7.89633 7.16666 10.0038 5.18111 10.874 2C15.3631 4.49772 20.8942 10.8567 20.4778 15.5826C20.1445 19.3654 17.3689 21.1971 13.9894 22C13.9894 22 16.1452 19.0346 16.5481 16.7813C16.9153 13.087 14.2322 10.6672 12.9207 10.017C12.9207 10.017 13.742 13.5002 11.9162 15.5092C10.8491 12.0355 8.40044 12.0141 8.40044 12.0141C9.40493 14.5106 7.17338 15.5699 6.9285 17.2908C6.43127 20.7851 8.98142 22 8.98142 22C2.35624 19.6629 2.71904 13.0012 4.96771 10.6515Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "0" }],
] as const;

export const FireIcon = /* @__PURE__ */ createTerraIcon({
  icon: FireIconData,
  displayName: 'FireIcon',
});

const FirewallIconData = [
  ['path', { d: "M20 14H4C2.89543 14 2 14.8954 2 16V20C2 21.1046 2.89543 22 4 22H20C21.1046 22 22 21.1046 22 20L22 16C22 14.8954 21.1046 14 20 14Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M2 18H22", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M12 18L12 14M7 22V18M17 22L17 18", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M19 11C19 10 17.9809 8.63931 16.499 7.6C12.5064 4.8 12.0628 2 12.0628 2C12.0628 2 7.94433 5.6 10.2883 10C8.15899 10.32 7.16797 8 6.93863 6.8C5.95522 8.08998 4.96435 9 5.00093 11", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "3" }],
] as const;

export const FirewallIcon = /* @__PURE__ */ createTerraIcon({
  icon: FirewallIconData,
  displayName: 'FirewallIcon',
});

const FireworksIconData = [
  ['path', { d: "M19 18C17.5 12.5 12 11 12 11C12 11 8 14.5 8 21", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M2 10.0249C3.33333 9.01472 7.2 7.80245 12 11.0352C13.1667 9.35033 16.8 6.38511 22 8.00281", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M15 5C14 5.66667 12 7.8 12 11C11.6667 9.33333 10 5.6 6 4", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M6 14C6.98663 13 9.55185 11 11.9198 11C12.9064 12.1667 13.8069 14 13.3997 18", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "3" }],
  ['path', { d: "M3.15 3.1H3.1M3.2 3.1C3.2 3.15523 3.15523 3.2 3.1 3.2C3.04477 3.2 3 3.15523 3 3.1C3 3.04477 3.04477 3 3.1 3C3.15523 3 3.2 3.04477 3.2 3.1Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "4" }],
  ['path', { d: "M16.9508 3.1H16.9008M17.0008 3.1C17.0008 3.15523 16.956 3.2 16.9008 3.2C16.8456 3.2 16.8008 3.15523 16.8008 3.1C16.8008 3.04477 16.8456 3 16.9008 3C16.956 3 17.0008 3.04477 17.0008 3.1Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "5" }],
  ['path', { d: "M20.5504 12.5014H20.5004M20.6004 12.5014C20.6004 12.5566 20.5556 12.6014 20.5004 12.6014C20.4452 12.6014 20.4004 12.5566 20.4004 12.5014C20.4004 12.4461 20.4452 12.4014 20.5004 12.4014C20.5556 12.4014 20.6004 12.4461 20.6004 12.5014Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "6" }],
  ['path', { d: "M13.0345 20.9H12.9845M13.0845 20.9C13.0845 20.9552 13.0398 21 12.9845 21C12.9293 21 12.8845 20.9552 12.8845 20.9C12.8845 20.8448 12.9293 20.8 12.9845 20.8C13.0398 20.8 13.0845 20.8448 13.0845 20.9Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "7" }],
  ['path', { d: "M4.15 15.9H4.1M4.2 15.9C4.2 15.9552 4.15523 16 4.1 16C4.04477 16 4 15.9552 4 15.9C4 15.8448 4.04477 15.8 4.1 15.8C4.15523 15.8 4.2 15.8448 4.2 15.9Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "8" }],
  ['path', { d: "M17.9508 11.1H17.9008M18.0008 11.1C18.0008 11.1552 17.956 11.2 17.9008 11.2C17.8456 11.2 17.8008 11.1552 17.8008 11.1C17.8008 11.0448 17.8456 11 17.9008 11C17.956 11 18.0008 11.0448 18.0008 11.1Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "9" }],
  ['path', { d: "M11.0504 4.1H11.0004M11.1004 4.1C11.1004 4.15523 11.0556 4.2 11.0004 4.2C10.9452 4.2 10.9004 4.15523 10.9004 4.1C10.9004 4.04477 10.9452 4 11.0004 4C11.0556 4 11.1004 4.04477 11.1004 4.1Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "10" }],
] as const;

export const FireworksIcon = /* @__PURE__ */ createTerraIcon({
  icon: FireworksIconData,
  displayName: 'FireworksIcon',
});

const FirstAidKitIconData = [
  ['path', { d: "M4 21H20C21.1046 21 22 20.1046 22 19V8.00035C22 6.89579 21.1046 6.00037 20 6.00035L4.00004 6.00004C2.89545 6.00002 2 6.89545 2 8.00004V19C2 20.1046 2.89543 21 4 21Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M7 6V4C7 3.44772 7.44772 3 8 3H16C16.5523 3 17 3.44771 17 4V5.99992", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M8.5 13.5H15.5M12 10V17", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const FirstAidKitIcon = /* @__PURE__ */ createTerraIcon({
  icon: FirstAidKitIconData,
  displayName: 'FirstAidKitIcon',
});

const FishFoodIconData = [
  ['path', { d: "M11 16.0418C11.4635 16.1947 11.9076 16.3708 12.3099 16.6525M12.3099 16.6525C13.3507 17.381 14 18.6919 14 20C11.083 19.9871 9.65844 19.4932 9.1094 18.6782L8 16.8568C5.50848 16.3537 3.21828 14.7625 2 12.0833C5 5.48589 14.5 5.48589 17.5 12.0833M12.3099 16.6525C14.4801 15.9922 16.4151 14.4692 17.5 12.0833M12.3099 7.5142C13.3507 6.78564 14 5.30802 14 3.99995C14 3.99995 9.69172 4.62406 9.1094 5.48846L8 7.30981M17.5 12.0833C17.8333 11.4236 19.6 9.11447 22 9.11447C21.1667 9.93915 19.8 13.0729 21 15.0522C19.8 15.0522 18 12.7431 17.5 12.0833Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M6.125 12H6M6.25 12C6.25 12.138 6.13807 12.25 6 12.25C5.86193 12.25 5.75 12.138 5.75 12C5.75 11.8619 5.86193 11.75 6 11.75C6.13807 11.75 6.25 11.8619 6.25 12Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", key: "1" }],
] as const;

export const FishFoodIcon = /* @__PURE__ */ createTerraIcon({
  icon: FishFoodIconData,
  displayName: 'FishFoodIcon',
});

const FishOffIconData = [
  ['path', { d: "M6 12V11.875M6.25 12C6.25 12.1381 6.13807 12.25 6 12.25C5.86193 12.25 5.75 12.1381 5.75 12C5.75 11.8619 5.86193 11.75 6 11.75C6.13807 11.75 6.25 11.8619 6.25 12Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M11 16.0418C11.4635 16.1947 11.9076 16.3709 12.3099 16.6525M12.3099 16.6525C13.3507 17.3811 14 18.692 14 20C11.083 19.9871 9.65844 19.4933 9.1094 18.6783L8 16.8569C5.50848 16.3537 3.21828 14.7625 2 12.0834C3.12668 9.60563 5.17014 8.05844 7.44178 7.44178M12.3099 16.6525C13.3298 16.3422 14.2978 15.8414 15.15 15.15M17.5 12.0834C17.8333 11.4236 19.6 9.11452 22 9.11452C21.1667 9.9392 19.8 13.073 21 15.0522C19.8 15.0522 18 12.7431 17.5 12.0834ZM17.5 12.0834C16.4658 9.80892 14.659 8.31858 12.6124 7.61235C13.6531 6.88379 14 5.30806 14 4C14 4 11.3856 4.37872 9.95474 4.95474", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M2 2L22 22", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const FishOffIcon = /* @__PURE__ */ createTerraIcon({
  icon: FishOffIconData,
  displayName: 'FishOffIcon',
});

const FishSymbolIconData = [
  ['path', { d: "M3 16.0455C4.09676 16.2648 5.63537 16.5182 7.34198 16.658M7.34198 16.658C11.1422 16.9694 15.7753 16.7182 18.2175 14.276C21.7564 10.737 21.0487 5.78251 20.6948 3.30524C18.2175 2.95135 13.263 2.24356 9.72401 5.78251C7.28181 8.2247 7.03055 12.8578 7.34198 16.658ZM7.34198 16.658C7.48184 18.3646 7.73518 19.9032 7.95453 21M11.1396 5.07472C11.1677 6.82198 12.025 8.79129 13.6169 10.3831C15.2087 11.975 17.178 12.8323 18.9253 12.8604", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M15.5 6.5V6.375M15.75 6.5C15.75 6.63807 15.6381 6.75 15.5 6.75C15.3619 6.75 15.25 6.63807 15.25 6.5C15.25 6.36193 15.3619 6.25 15.5 6.25C15.6381 6.25 15.75 6.36193 15.75 6.5Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const FishSymbolIcon = /* @__PURE__ */ createTerraIcon({
  icon: FishSymbolIconData,
  displayName: 'FishSymbolIcon',
});

const FishingHookIconData = [
  ['circle', { cx: 7, cy: 8, r: 2, stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M7 6V2", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M7 10V16C7 19.3137 9.68629 22 13 22C16.3137 22 19 19.3137 19 16V11L17 13", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const FishingHookIcon = /* @__PURE__ */ createTerraIcon({
  icon: FishingHookIconData,
  displayName: 'FishingHookIcon',
});

const FitToScreenIconData = [
  ['path', { d: "M3 4V20", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M21 4V20", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M15 9L18 12L15 15M9 9L6 12L9 15M6.5 12H17.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const FitToScreenIcon = /* @__PURE__ */ createTerraIcon({
  icon: FitToScreenIconData,
  displayName: 'FitToScreenIcon',
});

const FiveCircleIconData = [
  ['path', { d: "M9 15C9 15 9.5 17 12 17C13.6569 17 15 15.7949 15 14C15 12.2051 13.6569 11 12 11C10.3431 11 9 12 9 12L10 7H15", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const FiveCircleIcon = /* @__PURE__ */ createTerraIcon({
  icon: FiveCircleIconData,
  displayName: 'FiveCircleIcon',
});

const FiveSquareIconData = [
  ['path', { d: "M4.5 21.5L19.5 21.5C20.6046 21.5 21.5 20.6046 21.5 19.5V4.5C21.5 3.39543 20.6046 2.5 19.5 2.5H4.5C3.39543 2.5 2.5 3.39543 2.5 4.5V19.5C2.5 20.6046 3.39543 21.5 4.5 21.5Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M9 15C9 15 9.5 17 12 17C13.6569 17 15 15.7949 15 14C15 12.2051 13.6569 11 12 11C10.3431 11 9 12 9 12L10 7H15", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const FiveSquareIcon = /* @__PURE__ */ createTerraIcon({
  icon: FiveSquareIconData,
  displayName: 'FiveSquareIcon',
});

const FiverrIconData = [
  ['path', { d: "M6 8H3V12H6V22H10.5V12H15V22H20V8H11V7C11 6.17157 11.6716 5.5 12.5 5.5H15V2H11C8.23858 2 6 4.23858 6 7V8Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
] as const;

export const FiverrIcon = /* @__PURE__ */ createTerraIcon({
  icon: FiverrIconData,
  displayName: 'FiverrIcon',
});

const Flag01IconData = [
  ['path', { d: "M5 20.9971V16.0042M5 16.0042L5 3.01223C5 3.00505 5.00734 3.00021 5.01394 3.00304L18.4058 8.74076C18.6405 8.84132 18.6502 9.17046 18.4219 9.28477L5 16.0042Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
] as const;

export const Flag01Icon = /* @__PURE__ */ createTerraIcon({
  icon: Flag01IconData,
  displayName: 'Flag01Icon',
});

const Flag02IconData = [
  ['path', { d: "M4 14L4 21", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M11.7576 3.83892C8.45236 2.12985 5.29699 3.39729 4 4.42024V14.8254C4.9697 13.7112 7.87879 11.9841 11.7576 13.9897C15.224 15.7821 18.6044 14.7976 20 14.0232V4.00813C17.3096 5.2316 14.4173 5.21419 11.7576 3.83892Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const Flag02Icon = /* @__PURE__ */ createTerraIcon({
  icon: Flag02IconData,
  displayName: 'Flag02Icon',
});

const Flag03IconData = [
  ['path', { d: "M4 21V8", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M4.00609 14.9977C4.00057 14.9977 3.99609 14.9932 3.99609 14.9877M3.99609 14.9877V3H19.9999L15.9826 8.99775L20 15L3.99609 14.9877Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "1" }],
] as const;

export const Flag03Icon = /* @__PURE__ */ createTerraIcon({
  icon: Flag03IconData,
  displayName: 'Flag03Icon',
});

const FlameKindlingIconData = [
  ['path', { d: "M12 15C14.7614 15 17 12.8174 17 10.125C17 9.475 17 8.175 15.6667 6.55C15.6667 6.55 15.6003 8.40484 14.2842 8.13653C12.1554 7.70256 14.9034 3.62692 11 2C11 5.25 7 6.225 7 10.125C7 12.8174 9.23858 15 12 15Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M4 22L20 17", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M20 22L3.99997 17", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const FlameKindlingIcon = /* @__PURE__ */ createTerraIcon({
  icon: FlameKindlingIconData,
  displayName: 'FlameKindlingIcon',
});

const FlashOffIconData = [
  ['path', { d: "M10 12.9998H4.5L8.5 8.5M14 10.985V2L10.1136 6.5M14.0008 11.0002H19.5008L17.5 13.5M10.0008 13.015V22L15.5 15.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M2 2L22 22", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", key: "1" }],
] as const;

export const FlashOffIcon = /* @__PURE__ */ createTerraIcon({
  icon: FlashOffIconData,
  displayName: 'FlashOffIcon',
});

const FlashIconData = [
  ['path', { d: "M9.9996 12.9998H4.4996L13.9996 2V10.985M14.0004 11.0002H19.5004L10.0004 22V13.015", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
] as const;

export const FlashIcon = /* @__PURE__ */ createTerraIcon({
  icon: FlashIconData,
  displayName: 'FlashIcon',
});

const FlashlightIconData = [
  ['path', { d: "M16 3H8C7.44772 3 7 3.44772 7 4V6C7 7.04416 7.27249 8.07025 7.79054 8.97683L9 11V20C9 20.5523 9.44772 21 10 21H14C14.5523 21 15 20.5523 15 20V11L16.2095 8.97683C16.7275 8.07025 17 7.04416 17 6V4C17 3.44772 16.5523 3 16 3Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M7 6H17", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M12 13V15", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const FlashlightIcon = /* @__PURE__ */ createTerraIcon({
  icon: FlashlightIconData,
  displayName: 'FlashlightIcon',
});

const FlaticonIconData = [
  ['path', { d: "M16 3L13.5 7H6.5L8.5 10H12L10.5 13L14 19L11 21L2 6L5 3H16Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M22 6L19 3L13.5 12.5L16 16.5L22 6Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const FlaticonIcon = /* @__PURE__ */ createTerraIcon({
  icon: FlaticonIconData,
  displayName: 'FlaticonIcon',
});

const FlickrIconData = [
  ['circle', { cx: 12, cy: 12, r: 10, stroke: "currentColor", strokeWidth: 1.5, key: "0" }],
  ['path', { d: "M10.5 12C10.5 13.3807 9.38071 14.5 8 14.5C6.61929 14.5 5.5 13.3807 5.5 12C5.5 10.6193 6.61929 9.5 8 9.5C9.38071 9.5 10.5 10.6193 10.5 12Z", stroke: "currentColor", strokeWidth: 1.5, key: "1" }],
  ['path', { d: "M18.5 12C18.5 13.3807 17.3807 14.5 16 14.5C14.6193 14.5 13.5 13.3807 13.5 12C13.5 10.6193 14.6193 9.5 16 9.5C17.3807 9.5 18.5 10.6193 18.5 12Z", stroke: "currentColor", strokeWidth: 1.5, key: "2" }],
] as const;

export const FlickrIcon = /* @__PURE__ */ createTerraIcon({
  icon: FlickrIconData,
  displayName: 'FlickrIcon',
});

const FlimSlateIconData = [
  ['path', { d: "M21.5 11H4V20C4 21.1046 4.89543 22 6 22H19.5C20.6046 22 21.5 21.1046 21.5 20V11Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M3.99827 11L20.5 7L19.5604 3.86797C19.2486 2.82879 18.1652 2.22767 17.1185 2.51314L4.53899 5.94391C3.43154 6.24594 2.80502 7.41612 3.16764 8.50524L3.99827 11Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M8 10L9 4.5", stroke: "currentColor", strokeWidth: 1.5, key: "2" }],
  ['path', { d: "M14 8.5L15 3", stroke: "currentColor", strokeWidth: 1.5, key: "3" }],
  ['path', { d: "M8 18H12", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", key: "4" }],
] as const;

export const FlimSlateIcon = /* @__PURE__ */ createTerraIcon({
  icon: FlimSlateIconData,
  displayName: 'FlimSlateIcon',
});

const FlipBottomIconData = [
  ['path', { d: "M2.99997 8.99997L2.99997 7.99997M2.99997 4.99997C2.99997 3.34312 4.34312 1.99997 5.99997 1.99997M21 8.99997V7.99997M21 4.99997C21 3.34312 19.6568 1.99997 18 1.99997M9.99997 1.99997L14 1.99997", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M2.99997 13C2.99997 12.4477 3.44768 12 3.99997 12L20 12C20.5523 12 21 12.4477 21 13V19C21 20.6568 19.6568 22 18 22H5.99997C4.34312 22 2.99997 20.6568 2.99997 19L2.99997 13Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "1" }],
] as const;

export const FlipBottomIcon = /* @__PURE__ */ createTerraIcon({
  icon: FlipBottomIconData,
  displayName: 'FlipBottomIcon',
});

const FlipHorizontalIconData = [
  ['path', { d: "M2 15.0568C2 15.8702 2.91937 16.3433 3.58124 15.8705L7.86077 12.8137C8.41912 12.4149 8.41912 11.5851 7.86077 11.1863L3.58124 8.12946C2.91937 7.65669 2 8.12982 2 8.94319L2 15.0568Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M22 15.0568C22 15.8702 21.0806 16.3433 20.4188 15.8705L16.1392 12.8137C15.5809 12.4149 15.5809 11.5851 16.1392 11.1863L20.4188 8.12946C21.0806 7.65669 22 8.12982 22 8.94319V15.0568Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M12.002 14V10M12.002 6.5V3M12.002 21V17.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", key: "2" }],
] as const;

export const FlipHorizontalIcon = /* @__PURE__ */ createTerraIcon({
  icon: FlipHorizontalIconData,
  displayName: 'FlipHorizontalIcon',
});

const FlipLeftIconData = [
  ['path', { d: "M12 4C12 3.44772 12.4477 3 13 3H19C20.6569 3 22 4.34315 22 6V18C22 19.6569 20.6569 21 19 21H13C12.4477 21 12 20.5523 12 20V4Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M9 3H8M5 3C3.34315 3 2 4.34315 2 6M9 21H8M5 21C3.34315 21 2 19.6569 2 18M2 10V14", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const FlipLeftIcon = /* @__PURE__ */ createTerraIcon({
  icon: FlipLeftIconData,
  displayName: 'FlipLeftIcon',
});

const FlipPhoneIconData = [
  ['path', { d: "M18.5 5C18.5 4.44772 18.0523 4 17.5 4H6.5C5.94772 4 5.5 4.44772 5.5 5V15.1176C5.5 18.9187 8.41015 22 12 22C15.5899 22 18.5 18.9187 18.5 15.1176V5Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M15.5 7H8.5V10.5C8.5 11.3284 9.17157 12 10 12H14C14.8284 12 15.5 11.3284 15.5 10.5V7Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M11 18H13", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M5.5 4.5L5.5 2", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "3" }],
] as const;

export const FlipPhoneIcon = /* @__PURE__ */ createTerraIcon({
  icon: FlipPhoneIconData,
  displayName: 'FlipPhoneIcon',
});

const FlipRightIconData = [
  ['path', { d: "M15 3H16M19 3C20.6569 3 22 4.34315 22 6M15 21H16M19 21C20.6569 21 22 19.6569 22 18M22 10V14", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M2 6C2 4.34315 3.34315 3 5 3H11C11.5523 3 12 3.44772 12 4V20C12 20.5523 11.5523 21 11 21H5C3.34315 21 2 19.6569 2 18V6Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "1" }],
] as const;

export const FlipRightIcon = /* @__PURE__ */ createTerraIcon({
  icon: FlipRightIconData,
  displayName: 'FlipRightIcon',
});

const FlipTopIconData = [
  ['path', { d: "M3 15L3 16M3 19C3 20.6569 4.34315 22 6 22M21 15V16M21 19C21 20.6569 19.6569 22 18 22M10 22L14 22", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M3 5C3 3.34315 4.34315 2 6 2L18 2C19.6569 2 21 3.34315 21 5V11C21 11.5523 20.5523 12 20 12L4 12C3.44772 12 3 11.5523 3 11L3 5Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "1" }],
] as const;

export const FlipTopIcon = /* @__PURE__ */ createTerraIcon({
  icon: FlipTopIconData,
  displayName: 'FlipTopIcon',
});

const FlipVerticalIconData = [
  ['path', { d: "M15.8705 20.4188L12.8137 16.1392C12.4149 15.5809 11.5851 15.5809 11.1863 16.1392L8.12946 20.4188C7.65669 21.0806 8.12982 22 8.94319 22H15.0568C15.8702 22 16.3433 21.0806 15.8705 20.4188Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M15.0568 2C15.8702 2 16.3433 2.91937 15.8705 3.58124L12.8137 7.86077C12.4149 8.41912 11.5851 8.41912 11.1863 7.86077L8.12946 3.58124C7.65669 2.91937 8.12982 2 8.94319 2H15.0568Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M10 12H14M17.5 12H21M3 12H6.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", key: "2" }],
] as const;

export const FlipVerticalIcon = /* @__PURE__ */ createTerraIcon({
  icon: FlipVerticalIconData,
  displayName: 'FlipVerticalIcon',
});

const FloorPlanIconData = [
  ['path', { d: "M2.5 9.5H13.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M17.5 9.5H21.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M9.5 21.5L9.5 9.5", stroke: "currentColor", strokeWidth: 1.5, key: "2" }],
  ['path', { d: "M9.5 6.5V2.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "3" }],
  ['path', { d: "M17.8432 21.5H19.5C20.6046 21.5 21.5 20.6046 21.5 19.5V4.5C21.5 3.39543 20.6046 2.5 19.5 2.5H4.5C3.39543 2.5 2.5 3.39543 2.5 4.5V19.5C2.5 20.6046 3.39543 21.5 4.5 21.5H13C13 18.6223 15 17 17 17", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "4" }],
] as const;

export const FloorPlanIcon = /* @__PURE__ */ createTerraIcon({
  icon: FloorPlanIconData,
  displayName: 'FloorPlanIcon',
});

const FloppyDiskIconData = [
  ['path', { d: "M8 22V17C8 15.8954 8.89543 15 10 15H14C15.1046 15 16 15.8954 16 17V22", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M10 7H14", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M3 20V4C3 2.89543 3.89543 2 5 2H14.2759C14.7438 2 15.1968 2.16403 15.5563 2.46356L20.2804 6.40031C20.7364 6.7803 21 7.34319 21 7.93675V20C21 21.1046 20.1046 22 19 22H5C3.89543 22 3 21.1046 3 20Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const FloppyDiskIcon = /* @__PURE__ */ createTerraIcon({
  icon: FloppyDiskIconData,
  displayName: 'FloppyDiskIcon',
});

const FlowCircleIconData = [
  ['path', { d: "M18 4.5C18 5.88071 16.8807 7 15.5 7C14.1193 7 13 5.88071 13 4.5C13 3.11929 14.1193 2 15.5 2C16.8807 2 18 3.11929 18 4.5Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M18 19.5C18 20.8807 16.8807 22 15.5 22C14.1193 22 13 20.8807 13 19.5C13 18.1193 14.1193 17 15.5 17C16.8807 17 18 18.1193 18 19.5Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M10 12C10 14.2091 8.20914 16 6 16C3.79086 16 2 14.2091 2 12C2 9.79086 3.79086 8 6 8C8.20914 8 10 9.79086 10 12Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M22.0003 4.50018L18.0003 4.50009M6.00032 8L6.00022 6.50027C6.00014 5.39566 6.89557 4.50016 8.00017 4.50013L13.0003 4.5M22.0003 19.5003L18.0003 19.5002M6.00032 16.0003L6.00018 17.5C6.00008 18.6046 6.89551 19.5001 8.00013 19.5002L13.0003 19.5003", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "3" }],
] as const;

export const FlowCircleIcon = /* @__PURE__ */ createTerraIcon({
  icon: FlowCircleIconData,
  displayName: 'FlowCircleIcon',
});

const FlowConnectionIconData = [
  ['path', { d: "M22.001 20.5V15.5C22.001 14.9477 21.5533 14.5 21.001 14.5H16.001C15.4487 14.5 15.001 14.9477 15.001 15.5V20.5C15.001 21.0523 15.4487 21.5 16.001 21.5H21.001C21.5533 21.5 22.001 21.0523 22.001 20.5Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M9.50098 8V3C9.50098 2.44772 9.05326 2 8.50098 2H3.50098C2.94869 2 2.50098 2.44772 2.50098 3V8C2.50098 8.55228 2.94869 9 3.50098 9H8.50098C9.05326 9 9.50098 8.55228 9.50098 8Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M5.29289 21.2929C5.68342 21.6834 6.31658 21.6834 6.70711 21.2929L9.29289 18.7071C9.68342 18.3166 9.68342 17.6834 9.29289 17.2929L6.70711 14.7071C6.31658 14.3166 5.68342 14.3166 5.29289 14.7071L2.70711 17.2929C2.31658 17.6834 2.31658 18.3166 2.70711 18.7071L5.29289 21.2929Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M6.00098 9V14M10.001 18H15.001", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "3" }],
] as const;

export const FlowConnectionIcon = /* @__PURE__ */ createTerraIcon({
  icon: FlowConnectionIconData,
  displayName: 'FlowConnectionIcon',
});

const FlowSquareIconData = [
  ['path', { d: "M17.5 6V3C17.5 2.44772 17.0523 2 16.5 2H13.5C12.9477 2 12.5 2.44772 12.5 3V6C12.5 6.55228 12.9477 7 13.5 7H16.5C17.0523 7 17.5 6.55228 17.5 6Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M17.5 21V18C17.5 17.4477 17.0523 17 16.5 17H13.5C12.9477 17 12.5 17.4477 12.5 18V21C12.5 21.5523 12.9477 22 13.5 22H16.5C17.0523 22 17.5 21.5523 17.5 21Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M9 14V10C9 9.44772 8.55228 9 8 9H3C2.44772 9 2 9.44772 2 10V14C2 14.5523 2.44772 15 3 15H8C8.55228 15 9 14.5523 9 14Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M21.9994 4.50009H17.5M5.5 9.00018V6.5C5.5 5.39543 6.39543 4.5 7.5 4.5H12.5M21.9994 19.5004H17.5M5.5 15.0003V17.5005C5.5 18.6051 6.39543 19.5005 7.5 19.5005H12.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "3" }],
] as const;

export const FlowSquareIcon = /* @__PURE__ */ createTerraIcon({
  icon: FlowSquareIconData,
  displayName: 'FlowSquareIcon',
});

const FlowIconData = [
  ['path', { d: "M21 6.75C21 8.683 19.433 10.25 17.5 10.25C15.567 10.25 14 8.683 14 6.75C14 4.817 15.567 3.25 17.5 3.25C19.433 3.25 21 4.817 21 6.75Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M9 8.75V4.75C9 4.19772 8.55228 3.75 8 3.75H4C3.44772 3.75 3 4.19772 3 4.75V8.75C3 9.30228 3.44772 9.75 4 9.75H8C8.55228 9.75 9 9.30228 9 8.75Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M9 19.75V15.75C9 15.1977 8.55228 14.75 8 14.75H4C3.44772 14.75 3 15.1977 3 15.75V19.75C3 20.3023 3.44772 20.75 4 20.75H8C8.55228 20.75 9 20.3023 9 19.75Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M20.5 19.75V15.75C20.5 15.1977 20.0523 14.75 19.5 14.75H15.5C14.9477 14.75 14.5 15.1977 14.5 15.75V19.75C14.5 20.3023 14.9477 20.75 15.5 20.75H19.5C20.0523 20.75 20.5 20.3023 20.5 19.75Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "3" }],
  ['path', { d: "M17.5 10.25V14.25M14 17.75H9M9 6.75H14", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "4" }],
] as const;

export const FlowIcon = /* @__PURE__ */ createTerraIcon({
  icon: FlowIconData,
  displayName: 'FlowIcon',
});

const Flowchart01IconData = [
  ['path', { d: "M15.999 5V3C15.999 2.44772 15.5513 2 14.999 2H8.99902C8.44674 2 7.99902 2.44772 7.99902 3V5C7.99902 5.55228 8.44674 6 8.99902 6H14.999C15.5513 6 15.999 5.55228 15.999 5Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M15.999 21V19C15.999 18.4477 15.5513 18 14.999 18H8.99902C8.44674 18 7.99902 18.4477 7.99902 19V21C7.99902 21.5523 8.44674 22 8.99902 22H14.999C15.5513 22 15.999 21.5523 15.999 21Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M11.999 15L14.999 12L11.999 9L8.99902 12L11.999 15Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M9 12H6C4.89543 12 4 11.1046 4 10V6.00001C4 4.89543 4.89544 4 6.00001 4.00001L7.99862 4.00001", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "3" }],
  ['path', { d: "M14.999 12H17.999C19.1036 12 19.999 12.8954 19.999 14V18C19.999 19.1046 19.1036 20 17.999 20H15.999", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "4" }],
  ['path', { d: "M11.999 9V6M11.999 15V18", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "5" }],
] as const;

export const Flowchart01Icon = /* @__PURE__ */ createTerraIcon({
  icon: Flowchart01IconData,
  displayName: 'Flowchart01Icon',
});

const Flowchart02IconData = [
  ['path', { d: "M18 5V3C18 2.44772 17.5523 2 17 2H11C10.4477 2 10 2.44772 10 3V5C10 5.55228 10.4477 6 11 6H17C17.5523 6 18 5.55228 18 5Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M18 13V11C18 10.4477 17.5523 10 17 10H11C10.4477 10 10 10.4477 10 11V13C10 13.5523 10.4477 14 11 14H17C17.5523 14 18 13.5523 18 13Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M18 21V19C18 18.4477 17.5523 18 17 18H11C10.4477 18 10 18.4477 10 19V21C10 21.5523 10.4477 22 11 22H17C17.5523 22 18 21.5523 18 21Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M6 20C6 21.1046 5.10457 22 4 22C2.89543 22 2 21.1046 2 20C2 18.8954 2.89543 18 4 18C5.10457 18 6 18.8954 6 20Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "3" }],
  ['path', { d: "M14 6V10M10 12H6C4.89543 12 4 12.8954 4 14V18M6 20H10", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "4" }],
  ['path', { d: "M18 4H20C21.1046 4 22 4.89543 22 6V10C22 11.1046 21.1046 12 20 12H18", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "5" }],
] as const;

export const Flowchart02Icon = /* @__PURE__ */ createTerraIcon({
  icon: Flowchart02IconData,
  displayName: 'Flowchart02Icon',
});

const FlowerPotIconData = [
  ['path', { d: "M12 9C12 4.5 14 4 16 4C16 7 14.5 9 12 9ZM12 9C12 4.5 10 4 8 4C8 7 9.5 9 12 9Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M10 4C10 4 10.5 2.5 12 2C13.5 2.5 14 4 14 4", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M12 9V15", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M12 13C12.25 12.3333 13.2 11 15 11", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "3" }],
  ['path', { d: "M15.8399 20.4145L16.7416 16.2097C16.8751 15.5871 16.4005 15 15.7638 15H8.23731C7.60088 15 7.12637 15.5866 7.2594 16.209L8.15802 20.4132C8.35522 21.3358 9.17037 21.9952 10.1138 21.9952H13.8844C14.8273 21.9952 15.6422 21.3365 15.8399 20.4145Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "4" }],
] as const;

export const FlowerPotIcon = /* @__PURE__ */ createTerraIcon({
  icon: FlowerPotIconData,
  displayName: 'FlowerPotIcon',
});

const FlowerIconData = [
  ['path', { d: "M14.4999 12.5C14.4999 13.8807 13.3806 15 11.9999 15C10.6192 15 9.49988 13.8807 9.49988 12.5C9.49988 11.1193 10.6192 10 11.9999 10C13.3806 10 14.4999 11.1193 14.4999 12.5Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M11.9999 3C14.209 3 15.9979 4.91739 15.9979 7.12653C16.3181 7.04393 16.6539 7 16.9999 7C19.209 7 20.9999 8.79086 20.9999 11C20.9999 12.5964 20.0646 13.9745 18.7121 14.616C19.207 15.2818 19.4999 16.1067 19.4999 17C19.4999 19.2091 17.709 21 15.4999 21C13.9939 21 12.6822 20.1677 11.9999 18.938C11.3175 20.1677 10.0059 21 8.49988 21C6.29074 21 4.49988 19.2091 4.49988 17C4.49988 16.1067 4.79271 15.2818 5.28761 14.616C3.93512 13.9745 2.99988 12.5964 2.99988 11C2.99988 8.79086 4.79074 7 6.99988 7C7.34588 7 7.68163 7.04393 8.00184 7.12652C8.00184 4.91738 9.79074 3 11.9999 3Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "1" }],
] as const;

export const FlowerIcon = /* @__PURE__ */ createTerraIcon({
  icon: FlowerIconData,
  displayName: 'FlowerIcon',
});

const FlushedIconData = [
  ['circle', { cx: 12, cy: 12, r: 10, stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M10 9.5C10 10.3284 9.32843 11 8.5 11C7.67157 11 7 10.3284 7 9.5C7 8.67157 7.67157 8 8.5 8C9.32843 8 10 8.67157 10 9.5Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M17 9.5C17 10.3284 16.3284 11 15.5 11C14.6716 11 14 10.3284 14 9.5C14 8.67157 14.6716 8 15.5 8C16.3284 8 17 8.67157 17 9.5Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M9 16H15", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "3" }],
] as const;

export const FlushedIcon = /* @__PURE__ */ createTerraIcon({
  icon: FlushedIconData,
  displayName: 'FlushedIcon',
});

const FlyingHumanIconData = [
  ['path', { d: "M15.9939 5.49805C15.9939 6.32648 15.322 6.99805 14.4931 6.99805C13.6641 6.99805 12.9922 6.32648 12.9922 5.49805C12.9922 4.66962 13.6641 3.99805 14.4931 3.99805C15.322 3.99805 15.9939 4.66962 15.9939 5.49805Z", stroke: "currentColor", strokeWidth: 1.5, key: "0" }],
  ['path', { d: "M21 3C20.5 5 19.5 8 15 9C11.4857 9.78095 8.5 10 7 13", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M13.5 9.5C13.5 9.5 13 20.5 5 21M17 8.5C17 8.5 17.5 17 3 17", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const FlyingHumanIcon = /* @__PURE__ */ createTerraIcon({
  icon: FlyingHumanIconData,
  displayName: 'FlyingHumanIcon',
});

const FocusPointIconData = [
  ['path', { d: "M8.5 2.5L4.49996 2.50007C3.39541 2.50009 2.5 3.39552 2.5 4.50007V7.5M15.5 2.5H19.5001C20.6046 2.5 21.5001 3.39545 21.5001 4.50004L21.5 7.5M15.5 21.5L19.5 21.5001C20.6046 21.5002 21.5001 20.6047 21.5001 19.5001L21.5 16.5M8.5 21.5H4.50092C3.39659 21.5 2.50126 20.6049 2.50092 19.5006L2.5 16.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M11.5 7H12.5M11.5 12H12.5M11.5 17H12.5M5 12H6M18 12H19", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", key: "1" }],
] as const;

export const FocusPointIcon = /* @__PURE__ */ createTerraIcon({
  icon: FocusPointIconData,
  displayName: 'FocusPointIcon',
});

const Folder01IconData = [
  ['path', { d: "M8 6.99446H12.0179M12.0179 6.99446H20C21.1046 6.99446 22 7.88989 22 8.99446V19C22 20.1046 21.1046 21 20 21H4C2.89543 21 2 20.1046 2 19V4C2 3.44772 2.44772 3 3 3H8.5022C8.81572 3 9.11109 3.14703 9.30008 3.39718L12.0179 6.99446Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
] as const;

export const Folder01Icon = /* @__PURE__ */ createTerraIcon({
  icon: Folder01IconData,
  displayName: 'Folder01Icon',
});

const Folder02IconData = [
  ['path', { d: "M2 21V4C2 3.44772 2.44772 3 3 3H7.03163C7.3284 3 7.60985 3.13182 7.79985 3.35982L10 6M10 6H7M10 6H18C19.1046 6 20 6.89543 20 8V11", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M18.4766 21H2L5.74856 11.6286C5.90042 11.249 6.26813 11 6.67703 11H20.9995C21.707 11 22.1908 11.7145 21.928 12.3714L18.4766 21Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const Folder02Icon = /* @__PURE__ */ createTerraIcon({
  icon: Folder02IconData,
  displayName: 'Folder02Icon',
});

const Folder03IconData = [
  ['path', { d: "M3.66666 20.1961C3.76285 20.6635 4.18515 21 4.67564 21H18.5009C18.9553 21 19.3559 20.7103 19.4864 20.2873L21.9559 12.2873C22.154 11.6457 21.6596 11 20.9704 11H3.02931C2.37999 11 1.89299 11.5773 2.02033 12.1961L3.66666 20.1961Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M4 11L4 4C4 3.44772 4.44772 3 5 3H9.46482C9.79917 3 10.1114 3.1671 10.2969 3.4453L12 6M8.5 6H18C19.1046 6 20 6.89543 20 8V11", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const Folder03Icon = /* @__PURE__ */ createTerraIcon({
  icon: Folder03IconData,
  displayName: 'Folder03Icon',
});

const FolderAddIconData = [
  ['path', { d: "M8 6.99446H12.0179M12.0179 6.99446H20C21.1046 6.99446 22 7.88989 22 8.99446V12M12.0179 6.99446L9.30008 3.39718C9.11109 3.14703 8.81572 3 8.5022 3H3C2.44772 3 2 3.44772 2 4V19C2 20.1046 2.89543 21 4 21H13", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M18 13V21M22 17H14", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const FolderAddIcon = /* @__PURE__ */ createTerraIcon({
  icon: FolderAddIconData,
  displayName: 'FolderAddIcon',
});

const FolderArchiveIconData = [
  ['path', { d: "M14 16.5V15M14 11.5V10.5M16 19C16 20.1046 15.1046 21 14 21C12.8954 21 12 20.1046 12 19C12 17.8954 12.8954 17 14 17C15.1046 17 16 17.8954 16 19Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M8 6.99446H12.0179M12.0179 6.99446H20C21.1046 6.99446 22 7.88989 22 8.99446V19C22 20.1046 21.1046 21 20 21H19M12.0179 6.99446L9.60016 3.79437C9.22218 3.29407 8.63144 3 8.0044 3H4C2.89543 3 2 3.89543 2 5V19C2 20.1046 2.89543 21 4 21H9", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const FolderArchiveIcon = /* @__PURE__ */ createTerraIcon({
  icon: FolderArchiveIconData,
  displayName: 'FolderArchiveIcon',
});

const FolderAttachmentIconData = [
  ['path', { d: "M8 6.99446H12.0179M12.0179 6.99446H20C21.1046 6.99446 22 7.88989 22 8.99446V12M12.0179 6.99446L9.30008 3.39718C9.11109 3.14703 8.81572 3 8.5022 3H3C2.44772 3 2 3.44772 2 4V19C2 20.1046 2.89543 21 4 21H13.0179", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M21 15.4615V17.9231C21 19.6224 19.6569 21 18 21C16.3431 21 15 19.6224 15 17.9231V14.5385C15 13.6888 15.6716 13 16.5 13C17.3284 13 18 13.6888 18 14.5385V17.9231", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const FolderAttachmentIcon = /* @__PURE__ */ createTerraIcon({
  icon: FolderAttachmentIconData,
  displayName: 'FolderAttachmentIcon',
});

const FolderAudioIconData = [
  ['path', { d: "M8 6.99446H12.0179M12.0179 6.99446H20C21.1046 6.99446 22 7.88989 22 8.99446V10M12.0179 6.99446L9.30008 3.39718C9.11109 3.14703 8.81572 3 8.5022 3H3C2.44772 3 2 3.44772 2 4V19C2 20.1046 2.89543 21 4 21H13", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M18 15.5H15.5C15.2239 15.5 15 15.7239 15 16V18C15 18.2761 15.2239 18.5 15.5 18.5H18L22 21V13L18 15.5Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "1" }],
] as const;

export const FolderAudioIcon = /* @__PURE__ */ createTerraIcon({
  icon: FolderAudioIconData,
  displayName: 'FolderAudioIcon',
});

const FolderBlockIconData = [
  ['path', { d: "M8 6.99446H12.0179M12.0179 6.99446H20C21.1046 6.99446 22 7.88989 22 8.99446V12M12.0179 6.99446L9.30008 3.39718C9.11109 3.14703 8.81572 3 8.5022 3H3C2.44772 3 2 3.44772 2 4V19C2 20.1046 2.89543 21 4 21H13.0179", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M20.9749 19.9749C21.6082 19.3415 22 18.4665 22 17.5C22 15.567 20.433 14 18.5 14C17.5335 14 16.6585 14.3918 16.0251 15.0251M20.9749 19.9749C20.3415 20.6082 19.4665 21 18.5 21C16.567 21 15 19.433 15 17.5C15 16.5335 15.3918 15.6585 16.0251 15.0251M20.9749 19.9749L16.0251 15.0251", stroke: "currentColor", strokeWidth: 1.5, key: "1" }],
] as const;

export const FolderBlockIcon = /* @__PURE__ */ createTerraIcon({
  icon: FolderBlockIconData,
  displayName: 'FolderBlockIcon',
});

const FolderCheckIconData = [
  ['path', { d: "M8 6.99446H12.0179M12.0179 6.99446H20C21.1046 6.99446 22 7.88989 22 8.99446V12M12.0179 6.99446L9.30008 3.39718C9.11109 3.14703 8.81572 3 8.5022 3H3C2.44772 3 2 3.44772 2 4V19C2 20.1046 2.89543 21 4 21H11", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M21 15L16 21L14 19", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const FolderCheckIcon = /* @__PURE__ */ createTerraIcon({
  icon: FolderCheckIconData,
  displayName: 'FolderCheckIcon',
});

const FolderClockIconData = [
  ['circle', { cx: 17, cy: 16.5, r: 5, stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M17 14.5V16.5L18.5 17", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M8 6.49446H12.0179M12.0179 6.49446H20C21.1046 6.49446 22 7.38989 22 8.49446V9.5M12.0179 6.49446L9.60016 3.29437C9.22218 2.79407 8.63144 2.5 8.0044 2.5H4C2.89543 2.5 2 3.39543 2 4.5V18.5C2 19.6046 2.89543 20.5 4 20.5H9", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const FolderClockIcon = /* @__PURE__ */ createTerraIcon({
  icon: FolderClockIconData,
  displayName: 'FolderClockIcon',
});

const FolderCloudIconData = [
  ['path', { d: "M8 6.99446H12.0179M12.0179 6.99446H20C21.1046 6.99446 22 7.88989 22 8.99446V13M12.0179 6.99446L9.30008 3.39718C9.11109 3.14703 8.81572 3 8.5022 3H3C2.44772 3 2 3.44772 2 4V19C2 20.1046 2.89543 21 4 21H10", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M13 18.6667C13 19.9553 14.0074 21 15.25 21H19.975C21.0934 21 22 20.0598 22 18.9C22 17.7402 21.0833 16.8 19.9649 16.8C20.0897 15.3643 18.9799 14 17.5 14C16.2055 14 15.1431 15.0307 15.0342 16.3439C13.8928 16.4566 13 17.4535 13 18.6667Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const FolderCloudIcon = /* @__PURE__ */ createTerraIcon({
  icon: FolderCloudIconData,
  displayName: 'FolderCloudIcon',
});

const FolderCodeIconData = [
  ['path', { d: "M8 6.99446H12.0179M12.0179 6.99446H20C21.1046 6.99446 22 7.88989 22 8.99446V19C22 20.1046 21.1046 21 20 21H4C2.89543 21 2 20.1046 2 19V5C2 3.89543 2.89543 3 4 3H8.0044C8.63144 3 9.22218 3.29407 9.60016 3.79437L12.0179 6.99446Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M14 11L17 14L14 17M10 11L7 14L10 17", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const FolderCodeIcon = /* @__PURE__ */ createTerraIcon({
  icon: FolderCodeIconData,
  displayName: 'FolderCodeIcon',
});

const FolderCogIconData = [
  ['path', { d: "M20.5 17.5C20.5 18.8807 19.3807 20 18 20M20.5 17.5C20.5 16.1193 19.3807 15 18 15M20.5 17.5H22M18 20C16.6193 20 15.5 18.8807 15.5 17.5M18 20V21.5M15.5 17.5C15.5 16.1193 16.6193 15 18 15M15.5 17.5H14M18 15V13.5M19.7678 15.7322L20.8284 14.6716M16.2322 19.2678L15.1716 20.3284M19.7678 19.2678L20.8284 20.3284M16.2322 15.7322L15.1716 14.6716", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M8 6.49446H12.0179M12.0179 6.49446H20C21.1046 6.49446 22 7.38989 22 8.49446V10.4972M12.0179 6.49446L9.60016 3.29437C9.22218 2.79407 8.63144 2.5 8.0044 2.5H4C2.89543 2.5 2 3.39543 2 4.5V18.5C2 19.6046 2.89543 20.5 4 20.5H11", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const FolderCogIcon = /* @__PURE__ */ createTerraIcon({
  icon: FolderCogIconData,
  displayName: 'FolderCogIcon',
});

const FolderDetailsReferenceIconData = [
  ['path', { d: "M8 6.99446H12.0179M12.0179 6.99446H20C21.1046 6.99446 22 7.88989 22 8.99446V12M12.0179 6.99446L9.30008 3.39718C9.11109 3.14703 8.81572 3 8.5022 3H3C2.44772 3 2 3.44772 2 4V21", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M22 15H15M22 18H15M17.5 21H15", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M6 15H11M11 15V20M11 15L5 21", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const FolderDetailsReferenceIcon = /* @__PURE__ */ createTerraIcon({
  icon: FolderDetailsReferenceIconData,
  displayName: 'FolderDetailsReferenceIcon',
});

const FolderDetailsIconData = [
  ['path', { d: "M8 6.99446H12.0179M12.0179 6.99446H20C21.1046 6.99446 22 7.88989 22 8.99446V12M12.0179 6.99446L9.30008 3.39718C9.11109 3.14703 8.81572 3 8.5022 3H3C2.44772 3 2 3.44772 2 4V19C2 20.1046 2.89543 21 4 21H12.0179", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M22 15H15M22 18H15M17.5 21H15", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const FolderDetailsIcon = /* @__PURE__ */ createTerraIcon({
  icon: FolderDetailsIconData,
  displayName: 'FolderDetailsIcon',
});

const FolderDotIconData = [
  ['path', { d: "M12 13.5V14M13 14C13 14.5523 12.5523 15 12 15C11.4477 15 11 14.5523 11 14C11 13.4477 11.4477 13 12 13C12.5523 13 13 13.4477 13 14Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M8 6.99446H12.0179M12.0179 6.99446H20C21.1046 6.99446 22 7.88989 22 8.99446V19C22 20.1046 21.1046 21 20 21H4C2.89543 21 2 20.1046 2 19V5C2 3.89543 2.89543 3 4 3H8.0044C8.63144 3 9.22218 3.29407 9.60016 3.79437L12.0179 6.99446Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const FolderDotIcon = /* @__PURE__ */ createTerraIcon({
  icon: FolderDotIconData,
  displayName: 'FolderDotIcon',
});

const FolderDownloadIconData = [
  ['path', { d: "M8 6.99446H12.0179M12.0179 6.99446H20C21.1046 6.99446 22 7.88989 22 8.99446V12M12.0179 6.99446L9.30008 3.39718C9.11109 3.14703 8.81572 3 8.5022 3H3C2.44772 3 2 3.44772 2 4V19C2 20.1046 2.89543 21 4 21H14", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M22 18L19 21L16 18M19 13V20.3912", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const FolderDownloadIcon = /* @__PURE__ */ createTerraIcon({
  icon: FolderDownloadIconData,
  displayName: 'FolderDownloadIcon',
});

const FolderEditIconData = [
  ['path', { d: "M8 6.99446H12.0179M12.0179 6.99446H20C21.1046 6.99446 22 7.88989 22 8.99446V11M12.0179 6.99446L9.30008 3.39718C9.11109 3.14703 8.81572 3 8.5022 3H3C2.44772 3 2 3.44772 2 4V19C2 20.1046 2.89543 21 4 21H11", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M14 19V21H16L22 15L20 13L14 19Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "1" }],
] as const;

export const FolderEditIcon = /* @__PURE__ */ createTerraIcon({
  icon: FolderEditIconData,
  displayName: 'FolderEditIcon',
});

const FolderExportIconData = [
  ['path', { d: "M19 21L22 18L19 15M14 18H21.3912", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M8 6.99446H12.0179M12.0179 6.99446H20C21.1046 6.99446 22 7.88989 22 8.99446V13M12.0179 6.99446L9.30008 3.39718C9.11109 3.14703 8.81572 3 8.5022 3H3C2.44772 3 2 3.44772 2 4V19C2 20.1046 2.89543 21 4 21H12", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const FolderExportIcon = /* @__PURE__ */ createTerraIcon({
  icon: FolderExportIconData,
  displayName: 'FolderExportIcon',
});

const FolderFavouriteIconData = [
  ['path', { d: "M8 6.99446H12.0179M12.0179 6.99446H20C21.1046 6.99446 22 7.88989 22 8.99446V11M12.0179 6.99446L9.30008 3.39718C9.11109 3.14703 8.81572 3 8.5022 3H3C2.44772 3 2 3.44772 2 4V19C2 20.1046 2.89543 21 4 21H12", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M20.586 13.331C18.7898 12.3795 17.5 13.7821 17.5 13.7821C17.5 13.7821 16.2102 12.3795 14.4139 13.331C12.2383 14.4834 12.0821 18.9964 17.5 21C22.9179 18.9964 22.7616 14.4834 20.586 13.331Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const FolderFavouriteIcon = /* @__PURE__ */ createTerraIcon({
  icon: FolderFavouriteIconData,
  displayName: 'FolderFavouriteIcon',
});

const FolderFileStorageIconData = [
  ['path', { d: "M8 6.99446H12.0179M12.0179 6.99446H20C21.1046 6.99446 22 7.88989 22 8.99446V11M12.0179 6.99446L9.30008 3.39718C9.11109 3.14703 8.81572 3 8.5022 3H3C2.44772 3 2 3.44772 2 4V19C2 20.1046 2.89543 21 4 21H12", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M21.7071 15.2071L19.7929 13.2929C19.6054 13.1054 19.351 13 19.0858 13H16C15.4477 13 15 13.4477 15 14V20C15 20.5523 15.4477 21 16 21H21C21.5523 21 22 20.5523 22 20V15.9142C22 15.649 21.8946 15.3946 21.7071 15.2071Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "1" }],
] as const;

export const FolderFileStorageIcon = /* @__PURE__ */ createTerraIcon({
  icon: FolderFileStorageIconData,
  displayName: 'FolderFileStorageIcon',
});

const FolderGit2IconData = [
  ['circle', { cx: 14, cy: 12.5, r: 2, stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['circle', { cx: 20, cy: 18.5, r: 2, stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M18 18.5C15.7909 18.5 14 16.7091 14 14.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M14 14.5V21.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "3" }],
  ['path', { d: "M8 6.49446H12.0179M12.0179 6.49446H20C21.1046 6.49446 22 7.38989 22 8.49446V12.5M12.0179 6.49446L9.60016 3.29437C9.22218 2.79407 8.63144 2.5 8.0044 2.5H4C2.89543 2.5 2 3.39543 2 4.5V18.5C2 19.6046 2.89543 20.5 4 20.5H10", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "4" }],
] as const;

export const FolderGit2Icon = /* @__PURE__ */ createTerraIcon({
  icon: FolderGit2IconData,
  displayName: 'FolderGit2Icon',
});

const FolderGitIconData = [
  ['circle', { cx: 12, cy: 14, r: 2, stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M14 14H18M10 14H6", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M8 6.99446H12.0179M12.0179 6.99446H20C21.1046 6.99446 22 7.88989 22 8.99446V19C22 20.1046 21.1046 21 20 21H4C2.89543 21 2 20.1046 2 19V5C2 3.89543 2.89543 3 4 3H8.0044C8.63144 3 9.22218 3.29407 9.60016 3.79437L12.0179 6.99446Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const FolderGitIcon = /* @__PURE__ */ createTerraIcon({
  icon: FolderGitIconData,
  displayName: 'FolderGitIcon',
});

const FolderHeartIconData = [
  ['path', { d: "M8 6.49446H12.0179M12.0179 6.49446H20C21.1046 6.49446 22 7.38989 22 8.49446V10.5M12.0179 6.49446L9.60016 3.29437C9.22218 2.79407 8.63144 2.5 8.0044 2.5H4C2.89543 2.5 2 3.39543 2 4.5V18.5C2 19.6046 2.89543 20.5 4 20.5H11", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M18 21.5C18 21.5 14 19.0294 14 16.6389C14 15.4576 14.8421 14.5 16 14.5C16.6 14.5 17.2 14.7059 18 15.5294C18.8 14.7059 19.4 14.5 20 14.5C21.1579 14.5 22 15.4576 22 16.6389C22 19.0294 18 21.5 18 21.5Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const FolderHeartIcon = /* @__PURE__ */ createTerraIcon({
  icon: FolderHeartIconData,
  displayName: 'FolderHeartIcon',
});

const FolderImportIconData = [
  ['path', { d: "M17 21L14 18L17 15M21.9994 18H14.4994", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M8 6.99446H12.0179M12.0179 6.99446H20C21.1046 6.99446 22 7.88989 22 8.99446V14M12.0179 6.99446L9.30008 3.39718C9.11109 3.14703 8.81572 3 8.5022 3H3C2.44772 3 2 3.44772 2 4V19C2 20.1046 2.89543 21 4 21H11", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const FolderImportIcon = /* @__PURE__ */ createTerraIcon({
  icon: FolderImportIconData,
  displayName: 'FolderImportIcon',
});

const FolderInputIconData = [
  ['path', { d: "M9.00002 17L12 14L9 11M11 14L2 14", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M8 6.99446H12.0179M12.0179 6.99446H20C21.1046 6.99446 22 7.88989 22 8.99446V19C22 20.1046 21.1046 21 20 21H4C2.89543 21 2 20.1046 2 19V18M12.0179 6.99446L9.60016 3.79437C9.22218 3.29407 8.63144 3 8.0044 3H4C2.89543 3 2 3.89543 2 5V10", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const FolderInputIcon = /* @__PURE__ */ createTerraIcon({
  icon: FolderInputIconData,
  displayName: 'FolderInputIcon',
});

const FolderKanbanIconData = [
  ['path', { d: "M12 11V13", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M16 11V17", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M8 11V15", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M8 6.99446H12.0179M12.0179 6.99446H20C21.1046 6.99446 22 7.88989 22 8.99446V19C22 20.1046 21.1046 21 20 21H4C2.89543 21 2 20.1046 2 19V5C2 3.89543 2.89543 3 4 3H8.0044C8.63144 3 9.22218 3.29407 9.60016 3.79437L12.0179 6.99446Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "3" }],
] as const;

export const FolderKanbanIcon = /* @__PURE__ */ createTerraIcon({
  icon: FolderKanbanIconData,
  displayName: 'FolderKanbanIcon',
});

const FolderKeyIconData = [
  ['path', { d: "M17.5 18L22 13.5M21 15L22 16M18 19.5C18 20.6046 17.1046 21.5 16 21.5C14.8954 21.5 14 20.6046 14 19.5C14 18.3954 14.8954 17.5 16 17.5C17.1046 17.5 18 18.3954 18 19.5Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M8 6.49446H12.0179M12.0179 6.49446H20C21.1046 6.49446 22 7.38989 22 8.49446V9.5M12.0179 6.49446L9.60016 3.29437C9.22218 2.79407 8.63144 2.5 8.0044 2.5H4C2.89543 2.5 2 3.39543 2 4.5V18.5C2 19.6046 2.89543 20.5 4 20.5H10", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const FolderKeyIcon = /* @__PURE__ */ createTerraIcon({
  icon: FolderKeyIconData,
  displayName: 'FolderKeyIcon',
});

const FolderLibraryIconData = [
  ['path', { d: "M5.62195 20.1012L3.0462 11.8004C2.84628 11.1561 3.32023 10.5001 3.98567 10.5001H20.0143C20.6798 10.5001 21.1537 11.1561 20.9538 11.8004L18.3781 20.1012C18.1197 20.9338 17.3591 21.5001 16.4991 21.5001H7.50089C6.64091 21.5001 5.88032 20.9338 5.62195 20.1012Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M5 8V7.5C5 6.94772 5.44772 6.5 6 6.5H18C18.5523 6.5 19 6.94772 19 7.5V8", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M7.5 4V3.5C7.5 2.94772 7.94772 2.5 8.5 2.5H15.5C16.0523 2.5 16.5 2.94772 16.5 3.5V4", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const FolderLibraryIcon = /* @__PURE__ */ createTerraIcon({
  icon: FolderLibraryIconData,
  displayName: 'FolderLibraryIcon',
});

const FolderLinksIconData = [
  ['path', { d: "M8 6.99446H12.0179M12.0179 6.99446H20C21.1046 6.99446 22 7.88989 22 8.99446V14M12.0179 6.99446L9.30008 3.39718C9.11109 3.14703 8.81572 3 8.5022 3H3C2.44772 3 2 3.44772 2 4V19C2 20.1046 2.89543 21 4 21H13", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M17.6863 20.4315C18.4444 21.1895 19.6734 21.1895 20.4315 20.4315C21.1895 19.6734 21.1895 18.4444 20.4315 17.6863L18.7157 15.9705C17.9922 15.247 16.8396 15.2141 16.077 15.8717M16.3137 13.5685C15.5556 12.8105 14.3266 12.8105 13.5685 13.5685C12.8105 14.3266 12.8105 15.5557 13.5685 16.3137L15.2843 18.0294C16.0078 18.753 17.1604 18.7859 17.9231 18.1282", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", key: "1" }],
] as const;

export const FolderLinksIcon = /* @__PURE__ */ createTerraIcon({
  icon: FolderLinksIconData,
  displayName: 'FolderLinksIcon',
});

const FolderLockedIconData = [
  ['path', { d: "M8 6.99446H12.0179M12.0179 6.99446H20C21.1046 6.99446 22 7.88989 22 8.99446V11M12.0179 6.99446L9.30008 3.39718C9.11109 3.14703 8.81572 3 8.5022 3H3C2.44772 3 2 3.44772 2 4V19C2 20.1046 2.89543 21 4 21H12", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M16.75 16V14.75C16.75 13.7835 17.5335 13 18.5 13C19.4665 13 20.25 13.7835 20.25 14.75V16M15 16V21H22V16H15Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "1" }],
] as const;

export const FolderLockedIcon = /* @__PURE__ */ createTerraIcon({
  icon: FolderLockedIconData,
  displayName: 'FolderLockedIcon',
});

const FolderManagementIconData = [
  ['path', { d: "M8 6.99446H12.0179M12.0179 6.99446H20C21.1046 6.99446 22 7.88989 22 8.99446V10M12.0179 6.99446L9.30008 3.39718C9.11109 3.14703 8.81572 3 8.5022 3H3C2.44772 3 2 3.44772 2 4V19C2 20.1046 2.89543 21 4 21H12", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M18 19.7727C19.7673 19.7727 21.2 18.3075 21.2 16.5C21.2 14.6925 19.7673 13.2273 18 13.2273M18 19.7727C16.2327 19.7727 14.8 18.3075 14.8 16.5C14.8 14.6925 16.2327 13.2273 18 13.2273M18 19.7727V21M18 13.2273V12M15.0913 14.7149L14.0004 14.0455M22 18.9545L20.9092 18.2851M20.9087 14.7149L21.9996 14.0455M14 18.9545L15.0908 18.2851", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", key: "1" }],
] as const;

export const FolderManagementIcon = /* @__PURE__ */ createTerraIcon({
  icon: FolderManagementIconData,
  displayName: 'FolderManagementIcon',
});

const FolderMinusIconData = [
  ['path', { d: "M8 6.99446H12.0179M12.0179 6.99446H20C21.1046 6.99446 22 7.88989 22 8.99446V13M12.0179 6.99446L9.30008 3.39718C9.11109 3.14703 8.81572 3 8.5022 3H3C2.44772 3 2 3.44772 2 4V19C2 20.1046 2.89543 21 4 21H13", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M22 17H14", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", key: "1" }],
] as const;

export const FolderMinusIcon = /* @__PURE__ */ createTerraIcon({
  icon: FolderMinusIconData,
  displayName: 'FolderMinusIcon',
});

const FolderMusicIconData = [
  ['path', { d: "M8 6.99446H12.0179M12.0179 6.99446H20C21.1046 6.99446 22 7.88989 22 8.99446V11.5M12.0179 6.99446L9.30008 3.39718C9.11109 3.14703 8.81572 3 8.5022 3H3C2.44772 3 2 3.44772 2 4V19C2 20.1046 2.89543 21 4 21H12.0179", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M19.3971 18.7446C19.3971 19.9885 18.4127 20.9969 17.1985 20.9969C15.9843 20.9969 15 19.9885 15 18.7446C15 17.5007 15.9843 16.4923 17.1985 16.4923C18.4127 16.4923 19.3971 17.5007 19.3971 18.7446ZM19.3971 18.7446V13C19.3971 13 20.7041 15.6999 22.0009 15.6999", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const FolderMusicIcon = /* @__PURE__ */ createTerraIcon({
  icon: FolderMusicIconData,
  displayName: 'FolderMusicIcon',
});

const FolderOffIconData = [
  ['path', { d: "M7 3L8.0044 3C8.63144 3 9.22218 3.29407 9.60016 3.79437L12.0179 6.99446H20C21.1046 6.99446 22 7.88989 22 8.99446V18M21 21H4C2.89543 21 2 20.1046 2 19V4.75C2 4.0519 2.40876 3.44927 3 3.16841", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M2 2L22 22", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const FolderOffIcon = /* @__PURE__ */ createTerraIcon({
  icon: FolderOffIconData,
  displayName: 'FolderOffIcon',
});

const FolderOpenIconData = [
  ['path', { d: "M2.5 21.5V6.5C2.5 5.94772 2.94772 5.5 3.5 5.5H7.01938C7.32316 5.5 7.61047 5.63809 7.80024 5.8753L9.5 8H17.5C18.0523 8 18.5 8.44772 18.5 9V11.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M2.5 21.5H16.9759L20.4273 12.8714C20.69 12.2145 20.2063 11.5 19.4988 11.5H7.17703C6.76813 11.5 6.40042 11.749 6.24856 12.1286L2.5 21.5Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M11.5 4.51456C12.4151 3.28409 13.6662 2.55594 15.5125 2.50161C16.1155 2.48386 16.7152 2.61395 17.2682 2.85544C18.5748 3.42601 19.4185 4.15644 20 5.5L21.5 3", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const FolderOpenIcon = /* @__PURE__ */ createTerraIcon({
  icon: FolderOpenIconData,
  displayName: 'FolderOpenIcon',
});

const FolderOutputIconData = [
  ['path', { d: "M4.99998 17L2 14L5 11M3 14L12 14", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M8 6.99446H12.0179M12.0179 6.99446H20C21.1046 6.99446 22 7.88989 22 8.99446V19C22 20.1046 21.1046 21 20 21H4C2.89543 21 2 20.1046 2 19M12.0179 6.99446L9.60016 3.79437C9.22218 3.29407 8.63144 3 8.0044 3H4C2.89543 3 2 3.89543 2 5V9", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const FolderOutputIcon = /* @__PURE__ */ createTerraIcon({
  icon: FolderOutputIconData,
  displayName: 'FolderOutputIcon',
});

const FolderPenIconData = [
  ['path', { d: "M8 6.99446H12.0179M12.0179 6.99446H20C21.1046 6.99446 22 7.88989 22 8.99446V19C22 20.1046 21.1046 21 20 21H10M12.0179 6.99446L9.60016 3.79437C9.22218 3.29407 8.63144 3 8.0044 3H4C2.89543 3 2 3.89543 2 5V13", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M2 21V18.7143L7.51225 13.202C7.64161 13.0727 7.81706 13 8 13C8.18294 13 8.35839 13.0727 8.48775 13.202L9.79797 14.5123C9.92733 14.6416 10 14.8171 10 15C10 15.1829 9.92733 15.3584 9.79797 15.4877L4.28571 21H2Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const FolderPenIcon = /* @__PURE__ */ createTerraIcon({
  icon: FolderPenIconData,
  displayName: 'FolderPenIcon',
});

const FolderPinIconData = [
  ['path', { d: "M8 6.99446H12.0179M12.0179 6.99446H20C21.1046 6.99446 22 7.88989 22 8.99446V10M12.0179 6.99446L9.30008 3.39718C9.11109 3.14703 8.81572 3 8.5022 3H3C2.44772 3 2 3.44772 2 4V19C2 20.1046 2.89543 21 4 21H14.0179", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M19 18H16L17.5 15.5L17 13H21L20.5 15.5L22 18H19ZM19 18V21", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const FolderPinIcon = /* @__PURE__ */ createTerraIcon({
  icon: FolderPinIconData,
  displayName: 'FolderPinIcon',
});

const FolderRemoveIconData = [
  ['path', { d: "M8 6.99446H12.0179M12.0179 6.99446H20C21.1046 6.99446 22 7.88989 22 8.99446V12M12.0179 6.99446L9.30008 3.39718C9.11109 3.14703 8.81572 3 8.5022 3H3C2.44772 3 2 3.44772 2 4V19C2 20.1046 2.89543 21 4 21H13.0179", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M22 15L16 21M22 21L16 15", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const FolderRemoveIcon = /* @__PURE__ */ createTerraIcon({
  icon: FolderRemoveIconData,
  displayName: 'FolderRemoveIcon',
});

const FolderRootIconData = [
  ['path', { d: "M12 16C13.1046 16 14 15.1046 14 14C14 12.8954 13.1046 12 12 12C10.8954 12 10 12.8954 10 14C10 15.1046 10.8954 16 12 16Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M12 16V21", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M8 6.99446H12.0179M12.0179 6.99446H20C21.1046 6.99446 22 7.88989 22 8.99446V19C22 20.1046 21.1046 21 20 21H4C2.89543 21 2 20.1046 2 19V5C2 3.89543 2.89543 3 4 3H8.0044C8.63144 3 9.22218 3.29407 9.60016 3.79437L12.0179 6.99446Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const FolderRootIcon = /* @__PURE__ */ createTerraIcon({
  icon: FolderRootIconData,
  displayName: 'FolderRootIcon',
});

const FolderSearch2IconData = [
  ['path', { d: "M14 15.5L15.5 17M14.5 13.5C14.5 14.8807 13.3807 16 12 16C10.6193 16 9.5 14.8807 9.5 13.5C9.5 12.1193 10.6193 11 12 11C13.3807 11 14.5 12.1193 14.5 13.5Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M8 6.99446H12.0179M12.0179 6.99446H20C21.1046 6.99446 22 7.88989 22 8.99446V19C22 20.1046 21.1046 21 20 21H4C2.89543 21 2 20.1046 2 19V5C2 3.89543 2.89543 3 4 3H8.0044C8.63144 3 9.22218 3.29407 9.60016 3.79437L12.0179 6.99446Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const FolderSearch2Icon = /* @__PURE__ */ createTerraIcon({
  icon: FolderSearch2IconData,
  displayName: 'FolderSearch2Icon',
});

const FolderSearchIconData = [
  ['path', { d: "M8 6.99446H12.0179M12.0179 6.99446H20C21.1046 6.99446 22 7.88989 22 8.99446V11M12.0179 6.99446L9.30008 3.39718C9.11109 3.14703 8.81572 3 8.5022 3H3C2.44772 3 2 3.44772 2 4V19C2 20.1046 2.89543 21 4 21H12.0179", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M22 21L19.8529 18.8529M19.8529 18.8529C19.9675 18.7384 20.0739 18.6158 20.1714 18.486C20.602 17.913 20.8571 17.2006 20.8571 16.4286C20.8571 14.535 19.3221 13 17.4286 13C15.535 13 14 14.535 14 16.4286C14 18.3221 15.535 19.8571 17.4286 19.8571C18.3753 19.8571 19.2325 19.4734 19.8529 18.8529Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const FolderSearchIcon = /* @__PURE__ */ createTerraIcon({
  icon: FolderSearchIconData,
  displayName: 'FolderSearchIcon',
});

const FolderSecurityIconData = [
  ['path', { d: "M8 6.99446H12.0179M12.0179 6.99446H20C21.1046 6.99446 22 7.88989 22 8.99446V11M12.0179 6.99446L9.30008 3.39718C9.11109 3.14703 8.81572 3 8.5022 3H3C2.44772 3 2 3.44772 2 4V19C2 20.1046 2.89543 21 4 21H13", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M22 16.616V14.6449C22 14.3349 21.7723 14.0776 21.477 14.0248C20.2869 13.812 19.299 13.3387 18.817 13.0762C18.6197 12.9687 18.3803 12.9687 18.183 13.0762C17.701 13.3387 16.7131 13.812 15.523 14.0248C15.2277 14.0776 15 14.3349 15 14.6449V16.616C15 19.1874 17.5424 20.59 18.2935 20.9482C18.426 21.0114 18.574 21.0114 18.7065 20.9482C19.4576 20.59 22 19.1874 22 16.616Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", key: "1" }],
] as const;

export const FolderSecurityIcon = /* @__PURE__ */ createTerraIcon({
  icon: FolderSecurityIconData,
  displayName: 'FolderSecurityIcon',
});

const FolderShared01IconData = [
  ['path', { d: "M21.9993 21V21.75C22.4136 21.75 22.7493 21.4142 22.7493 21H21.9993ZM14.9961 21H14.2461C14.2461 21.4142 14.5819 21.75 14.9961 21.75V21ZM21.9993 20.25H14.9961V21.75H21.9993V20.25ZM15.7461 21C15.7461 19.4815 16.9777 18.25 18.4977 18.25V16.75C16.1499 16.75 14.2461 18.6525 14.2461 21H15.7461ZM18.4977 18.25C20.0177 18.25 21.2493 19.4815 21.2493 21H22.7493C22.7493 18.6525 20.8455 16.75 18.4977 16.75V18.25ZM19.4977 13.75C19.4977 14.302 19.05 14.75 18.4969 14.75V16.25C19.8777 16.25 20.9977 15.131 20.9977 13.75H19.4977ZM18.4969 14.75C17.9438 14.75 17.4961 14.302 17.4961 13.75H15.9961C15.9961 15.131 17.1161 16.25 18.4969 16.25V14.75ZM17.4961 13.75C17.4961 13.198 17.9438 12.75 18.4969 12.75V11.25C17.1161 11.25 15.9961 12.369 15.9961 13.75H17.4961ZM18.4969 12.75C19.05 12.75 19.4977 13.198 19.4977 13.75H20.9977C20.9977 12.369 19.8777 11.25 18.4969 11.25V12.75Z", fill: "currentColor", key: "0" }],
  ['path', { d: "M8 6.99446H12.0179M12.0179 6.99446H20C21.1046 6.99446 22 7.88989 22 8.99446V10M12.0179 6.99446L9.30008 3.39718C9.11109 3.14703 8.81572 3 8.5022 3H3C2.44772 3 2 3.44772 2 4V19C2 20.1046 2.89543 21 4 21H12.0179", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const FolderShared01Icon = /* @__PURE__ */ createTerraIcon({
  icon: FolderShared01IconData,
  displayName: 'FolderShared01Icon',
});

const FolderShared02IconData = [
  ['path', { d: "M19.1574 14.171C19.4037 14.6625 19.9124 15 20.4999 15C21.3288 15 22.0007 14.3284 22.0007 13.5C22.0007 12.6716 21.3288 12 20.4999 12C19.6711 12 18.9992 12.6716 18.9992 13.5C18.9992 13.7412 19.0561 13.9691 19.1574 14.171ZM19.1574 14.171L15.8395 15.829M15.8395 15.829C15.5931 15.3375 15.0844 15 14.4969 15C13.668 15 12.9961 15.6716 12.9961 16.5C12.9961 17.3284 13.668 18 14.4969 18C15.0844 18 15.5931 17.6625 15.8395 17.171M15.8395 15.829C15.9407 16.0309 15.9976 16.2588 15.9976 16.5C15.9976 16.7412 15.9407 16.9691 15.8395 17.171M15.8395 17.171L19.1574 18.829M19.1574 18.829C19.0561 19.0309 18.9992 19.2588 18.9992 19.5C18.9992 20.3284 19.6711 21 20.4999 21C21.3288 21 22.0007 20.3284 22.0007 19.5C22.0007 18.6716 21.3288 18 20.4999 18C19.9124 18 19.4037 18.3375 19.1574 18.829Z", stroke: "currentColor", strokeWidth: 1.5, key: "0" }],
  ['path', { d: "M8 6.99446H12.0179M12.0179 6.99446H20C21.1046 6.99446 22 7.89543 22 9M12.0179 6.99446L9.30008 3.39718C9.11109 3.14703 8.81572 3 8.5022 3H3C2.44772 3 2 3.44772 2 4V19C2 20.1046 2.89543 21 4 21H12.0179", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const FolderShared02Icon = /* @__PURE__ */ createTerraIcon({
  icon: FolderShared02IconData,
  displayName: 'FolderShared02Icon',
});

const FolderShared03IconData = [
  ['path', { d: "M12.0064 18V21.9846M20.5 22H3.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M8 5.5H12.0179M12.0179 5.5H20C21.1046 5.5 22 6.39543 22 7.5V16C22 17.1046 21.1046 18 20 18H4C2.89543 18 2 17.1046 2 16V3C2 2.44772 2.44772 2 3 2H8.54185C8.83274 2 9.10922 2.12667 9.29918 2.34698L12.0179 5.5Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const FolderShared03Icon = /* @__PURE__ */ createTerraIcon({
  icon: FolderShared03IconData,
  displayName: 'FolderShared03Icon',
});

const FolderSymlinkIconData = [
  ['path', { d: "M12 14L12.5303 14.5303C12.8232 14.2374 12.8232 13.7625 12.5303 13.4696L12 14ZM8.46969 16.4697C8.1768 16.7626 8.1768 17.2374 8.4697 17.5303C8.76259 17.8232 9.23747 17.8232 9.53036 17.5303L9.00002 17L8.46969 16.4697ZM9.53033 10.4697C9.23743 10.1768 8.76256 10.1768 8.46967 10.4697C8.17678 10.7626 8.17678 11.2374 8.46967 11.5303L9 11L9.53033 10.4697ZM11 14.75C11.4142 14.75 11.75 14.4142 11.75 14C11.75 13.5858 11.4142 13.25 11 13.25V14V14.75ZM8 6.24446C7.58579 6.24446 7.25 6.58024 7.25 6.99446C7.25 7.40867 7.58579 7.74446 8 7.74446V6.99446V6.24446ZM9.60016 3.79437L9.00175 4.24648V4.24648L9.60016 3.79437ZM1.25 9.99446C1.25 10.4087 1.58579 10.7445 2 10.7445C2.41421 10.7445 2.75 10.4087 2.75 9.99446H2H1.25ZM12 14L11.4697 13.4697L8.46969 16.4697L9.00002 17L9.53036 17.5303L12.5303 14.5303L12 14ZM9 11L8.46967 11.5303L11.4697 14.5303L12 14L12.5303 13.4696L9.53033 10.4697L9 11ZM11 14V13.25H4V14V14.75H11V14ZM8 6.99446V7.74446H12.0179V6.99446V6.24446H8V6.99446ZM12.0179 6.99446V7.74446H20V6.99446V6.24446H12.0179V6.99446ZM9.60016 3.79437L9.00175 4.24648L11.4195 7.44657L12.0179 6.99446L12.6163 6.54234L10.1986 3.34225L9.60016 3.79437ZM22 8.99446H21.25V19H22H22.75V8.99446H22ZM4 21V21.75H20V21V20.25H4V21ZM4 3V3.75H8.0044V3V2.25H4V3ZM20 6.99446V7.74446C20.6904 7.74446 21.25 8.3041 21.25 8.99446H22H22.75C22.75 7.47567 21.5188 6.24446 20 6.24446V6.99446ZM2 5H2.75C2.75 4.30964 3.30964 3.75 4 3.75V3V2.25C2.48122 2.25 1.25 3.48122 1.25 5H2ZM9.60016 3.79437L10.1986 3.34225C9.67884 2.65434 8.86657 2.25 8.0044 2.25V3V3.75C8.3963 3.75 8.76551 3.93379 9.00175 4.24648L9.60016 3.79437ZM2 19H1.25C1.25 20.5188 2.48122 21.75 4 21.75V21V20.25C3.30964 20.25 2.75 19.6904 2.75 19H2ZM22 19H21.25C21.25 19.6904 20.6904 20.25 20 20.25V21V21.75C21.5188 21.75 22.75 20.5188 22.75 19H22ZM2 19H2.75V16H2H1.25V19H2ZM2 9.99446H2.75V5H2H1.25V9.99446H2ZM4 14V13.25C2.48122 13.25 1.25 14.4812 1.25 16H2H2.75C2.75 15.3096 3.30964 14.75 4 14.75V14Z", fill: "currentColor", key: "0" }],
] as const;

export const FolderSymlinkIcon = /* @__PURE__ */ createTerraIcon({
  icon: FolderSymlinkIconData,
  displayName: 'FolderSymlinkIcon',
});

const FolderSyncIconData = [
  ['path', { d: "M8 6.49446H12.0179M12.0179 6.49446H20C21.1046 6.49446 22 7.38989 22 8.49446V10.5M12.0179 6.49446L9.60016 3.29437C9.22218 2.79407 8.63144 2.5 8.0044 2.5H4C2.89543 2.5 2 3.39543 2 4.5V18.5C2 19.6046 2.89543 20.5 4 20.5H11", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M21.4649 15C20.7733 13.8044 19.4806 13 18 13C16.4726 13 15.1451 13.8561 14.4713 15.1147M14.5351 19C15.2267 20.1956 16.5194 21 18 21C19.5227 21 20.8467 20.1492 21.5224 18.897M17 15.5H14V12.5M19 18.5H22V21.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const FolderSyncIcon = /* @__PURE__ */ createTerraIcon({
  icon: FolderSyncIconData,
  displayName: 'FolderSyncIcon',
});

const FolderTransferIconData = [
  ['path', { d: "M15.5 3.5C19.7 3.5 21.5 5.9 21.5 9.5L19.5 8.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M8.5 20.5C4.3 20.5 2.5 18.1 2.5 14.5L4.5 15.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M5.879 2.4967L3.49902 2.49902C2.94712 2.49956 2.5 2.94712 2.5 3.49902V10.5C2.5 11.0523 2.94772 11.5 3.5 11.5H11.4996C12.0519 11.5 12.4996 11.0523 12.4996 10.5V5.50235C12.4996 4.94915 12.0505 4.50105 11.4973 4.50235L7.49947 4.51172L6.77588 3.05245C6.60692 2.71172 6.25931 2.49633 5.879 2.4967Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M17.2237 13.0564C17.3927 12.7156 17.7403 12.5002 18.1206 12.5006L20.5006 12.5029C21.0525 12.5035 21.4996 12.951 21.4996 13.5029V20.5039C21.4996 21.0562 21.0519 21.5039 20.4996 21.5039H12.5C11.9477 21.5039 11.5 21.0562 11.5 20.5039V15.5063C11.5 14.9531 11.9491 14.505 12.5023 14.5063L16.5001 14.5156L17.2237 13.0564Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "3" }],
] as const;

export const FolderTransferIcon = /* @__PURE__ */ createTerraIcon({
  icon: FolderTransferIconData,
  displayName: 'FolderTransferIcon',
});

const FolderTreeIconData = [
  ['path', { d: "M12 9V4C12 3.44772 12.4477 3 13 3H15C15.3148 3 15.6111 3.14819 15.8 3.4L17 5H20C20.5523 5 21 5.44772 21 6V9C21 9.55228 20.5523 10 20 10H13C12.4477 10 12 9.55228 12 9Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M3 3V5C3 6.10457 3.89543 7 5 7H8", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M3 3V16C3 17.1046 3.89543 18 5 18H8", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M12 20V15C12 14.4477 12.4477 14 13 14H15C15.3148 14 15.6111 14.1482 15.8 14.4L17 16H20C20.5523 16 21 16.4477 21 17V20C21 20.5523 20.5523 21 20 21H13C12.4477 21 12 20.5523 12 20Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "3" }],
] as const;

export const FolderTreeIcon = /* @__PURE__ */ createTerraIcon({
  icon: FolderTreeIconData,
  displayName: 'FolderTreeIcon',
});

const FolderUnknownIconData = [
  ['path', { d: "M16.9961 14C16.9961 12.6193 18.1159 11.5 19.4973 11.5C20.8786 11.5 21.9984 12.6193 21.9984 14C21.9984 14.8571 21.5668 15.6135 20.9091 16.0639C20.2259 16.5317 19.4985 17.172 19.5 18M19.625 20.75H19.5M19.75 20.75C19.75 20.8881 19.6381 21 19.5 21C19.3619 21 19.25 20.8881 19.25 20.75C19.25 20.6119 19.3619 20.5 19.5 20.5C19.6381 20.5 19.75 20.6119 19.75 20.75Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M8 6.99446H12.0179M12.0179 6.99446H20C21.1046 6.99446 22 7.89543 22 9M12.0179 6.99446L9.30008 3.39718C9.11109 3.14703 8.81572 3 8.5022 3H3C2.44772 3 2 3.44772 2 4V19C2 20.1046 2.89543 21 4 21H16", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const FolderUnknownIcon = /* @__PURE__ */ createTerraIcon({
  icon: FolderUnknownIconData,
  displayName: 'FolderUnknownIcon',
});

const FolderUnlockedIconData = [
  ['path', { d: "M16.75 16V14.75C16.75 13.7835 17.5335 13 18.5 13C18.9768 13 19.4091 13.1907 19.7247 13.5M15 16V21H22V16H15Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M8 6.99446H12.0179M12.0179 6.99446H20C21.1046 6.99446 22 7.88989 22 8.99446V11M12.0179 6.99446L9.30008 3.39718C9.11109 3.14703 8.81572 3 8.5022 3H3C2.44772 3 2 3.44772 2 4V19C2 20.1046 2.89543 21 4 21H12.0179", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const FolderUnlockedIcon = /* @__PURE__ */ createTerraIcon({
  icon: FolderUnlockedIconData,
  displayName: 'FolderUnlockedIcon',
});

const FolderUploadIconData = [
  ['path', { d: "M21.5 16L19 13.5L16.5 16M19 21L19 14.1088", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M8 6.99446H12.0179M12.0179 6.99446H20C21.1046 6.99446 22 7.88989 22 8.99446V11M12.0179 6.99446L9.30008 3.39718C9.11109 3.14703 8.81572 3 8.5022 3H3C2.44772 3 2 3.44772 2 4V19C2 20.1046 2.89543 21 4 21H13.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const FolderUploadIcon = /* @__PURE__ */ createTerraIcon({
  icon: FolderUploadIconData,
  displayName: 'FolderUploadIcon',
});

const FolderVideoIconData = [
  ['path', { d: "M8 6.99446H12.0179M12.0179 6.99446H20C21.1046 6.99446 22 7.88989 22 8.99446V13M12.0179 6.99446L9.30008 3.39718C9.11109 3.14703 8.81572 3 8.5022 3H3C2.44772 3 2 3.44772 2 4V19C2 20.1046 2.89543 21 4 21H10", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M19 18.5L22 20V16L19 17.5M19 18.5V17.5M19 18.5V20C19 20.5523 18.5523 21 18 21H14C13.4477 21 13 20.5523 13 20V16C13 15.4477 13.4477 15 14 15H18C18.5523 15 19 15.4477 19 16V17.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "1" }],
] as const;

export const FolderVideoIcon = /* @__PURE__ */ createTerraIcon({
  icon: FolderVideoIconData,
  displayName: 'FolderVideoIcon',
});

const FolderViewIconData = [
  ['path', { d: "M8 6.99446H12.0179M12.0179 6.99446H20C21.1046 6.99446 22 7.88989 22 8.99446V13M12.0179 6.99446L9.30008 3.39718C9.11109 3.14703 8.81572 3 8.5022 3H3C2.44772 3 2 3.44772 2 4V19C2 20.1046 2.89543 21 4 21H10", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M17.125 18H17M17.25 18C17.25 18.1381 17.1381 18.25 17 18.25C16.8619 18.25 16.75 18.1381 16.75 18C16.75 17.8619 16.8619 17.75 17 17.75C17.1381 17.75 17.25 17.8619 17.25 18Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M17 21C19.7614 21 22 18 22 18C22 18 19.7614 15 17 15C14.2386 15 12 18 12 18C12 18 14.2386 21 17 21Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "2" }],
] as const;

export const FolderViewIcon = /* @__PURE__ */ createTerraIcon({
  icon: FolderViewIconData,
  displayName: 'FolderViewIcon',
});

const FolderZipIconData = [
  ['path', { d: "M8 6.99446H12.0179M12.0179 6.99446L9.30008 3.39718C9.11109 3.14703 8.81572 3 8.5022 3H3C2.44772 3 2 3.44772 2 4V19C2 20.1046 2.89543 21 4 21H20C21.1046 21 22 20.1046 22 19V8.99446C22 7.88989 21.1046 6.99446 20 6.99446H18.5M12.0179 6.99446H15V10.9972M15 15H13M15 15H17M15 15V10.9972M15 10.9972H13M15 10.9972H17", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
] as const;

export const FolderZipIcon = /* @__PURE__ */ createTerraIcon({
  icon: FolderZipIconData,
  displayName: 'FolderZipIcon',
});

const FoldersIconData = [
  ['path', { d: "M21 6.5H14.9271C14.2795 6.5 13.6719 6.18638 13.2968 5.65841L11.6506 3.34159C11.2755 2.81362 10.6679 2.5 10.0202 2.5L3 2.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M8.68421 9H12M12 9H19C20.1046 9 21 9.89543 21 11V19.5C21 20.6046 20.1046 21.5 19 21.5H5C3.89543 21.5 3 20.6046 3 19.5V6.5C3 5.94772 3.44772 5.5 4 5.5H9.10083C9.43274 5.5 9.74302 5.66468 9.92903 5.93957L12 9Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const FoldersIcon = /* @__PURE__ */ createTerraIcon({
  icon: FoldersIconData,
  displayName: 'FoldersIcon',
});

const FootballPitchIconData = [
  ['circle', { cx: 12, cy: 12, r: 2, stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M12 10V4M12 14V20", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M22 9H19.5C18.9477 9 18.5 9.44772 18.5 10V14C18.5 14.5523 18.9477 15 19.5 15H22", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M2 9H4.5C5.05228 9 5.5 9.44772 5.5 10V14C5.5 14.5523 5.05228 15 4.5 15H2", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "3" }],
  ['path', { d: "M20 4H4C2.89543 4 2 4.89543 2 6V18C2 19.1046 2.89543 20 4 20H20C21.1046 20 22 19.1046 22 18V6C22 4.89543 21.1046 4 20 4Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "4" }],
] as const;

export const FootballPitchIcon = /* @__PURE__ */ createTerraIcon({
  icon: FootballPitchIconData,
  displayName: 'FootballPitchIcon',
});

const FootballIconData = [
  ['path', { d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z", stroke: "currentColor", strokeWidth: 1.5, key: "0" }],
  ['path', { d: "M11.7077 9.34893C11.882 9.21702 12.118 9.21702 12.2923 9.34893L14.545 11.054C14.7193 11.1859 14.7922 11.4197 14.7256 11.6332L13.8652 14.3921C13.7986 14.6055 13.6077 14.75 13.3923 14.75H10.6077C10.3923 14.75 10.2014 14.6055 10.1348 14.3921L9.27437 11.6332C9.20781 11.4197 9.28073 11.1859 9.45499 11.054L11.7077 9.34893Z", stroke: "currentColor", strokeWidth: 1.5, key: "1" }],
  ['path', { d: "M12 9V5M15 11L19 9.5M14 15L16 18M10 14.5L8 17M9 11.5L5 10.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M9 2.5L12.0165 4.62241L15 2.5M2 12.7998L5.19655 10.4388L3.55548 6.72045M19.4703 18.8531L15.6158 18.1555L14.2655 22M20.0298 6.19586L18.8035 9.38978L22 11.7507M8.00992 21.4059L8.05142 17.1665L4.00331 17.21", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "3" }],
] as const;

export const FootballIcon = /* @__PURE__ */ createTerraIcon({
  icon: FootballIconData,
  displayName: 'FootballIcon',
});

const ForgotPasswordIconData = [
  ['path', { d: "M6.5 9V6.5C6.5 4.01472 8.51472 2 11 2C13.4853 2 15.5 4.01472 15.5 6.5V9", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M19 9H5C3.89543 9 3 9.89543 3 11V20C3 21.1046 3.89543 22 5 22H14", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M19.125 21.75H19M19.25 21.75C19.25 21.8881 19.1381 22 19 22C18.8619 22 18.75 21.8881 18.75 21.75C18.75 21.6119 18.8619 21.5 19 21.5C19.1381 21.5 19.25 21.6119 19.25 21.75Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M17 15C17 13.8954 17.8954 13 19 13C20.1046 13 21 13.8954 21 15C21 15.5778 20.755 16.0983 20.3632 16.4634C19.7572 17.0282 19 17.6716 19 18.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "3" }],
  ['path', { d: "M12.125 15.5H12M12.25 15.5C12.25 15.6381 12.1381 15.75 12 15.75C11.8619 15.75 11.75 15.6381 11.75 15.5C11.75 15.3619 11.8619 15.25 12 15.25C12.1381 15.25 12.25 15.3619 12.25 15.5Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "4" }],
  ['path', { d: "M8.125 15.5H8M8.25 15.5C8.25 15.6381 8.13807 15.75 8 15.75C7.86193 15.75 7.75 15.6381 7.75 15.5C7.75 15.3619 7.86193 15.25 8 15.25C8.13807 15.25 8.25 15.3619 8.25 15.5Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "5" }],
] as const;

export const ForgotPasswordIcon = /* @__PURE__ */ createTerraIcon({
  icon: ForgotPasswordIconData,
  displayName: 'ForgotPasswordIcon',
});

const ForkIconData = [
  ['path', { d: "M19 5L15.3333 8.66667M13.5 6.83333L17.1667 10.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M22 6.68722L17.7971 10.8898C16.9852 11.7016 15.8891 12.1657 14.741 12.1836H13.5L4.77175 21.4921C4.15326 22.1537 3.10957 22.1713 2.46911 21.5309C1.82872 20.8906 1.84625 19.8471 2.50778 19.2287L11.8157 10.5V9.25855C11.8335 8.11046 12.2976 7.01438 13.1096 6.20246L17.3124 2", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const ForkIcon = /* @__PURE__ */ createTerraIcon({
  icon: ForkIconData,
  displayName: 'ForkIcon',
});

const ForrstIconData = [
  ['path', { d: "M13.5 18.5L16.5 15.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M13.5 14.5L15 13", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M10.5 16.5L8 14.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M9.42495 21L3.07659 21C2.25689 21 1.73875 20.1297 2.13683 19.4215L11.0602 3.54651C11.4698 2.81783 12.5302 2.81783 12.9398 3.54651L21.8632 19.4215C22.2613 20.1297 21.7431 21 20.9234 21L14.575 21C13.9813 21 13.5 20.5243 13.5 19.9375V12.5331C13.5 11.9463 13.0187 11.4706 12.425 11.4706H11.575C10.9813 11.4706 10.5 11.9463 10.5 12.5331V19.9375C10.5 20.5243 10.0187 21 9.42495 21Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "3" }],
] as const;

export const ForrstIcon = /* @__PURE__ */ createTerraIcon({
  icon: ForrstIconData,
  displayName: 'ForrstIcon',
});

const FortressIconData = [
  ['path', { d: "M1 20.9817H9V17.9849C9 16.3297 10.3431 14.988 12 14.988C13.6569 14.988 15 16.3297 15 17.9849V20.9817H23", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M7 9H6", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M18 9H17", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M3.01953 20.9932L3.01955 3.01194C3.01955 3.00643 3.02402 3.00195 3.02955 3.00195H5.00731L5.50124 4.99968H7.51309L8.00426 3.00195H9.99486C10.0004 3.00195 10.0049 3.00643 10.0049 3.01194V8.9731C10.0049 8.97862 10.0093 8.98309 10.0149 8.98309H14.0254C14.031 8.98309 14.0355 8.97857 14.0354 8.97302L13.9831 3.01203C13.9831 3.00648 13.9876 3.00195 13.9931 3.00195H16.0022L16.5004 4.98392H18.5012L18.9972 3.00706H20.9832C20.9887 3.00706 20.9932 3.01153 20.9932 3.01705V20.999", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "3" }],
] as const;

export const FortressIcon = /* @__PURE__ */ createTerraIcon({
  icon: FortressIconData,
  displayName: 'FortressIcon',
});

const Forward01IconData = [
  ['path', { d: "M9.47814 19.0621C8.81187 19.4721 7.95404 18.9928 7.95404 18.2104V5.78957C7.95404 5.00725 8.81187 4.5279 9.47814 4.93791L19.5701 11.1484C20.2046 11.5388 20.2046 12.4612 19.5701 12.8517L9.47814 19.0621Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M3.95404 4.5L3.95404 19.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const Forward01Icon = /* @__PURE__ */ createTerraIcon({
  icon: Forward01IconData,
  displayName: 'Forward01Icon',
});

const Forward02IconData = [
  ['path', { d: "M13.9453 17.8986C13.2826 18.3625 12.3719 17.8884 12.3719 17.0793V6.92065C12.3719 6.11163 13.2826 5.63748 13.9454 6.10142L21.2016 11.1808C21.7703 11.5789 21.7703 12.4211 21.2016 12.8192L13.9453 17.8986Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M3.94535 17.8986C3.28257 18.3625 2.37189 17.8884 2.37189 17.0793V6.92065C2.37189 6.11163 3.28257 5.63748 3.94535 6.10142L11.2016 11.1808C11.7703 11.5789 11.7703 12.4211 11.2016 12.8192L3.94535 17.8986Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "1" }],
] as const;

export const Forward02Icon = /* @__PURE__ */ createTerraIcon({
  icon: Forward02IconData,
  displayName: 'Forward02Icon',
});

const FourCircleIconData = [
  ['path', { d: "M15 7V12.5M15 12.5V17M15 12.5H9.43601C9.19521 12.5 9 12.3048 9 12.064C9 12.0216 9.00619 11.9794 9.01839 11.9387L10.5 7", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const FourCircleIcon = /* @__PURE__ */ createTerraIcon({
  icon: FourCircleIconData,
  displayName: 'FourCircleIcon',
});

const FourFinger02IconData = [
  ['path', { d: "M11.0015 5.5C11.0015 4.67157 10.3299 4 9.50147 4C8.67304 4 8.00147 4.67157 8.00147 5.5L8.00158 9M11.0015 5.5V10.5M11.0015 5.5V3.5001C11.0015 2.67162 11.6731 2 12.5016 2C13.3301 2 14.0017 2.67162 14.0017 3.5001V5.5M18.0013 22.0002L18.0013 20.5L19.1248 19.0957C19.6922 18.3864 20.0013 17.5052 20.0013 16.5969V7.49981C20.0013 6.67149 19.3298 6 18.5015 6C17.6732 6 17.0017 6.67149 17.0017 7.49981M8.00168 22V20.5L4.6141 15.844C4.21503 15.2955 4.00006 14.6346 4.00006 13.9563C4.00006 13.0309 4.39964 12.1505 5.09622 11.5412L8.00158 9M8.00168 13.5L8.00158 9M14.0017 5.5V11.5M14.0017 5.5C14.0017 4.67157 14.6733 4 15.5017 4C16.3301 4 17.0017 4.67157 17.0017 5.5V7.49981M17.0017 7.49981V12.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
] as const;

export const FourFinger02Icon = /* @__PURE__ */ createTerraIcon({
  icon: FourFinger02IconData,
  displayName: 'FourFinger02Icon',
});

const FourFinger03IconData = [
  ['path', { d: "M14 5.5V4C14 3.17157 13.3284 2.5 12.5 2.5C11.6716 2.5 11 3.17157 11 4V5M14 5.5V12.3546M14 5.5C14 4.67157 14.6716 4 15.5 4C16.3284 4 17 4.67157 17 5.5V13M11 5V11.5M11 5C11 4.17157 10.3284 3.5 9.5 3.5C8.67157 3.5 8 4.17157 8 5V9M8 14V9M8 9L4.87868 12.1213C4.31607 12.6839 4 13.447 4 14.2426V14.5917C4 15.1839 4.17531 15.763 4.50385 16.2558L7.1094 20.1641C7.6658 20.9987 8.60249 21.5 9.60555 21.5H17C18.6569 21.5 20 20.1569 20 18.5V8C20 7.17157 19.3284 6.5 18.5 6.5C17.6716 6.5 17 7.17157 17 8", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
] as const;

export const FourFinger03Icon = /* @__PURE__ */ createTerraIcon({
  icon: FourFinger03IconData,
  displayName: 'FourFinger03Icon',
});

const FourSquareIconData = [
  ['path', { d: "M15 7V12.5M15 12.5V17M15 12.5H9.43601C9.19521 12.5 9 12.3048 9 12.064C9 12.0216 9.00619 11.9794 9.01839 11.9387L10.5 7", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M4.5 21.5L19.5 21.5C20.6046 21.5 21.5 20.6046 21.5 19.5V4.5C21.5 3.39543 20.6046 2.5 19.5 2.5H4.5C3.39543 2.5 2.5 3.39543 2.5 4.5V19.5C2.5 20.6046 3.39543 21.5 4.5 21.5Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const FourSquareIcon = /* @__PURE__ */ createTerraIcon({
  icon: FourSquareIconData,
  displayName: 'FourSquareIcon',
});

const FoursquareIconData = [
  ['path', { d: "M18 8.5H12", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M5 2.99999C5.00001 2.44771 5.44772 2 6 2L17.9991 2C18.6145 2 19.0838 2.55042 18.9866 3.15801L16.9998 14.5H10.4998L5.00019 22L5 2.99999Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "1" }],
] as const;

export const FoursquareIcon = /* @__PURE__ */ createTerraIcon({
  icon: FoursquareIconData,
  displayName: 'FoursquareIcon',
});

const FramerIconData = [
  ['path', { d: "M12 21L5.99999 15H12V21Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M12 9L17.9829 14.9829C17.9892 14.9892 17.9848 15 17.9759 15H6.01C6.00448 15 6 14.9955 6 14.99V9H12ZM12 9L6.01709 3.02196C6.01078 3.01566 6.01525 3.00488 6.02416 3.00488H18V9H12Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "1" }],
] as const;

export const FramerIcon = /* @__PURE__ */ createTerraIcon({
  icon: FramerIconData,
  displayName: 'FramerIcon',
});

const FrameworksIconData = [
  ['path', { d: "M13 2H11C10.4477 2 10 2.44772 10 3V5C10 5.55228 10.4477 6 11 6H13C13.5523 6 14 5.55228 14 5V3C14 2.44772 13.5523 2 13 2Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M13 18H11C10.4477 18 10 18.4477 10 19V21C10 21.5523 10.4477 22 11 22H13C13.5523 22 14 21.5523 14 21V19C14 18.4477 13.5523 18 13 18Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M6 10H4C3.44772 10 3 10.4477 3 11V13C3 13.5523 3.44772 14 4 14H6C6.55228 14 7 13.5523 7 13V11C7 10.4477 6.55228 10 6 10Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M20 10H18C17.4477 10 17 10.4477 17 11V13C17 13.5523 17.4477 14 18 14H20C20.5523 14 21 13.5523 21 13V11C21 10.4477 20.5523 10 20 10Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "3" }],
  ['path', { d: "M14 4H17C18.1046 4 19 4.89543 19 6V7", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "4" }],
  ['path', { d: "M10 4H7C5.89543 4 5 4.89543 5 6V7", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "5" }],
  ['path', { d: "M14 20H17C18.1046 20 19 19.1046 19 18V17", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "6" }],
  ['path', { d: "M10 20H7C5.89543 20 5 19.1046 5 18V17", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "7" }],
  ['path', { d: "M10 12H14", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "8" }],
] as const;

export const FrameworksIcon = /* @__PURE__ */ createTerraIcon({
  icon: FrameworksIconData,
  displayName: 'FrameworksIcon',
});

const FrenchFries01IconData = [
  ['path', { d: "M7.5 18C8.88071 18 10 16.8807 10 15.5C10 14.1193 8.88071 13 7.5 13C7.32877 13 7.16155 13.0172 7 13.05", stroke: "currentColor", strokeWidth: 1.6, key: "0" }],
  ['path', { d: "M7.5 8.5L8 4L10.6 5M10 9.5L11 2L14 3L12.5 10.5M13 11L15.5 6H18.5L15 12", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M17.5 12.5L5.5 8L8.5 22L17.5 12.5Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "2" }],
] as const;

export const FrenchFries01Icon = /* @__PURE__ */ createTerraIcon({
  icon: FrenchFries01IconData,
  displayName: 'FrenchFries01Icon',
});

const FrenchFries02IconData = [
  ['path', { d: "M14 13V2H10V13", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M18.5 10L20 7L16.5 5L14 10", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M9.35688 8.38587C9.56999 8.74106 10.0307 8.85623 10.3859 8.64312C10.7411 8.43001 10.8562 7.96931 10.6431 7.61413L10 8L9.35688 8.38587ZM7 3L7.64312 2.61413C7.43321 2.26427 6.98214 2.14639 6.6279 2.34882L7 3ZM3.5 5L3.1279 4.34882C2.95418 4.44808 2.82733 4.61264 2.77555 4.80589C2.72377 4.99915 2.75135 5.20508 2.85217 5.3779L3.5 5ZM10 8L10.6431 7.61413L7.64312 2.61413L7 3L6.35688 3.38587L9.35688 8.38587L10 8ZM7 3L6.6279 2.34882L3.1279 4.34882L3.5 5L3.8721 5.65118L7.3721 3.65118L7 3ZM3.5 5L2.85217 5.3779L6.35217 11.3779L7 11L7.64783 10.6221L4.14783 4.6221L3.5 5Z", fill: "currentColor", key: "2" }],
  ['path', { d: "M3 10C8 10 8.80755 12.7551 9 13.5H15C15.1924 12.7551 16 10 21 10L18.3787 20.4851C18.1561 21.3754 17.3562 22 16.4384 22H7.56155C6.64382 22 5.84385 21.3754 5.62127 20.4851L3 10Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "3" }],
] as const;

export const FrenchFries02Icon = /* @__PURE__ */ createTerraIcon({
  icon: FrenchFries02IconData,
  displayName: 'FrenchFries02Icon',
});

const FridgeIconData = [
  ['path', { d: "M17 2H7C5.89543 2 5 2.89543 5 4V20C5 21.1046 5.89543 22 7 22H17C18.1046 22 19 21.1046 19 20V4C19 2.89543 18.1046 2 17 2Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M5 11H19", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M9 18L9 15", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M9 7L9 6", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "3" }],
] as const;

export const FridgeIcon = /* @__PURE__ */ createTerraIcon({
  icon: FridgeIconData,
  displayName: 'FridgeIcon',
});

const FrisbeeIconData = [
  ['path', { d: "M4 22L7 19", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M2 20L5 17", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M19.7161 2.44925C21.0334 3.76659 19.3553 7.58059 15.9679 10.968C12.5805 14.3555 8.76656 16.0337 7.44924 14.7163M19.7161 2.44925C18.3988 1.1319 14.5848 2.81006 11.1974 6.19752M19.7161 2.44925L21.4198 4.15275C22.9253 5.65829 21.3998 9.62485 18.0124 13.0123C14.625 16.3998 10.6585 17.9254 9.15297 16.4198L7.44924 14.7163M7.44924 14.7163C6.13192 13.399 7.81005 9.58498 11.1974 6.19752M11.1974 6.19752C8.93918 8.45582 7.71872 10.897 8.47148 11.6498C9.22423 12.4025 11.6651 11.1821 13.9234 8.92375C16.1817 6.66545 17.4021 4.22449 16.6494 3.47172C15.8966 2.71895 13.4557 3.93921 11.1974 6.19752Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const FrisbeeIcon = /* @__PURE__ */ createTerraIcon({
  icon: FrisbeeIconData,
  displayName: 'FrisbeeIcon',
});

const FryIconData = [
  ['path', { d: "M22 9.5C22 13.6421 18.6421 17 14.5 17C10.3579 17 7 13.6421 7 9.5C7 5.35786 10.3579 2 14.5 2C18.6421 2 22 5.35786 22 9.5Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M19 9C19 11.2091 17.2091 13 15 13C12.7909 13 11 11.2091 11 9C11 6.79086 12.7909 5 15 5C17.2091 5 19 6.79086 19 9Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M2 22L9 15", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M15.125 9H15M15.25 9C15.25 9.13807 15.1381 9.25 15 9.25C14.8619 9.25 14.75 9.13807 14.75 9C14.75 8.86193 14.8619 8.75 15 8.75C15.1381 8.75 15.25 8.86193 15.25 9Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", key: "3" }],
] as const;

export const FryIcon = /* @__PURE__ */ createTerraIcon({
  icon: FryIconData,
  displayName: 'FryIcon',
});

const Fuel01IconData = [
  ['path', { d: "M13.6667 4.5H6C4.89543 4.5 4 5.39543 4 6.5V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20V9.5C20 9.18524 19.8518 8.88885 19.6 8.7L14.2667 4.7C14.0936 4.57018 13.883 4.5 13.6667 4.5Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M13 8L17 11", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M12 18C13.1046 18 14 17.1605 14 16.125C14 14.875 12 13 12 13C12 13 10 14.875 10 16.125C10 17.1605 10.8954 18 12 18Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M6 4.5V3C6 2.44772 6.44772 2 7 2H8.5C9.05228 2 9.5 2.44772 9.5 3V4.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "3" }],
] as const;

export const Fuel01Icon = /* @__PURE__ */ createTerraIcon({
  icon: Fuel01IconData,
  displayName: 'Fuel01Icon',
});

const Fuel02IconData = [
  ['path', { d: "M13.6667 4.5H6C4.89543 4.5 4 5.39543 4 6.5V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20V9.5C20 9.18524 19.8518 8.88885 19.6 8.7L14.2667 4.7C14.0936 4.57018 13.883 4.5 13.6667 4.5Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M13 8L17 11", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M12 18C13.1046 18 14 17.1605 14 16.125C14 14.875 12 13 12 13C12 13 10 14.875 10 16.125C10 17.1605 10.8954 18 12 18Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M6 4.5V3C6 2.44772 6.44772 2 7 2H8.5C9.05228 2 9.5 2.44772 9.5 3V4.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "3" }],
] as const;

export const Fuel02Icon = /* @__PURE__ */ createTerraIcon({
  icon: Fuel02IconData,
  displayName: 'Fuel02Icon',
});

const FuelStationIconData = [
  ['path', { d: "M4 10H16", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M4 21V5C4 3.89543 4.89543 3 6 3H14C15.1046 3 16 3.89543 16 5V21", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M10 13L8.5 15.5H11.5L10 18", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M2 21H18", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "3" }],
  ['path', { d: "M16 14H19V16.5C19 17.3284 19.6716 18 20.5 18C21.3284 18 22 17.3284 22 16.5V8.99999L20.7764 6.55289C20.607 6.21405 20.2607 6.00004 19.8819 6.0001L19 6.00025", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "4" }],
] as const;

export const FuelStationIcon = /* @__PURE__ */ createTerraIcon({
  icon: FuelStationIconData,
  displayName: 'FuelStationIcon',
});

const FuelIconData = [
  ['path', { d: "M5 6V3.5H9V6", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M15 5L18 5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", key: "1" }],
  ['path', { d: "M19 2H14C12.8954 2 12 2.89543 12 4V6H5C3.89543 6 3 6.89543 3 8V20C3 21.1046 3.89543 22 5 22H19C20.1046 22 21 21.1046 21 20V4C21 2.89543 20.1046 2 19 2Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M12 10.5C11.1129 11.3354 9 13.1229 9 14.5873C9 16.0231 10.136 17.5 12 17.5C13.864 17.5 15 16.0231 15 14.5873C15 13.1229 12.8871 11.3354 12 10.5Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "3" }],
] as const;

export const FuelIcon = /* @__PURE__ */ createTerraIcon({
  icon: FuelIconData,
  displayName: 'FuelIcon',
});

const FullScreenIconData = [
  ['path', { d: "M3 8.5V5C3 3.89543 3.89543 3 5 3H8.5M21 8.5V5C21 3.89543 20.1046 3 19 3H15.5M15.5 21H19C20.1046 21 21 20.1046 21 19V15.5M8.5 21H5C3.89543 21 3 20.1046 3 19V15.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
] as const;

export const FullScreenIcon = /* @__PURE__ */ createTerraIcon({
  icon: FullScreenIconData,
  displayName: 'FullScreenIcon',
});

const FullSignalIconData = [
  ['path', { d: "M18.5 5H17V19H18.5M18.5 5H20V19H18.5M18.5 5V19", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M12 8H10.5V19H12M12 8H13.5V19H12M12 8V19", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M5.5 12H4V19H5.5M5.5 12H7V19H5.5M5.5 12V19", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
] as const;

export const FullSignalIcon = /* @__PURE__ */ createTerraIcon({
  icon: FullSignalIconData,
  displayName: 'FullSignalIcon',
});

const FullscreenIconData = [
  ['path', { d: "M21 7V5C21 3.89543 20.1046 3 19 3H17M3 7V5C3 3.89543 3.89543 3 5 3H7M21 17V19C21 20.1046 20.1046 21 19 21H17M3 17V19C3 20.1046 3.89543 21 5 21H7", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
] as const;

export const FullscreenIcon = /* @__PURE__ */ createTerraIcon({
  icon: FullscreenIconData,
  displayName: 'FullscreenIcon',
});

const FunctionCircleIconData = [
  ['path', { d: "M8.5 15.5C8.63206 15.9782 8.89835 16.5 9.59365 16.5C10.7968 16.5 11.0976 15.5 12 12C12.9024 8.5 13.2032 7.5 14.4064 7.5C15.1016 7.5 15.3679 8.02179 15.5 8.5M10.5417 10.75H14.4064", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['circle', { cx: 12, cy: 12, r: 10, stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "1" }],
] as const;

export const FunctionCircleIcon = /* @__PURE__ */ createTerraIcon({
  icon: FunctionCircleIconData,
  displayName: 'FunctionCircleIcon',
});

const FunctionOfXIconData = [
  ['path', { d: "M14.5 14H14.882C15.2607 14 15.607 14.214 15.7764 14.5528L17.2236 17.4472C17.393 17.786 17.7393 18 18.118 18H18.5M19 14C18.3705 14 17.7777 14.2964 17.4 14.8L15.6 17.2C15.2223 17.7036 14.6295 18 14 18", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M2 18.2222C2.18866 19.0724 2.56908 20 3.56235 20C5.28118 20 5.71088 18.2222 7 12C8.28912 5.77778 8.71882 4 10.4376 4C11.4309 4 11.8113 4.92763 12 5.77778M4.5 10H10.4376", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
  ['path', { d: "M21 12C22.3804 15.253 22.2854 16.9808 21 20", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "2" }],
  ['path', { d: "M12 12C10.6196 15.253 10.7146 16.9808 12 20", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "3" }],
] as const;

export const FunctionOfXIcon = /* @__PURE__ */ createTerraIcon({
  icon: FunctionOfXIconData,
  displayName: 'FunctionOfXIcon',
});

const FunctionSquareIconData = [
  ['path', { d: "M8 15.8889C8.15093 16.4202 8.45526 17 9.24988 17C10.6249 17 10.9687 15.8889 12 12C13.0313 8.11111 13.3751 7 14.7501 7C15.5447 7 15.8491 7.57977 16 8.11111M10.3333 10.6111H14.7501", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M2.5 19.5C2.5 20.6046 3.39543 21.5 4.5 21.5H19.5C20.6046 21.5 21.5 20.6046 21.5 19.5V4.50043C21.5 3.39589 20.6046 2.50046 19.5001 2.50043L4.50005 2.50005C3.39546 2.50002 2.5 3.39546 2.5 4.50005V19.5Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round", key: "1" }],
] as const;

export const FunctionSquareIcon = /* @__PURE__ */ createTerraIcon({
  icon: FunctionSquareIconData,
  displayName: 'FunctionSquareIcon',
});

const FunctionIconData = [
  ['path', { d: "M5 19C5.26413 19.9564 5.79671 21 7.18729 21C9.59365 21 10.1952 19 12 12C13.8048 5 14.4064 3 16.8127 3C18.2033 3 18.7359 4.04358 19 5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "0" }],
  ['path', { d: "M9 10H17", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", key: "1" }],
] as const;

export const FunctionIcon = /* @__PURE__ */ createTerraIcon({
  icon: FunctionIconData,
  displayName: 'FunctionIcon',
});
